// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAALTUlEQVR4Xu2be1xU1RbHf2dmeAnyGEYclKcgCF5AQTRQfKBlvupyZYAZRPGR3JtmmuKrUqR8kPkIIQUpLRhmgNKsfGSQpQIiJSCpHxUDFQR5OAMIzABnzv2cuWGSpMw0w6Pu/nzmM3+c/Vjru9faZ++19iHQi2XfvoQRBKFwYejo2gKUBGRrAYfDuRIUFET2lFhETw30+Dix+5NGmxkN2GtmZm4z0NiQyzZn6z9sbERVVXVTvVTSwtDV/WS+IGRNT8jW4wBEovTFbLbpFjd396GW3MF4+LBJ+dPRYcHY2Fj5X3S5WHG5uLi8hUF4RQgEtdoE0aMAjhz58mWDAfopL05/3kgileL69RugKAqmpqZoaWlBQ0MjzNlsuLmNROPDhzh+/HRFQ33tyIiIiHptQdA6gLi4RCcSGKnDgJUF1yJqbsDLbIlEgus3SjDKww36+vqddKutrUNBYRH8p0zCgwcSfJN15nIYP8ij3wFIThYlyFpbg8xMjVmWlpYsJoOJcePG6NfU1OB+dQ3+MdJVOftlZWWQSuthb2+ntAS6tLa1ISf3AiZP9ENBQZHsUlHR6iULF3yoDQgatwChMN1L1ibPnDplkqmV1VDQA9Q3NILFZGDgwIE4n50LL8/RaG5uwt4PYlFRUQl9fT00NjZizpzZ4AXOBUEQqKyqQmPjQ6VLnDx5+nJYGF8rVqBRAML0dC8j/QHfzJwx3VyhUODateuorasD28wM8tZW0KbvMGwY7O1tsXHjWxgwwAC+vr4YPtwRWd+dwc8/F2PatOcxZ/Ys5Zrw06VCTBjvg4MfHW5aumShUZ+3gI8PfdqwYH7oQLlcjgt5+fDyHKVc2R8vNJgLF/KQlp6GIF4Qxo/3ffR41+49uHr1KhITDoDJZOJcdi58xnnj5KlT1b/cvfv8yldfvaxpCBqzAKFQKBw/wU8w2GIQcvMuYsqkiUofLygsRHZ2Dmgoo0ePwuRJk/D5kaMoLCzCxg3rYGT028QWFBTgvZ27sC/2A3A45sjMOoOp/pOR8fkRyf3KOu8VKyJu9UkAhw4d0icp4v7ihQuMf7xUABdnJxgaGiIlRYjz2TngWnLBJAjU1j3AoEEc2NnZobCoCFGb3u4EID//R+zesxexH+yBgYEBin++Cu8xnjj8qUj6yuL5ZppWnu5PIxYQu3//2GG2w76f5j/JIO/ij5joNx6FhYU4cCARfn5+mDnzRSWQbzOzcPbsWdy5cxdDrYY+FUBD40PosJjQ1zfA6dNZ58PC+H59FsCHCQeXjh3jlWBjY4179yrh4e6G+A/3o6a6BitWvAY2+7fJ2xHzHoqKLj8VwJtvbkBzswxjvb2QmZnVWFp6O3jp0sUn+zSAMZ6eCXZ2NqiouIdRHu7YvuM9kCSJt97c0EnutPR0fPHFl08F8MqSJfD3n4ybN0uoSwUFx0KCgwK0obzGXCA+PtHb1s76h2lT/Q3yLuYrXWBHTAxkMjmiNm/qJHtqqghffX38mS5Anw/yLv5UwA8J9NSW8hoDEBsbq2c00OT+wvD5JpcKCuHkNBxxcXFqA+DxAptb29rP8IN5s7WpvMYA0B2lpIiSx0/wncflDkZubh7y8nLVBuDuMWrpxvWRB7WtvEYB0J0lfXy4Pnz+PGN6L79pUxQMDQeo5QKgSHuxWFzW7wAki8UehnqGmbNmvsChd3X05kedNaDfAqBnLDlZ7NHa3pZVVlpizmAw/n4AOsx2yZKI20Othtj87SygAwAvWHDK1cV5+v8BqLEP6NdrgKYtICoqihEVFaXQ1htBI4ehroT7sy5AEMwJFKi3AcKJgOI6RTGixWJhqqZB9EkACoLYwzYxWTXEkgtvb2/k5+ej4l4VpA31r6WlpsRpEkKfBEDHBH2eG4fly5cp44N0YCU2dh8dSZIxGBiSmpoq0RSEPgnAjM3G8mX/gauLyyM9r1y5ivj4eEilDTNEopRTf2kA5uZsRK5ZDVtb20d6lpaWYef7uyCVSANEopQv/tYApNK6kyZmZvMoUuFDEIx7gOJjdc8OfdIFnmYBEumDJQBeHTyY62lqbIo2sg2lv5TKKAUCxeKU46paRv8DIJHKHR2G6U2bNhW+vj64ffsOTpw4QWeSmhgE5SASie6rAqEfApBg1qyZmBcqeKTn1avXcOiTT3C3vELl12S/BLA2MhKjR/+WKWuRybBlSzRtDdvFIuHGv7wFrFr1OsZ6ez/Ss6mpCZu3RONeecVWkUj4Vr8AQIfO3one0mVi5KmLoESCfg2gpKQEMTE74TdxAuaHhXWaLDpvuGzZcrA5HLwbvUW5C+woHfsAOsHaJwAIBIJRJEn8myDIERQYVQSIoyTZ+llGRobygtMfHYboZ7W1teBwOF1aant7O1gs1hPPysvL8e62HaiXSrFh/Tq4u7v1nguEhIQGMllMsbW1FXPwYC5ksmZUVlah+n7VBZIkX8rIyKh5GgBVfPTxuvsPJCgzT+9ER3XqokfXgNDQUON2krrj89w4k0WLFiovPdAlk877nT+Hm9dLLpJkqy8YOse7igipq3xHO7m8FXp6ur0HIFgg4HEtuOlvrHodNjY2nQTJyvoOn31+BFKJJIqk4KMNAF0B7FEL4PND11rb2sRsXL8OJiYmT8gjFIrw9fHjClCKZucRI4x+HxP8sxbQ6wBCBILFllzLpLWRa8DlcrvUZ9PmKDqxCWdnpyfC4v0eAI83f6iOLlUWODeAFRDQddK2uroa27bvUN76+stZAD2DwfzQGA7bfO3KlSvg6OjQ5aSeOfM9Tp0+jZjt27Qx6b23CNIjh4eH68vl8kI7O3vnbdu2/qGCMpkMenp6nTY02qDRo4tghwJ8Pt+HwdLNfvml2QQvMFAbenW7z14BQEsXJJi324LNXvXGGythb2/fbYE1XbHXAMyZs3SAoWHj5WGOjg5b34nWtF7d7q/XANAShoTM82PpMH4ICAgg/hXwz24LrcmKvQrg17dC7KBB5q9Frl79xO5Qk4r+UV/0faJt27aj9HbZu+JU4duqjKmRiBCPxzNiMnWKhzsNt4ve0vmgooow6tatqqrCrt17UV5xd704NTVGlX40AoAekM8P82fpMLMCA+fipTlav9vUScebJSWI3RePuppagUiUIuoVAEpXCA49YMG1iFi7ZjXoq/I9VYqLi7Hz/d1QkG3uQqGwWJVxNWYB9KD0UbmNJK6MdHG22rRJpdCcKjI/UTcufj/OnT0rcXUdwVE1la5RALRkAoFgOktH71RQEA+zZs74U4p1p3F5RQUOJibhxo2Sj8TiFDppolLROADlq5HP/8iSO2QRHbuztrZWSSBVKx879iWOHj0GubztObE4OU/V9loBwOPxTJgs3UJHR0e79esilTfFtVHofMDWrVtx89Yv36aLUl9QZwytAFBaQUjIaFKBc+5uboZr166Brm7nMJY6wv6+Db3y5+TkyEAxPdPSkq+p06fWANDCBAkEU6h2xVfOzs6G4QvC4ODQ9dFZHcETk5KQm52Dlta2BWmpKZ+q0wfdRqsAfl0UvRTAEWsrG5tpU/0xdqz3o8/j1BH6XmUlEhOTcOvWLaq9rW2lWJwaq04/HW20DoAeKDw83LSlpXWnrq7OYmtrK8LR0RFjxoyBq6uL8uOoZ5Xm5mbcuHED2dm5uFlykw7B1xAsxqI0ofDrZ7V91vMeAdAhRGhoqBtJIZKgEMzmcHTZpqbKb4Po74jMzc1hamYGtpmp8nvB+vp61NTW4cGDB6iuvg+ppB4SSV0DwWQdMNDT2X748GHps5TrzvMeBfAYCGOSxAyA8KcoaiwIxXCCYChfFQwmAwryf9cCFQpKRimoW0wm8wLFUJzQZTK/SU5ObuqOYt2t818u+GKbNIce8QAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --fpd-primary-color: #485563;
  --fpd-primary-fg-color: #fff;
  --fpd-secondary-color: #029EEB;
  --fpd-secondary-fg-color: #fff;
  --fpd-light-bg-color: #F6F6F6;
  --fpd-light-grey-color: #EBEBEB;
  --fpd-dark-grey-color: #989898;
  --fpd-red-color: #bd081c;
  --fpd-yellow-color: #fffaf3;
  --fpd-yellow-contrast-color: #654c21;
  --fpd-green-color: #2ecc71;
  --fpd-scrollbar-track-color: var(--fpd-light-bg-color);
  --fpd-scrollbar-thumb-color: var(--fpd-dark-grey-color);
  --fpd-scrollbar-width: 6px;
  --fpd-btn-primary-color: var(--fpd-secondary-color);
  --fpd-btn-primary-text-color: var(--fpd-secondary-fg-color);
  --fpd-dropdown-height: 40px;
  --fpd-snackbar-bg-color: rgba(0, 0, 0, 0.9);
  --fpd-list-bg-color-active: rgba(0, 0, 0, 0.04);
  --fpd-input-text-color: rgba(0, 0, 0, 0.7);
  --fpd-tooltip-bg-color: rgba(0, 0, 0, 0.9);
  --fpd-track-height: 8px;
  --fpd-text-color: var(--fpd-primary-color);
  --fpd-border-color: var(--fpd-light-grey-color);
  --fpd-container-min-height: 500px;
  --fpd-border-radius: 6px;
  --fpd-mainbar-nav-color: var(--fpd-primary-color);
  --fpd-sidebar-width: 400px;
  --fpd-sidebar-nav-width: 80px;
  --fpd-topbar-nav-height: 70px;
  --fpd-off-canvas-width: 350px;
  --fpd-actions-bar-bg-color: var(--fpd-primary-color);
  --fpd-actions-bar-height: 50px;
  --fpd-loading-svg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --fpd-canvas-bg: var(--fpd-light-bg-color);
  --fpd-et-max-width: 375px;
  --fpd-module-content-padding: 10px;
  --fpd-module-secondary-color: var(--fpd-light-bg-color);
  --fpd-module-secondary-text-color: var(--fpd-text-color);
  --fpd-image-quality-start-color: #FFE790
}

.fpd-container *,
.fpd-container:after,
.fpd-container:before {
  margin: 0;
  padding: 0;
  list-style: none;
  max-width: 100%;
  list-style-type: none;
  text-shadow: none;
  outline: 0;
  line-height: 20px;
  border: none;
  box-sizing: border-box
}

.fpd-container input {
  -webkit-appearance: none;
  appearance: none;
  height: auto;
  background: 0 0 !important;
  outline: 0 !important
}

.fpd-container textarea {
  background: 0 0;
  outline: 0 !important
}

.fpd-container input::-webkit-inner-spin-button,
.fpd-container input::-webkit-outer-spin-button {
  appearance: none
}

.fpd-wrapper {
  display: flex;
  flex-flow: row wrap;
  max-width: 100%;
  position: relative;
  color: var(--fpd-text-color)
}

.fpd-container.fpd-not-responsive,
.fpd-container.fpd-not-responsive * {
  max-width: none !important
}

.fpd-container.fpd-not-responsive * .fpd-product-stage,
.fpd-container.fpd-not-responsive .fpd-product-stage {
  overflow: auto
}

.fpd-container .fpd-scroll-area {
  height: 100%;
  overflow: auto;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: var(--fpd-scrollbar-width);
  scrollbar-color: var(--fpd-scrollbar-thumb-color) var(--fpd-scrollbar-track-color)
}

.fpd-container .fpd-scroll-area::-webkit-scrollbar {
  width: var(--fpd-scrollbar-width);
  height: var(--fpd-scrollbar-width);
  padding-right: 5px;
  margin-right: 5px
}

.fpd-container .fpd-scroll-area::-webkit-scrollbar-track {
  background-color: var(--fpd-scrollbar-track-color);
  -webkit-border-radius: 10px;
  border-radius: 10px;
  margin: 20px
}

.fpd-container .fpd-scroll-area::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: var(--fpd-scrollbar-thumb-color)
}

.fpd-scrollbar-hidden {
  overscroll-behavior: none;
  -ms-overflow-style: none;
  scrollbar-width: none
}

.fpd-scrollbar-hidden::-webkit-scrollbar {
  display: none
}

textarea[data-fabric-hiddentextarea] {
  font-size: 16px !important;
  transform: translateY(-20px);
  caret-color: transparent
}

.fpd-disabled {
  opacity: .2 !important;
  cursor: default !important;
  pointer-events: none !important
}

body .fpd-hidden {
  display: none !important;
  pointer-events: none !important
}

.fpd-overflow-hidden {
  overflow: hidden !important
}

.fpd-hidden-canvas {
  position: absolute !important;
  left: -9999999px
}

[class^=fpd-icon-]:before {
  color: inherit !important
}

body .fpd-visible-hidden {
  visibility: hidden !important;
  pointer-events: none !important
}

body fpd-dropdown {
  position: relative;
  display: flex;
  height: var(--fpd-dropdown-height)
}

body fpd-dropdown>.fpd-dropdown-current {
  height: 100%;
  width: 100% !important;
  padding: 7px 20px 7px 7px !important;
  margin: 0 !important
}

body fpd-dropdown>.fpd-dropdown-arrow {
  position: absolute;
  font-size: 20px;
  right: 2px;
  top: calc(50% - 10px);
  opacity: .6;
  text-align: center;
  width: 20px;
  height: 20px;
  transform-origin: center center;
  transition: all .2s ease-out;
  cursor: pointer
}

body fpd-dropdown .fpd-dropdown-list {
  display: none;
  position: fixed;
  padding-right: 5px;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 100;
  box-shadow: 0 2px 0 1px rgba(64, 87, 109, .07), 0 2px 12px rgba(53, 71, 90, .2);
  transform: translateY(2px);
  border-radius: 4px;
  max-height: 200px
}

body fpd-dropdown .fpd-dropdown-list>.fpd-scroll-area {
  max-height: inherit;
  padding: 0 !important
}

body fpd-dropdown .fpd-dropdown-list .fpd-item {
  display: block;
  text-align: left;
  margin: 5px;
  padding: 10px;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px
}

body fpd-dropdown .fpd-dropdown-list .fpd-item:hover {
  background: rgba(0, 0, 0, .05)
}

body fpd-dropdown input:focus~.fpd-dropdown-list,
body fpd-dropdown.fpd-active .fpd-dropdown-list {
  display: block;
  border: 1px solid var(--fpd-border-color)
}

body fpd-dropdown input:focus~.fpd-dropdown-arrow,
body fpd-dropdown.fpd-active>.fpd-dropdown-arrow {
  transform: rotate(90deg)
}

body fpd-dropdown.fpd-on-loading .fpd-dropdown-arrow {
  display: none !important
}

body fpd-dropdown.fpd-on-loading>input.fpd-dropdown-current {
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: 98% center;
  background-image: var(--fpd-loading-svg)
}

.fpd-container .fpd-loader-wrapper {
  background: rgba(255, 255, 255, .9);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100
}

.fpd-loader-wrapper>.fpd-loader {
  position: absolute;
  text-align: center;
  width: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%)
}

.fpd-loader>.fpd-loader-text {
  position: absolute;
  width: 100%;
  display: block;
  font-size: 14px;
  padding: 20px 0;
  color: rgba(0, 0, 0, .5);
  text-transform: uppercase;
  font-weight: lighter;
  letter-spacing: 1.5px;
  -webkit-filter: blur(0)
}

.fpd-loader>.fpd-loader-circle {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, .2);
  border-left: 3px solid #000;
  transform: translateZ(0);
  animation: fpd-loader-animation 1.1s infinite linear
}

.fpd-loader>.fpd-loader-circle,
.fpd-loader>.fpd-loader-circle:after {
  border-radius: 50%
}

@-webkit-keyframes fpd-loader-animation {
  0% {
    transform: rotate(0)
  }

  100% {
    transform: rotate(360deg)
  }
}

@keyframes fpd-loader-animation {
  0% {
    transform: rotate(0)
  }

  100% {
    transform: rotate(360deg)
  }
}

.fpd-container .fpd-btn,
.fpd-modal-inner .fpd-btn {
  background: var(--fpd-btn-primary-color);
  color: var(--fpd-btn-primary-text-color);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 5px 15px;
  font-size: 14px;
  margin: 10px 0;
  text-transform: uppercase;
  border-radius: var(--fpd-border-radius);
  transition: all .2s ease-out
}

.fpd-container .fpd-btn:hover,
.fpd-modal-inner .fpd-btn:hover {
  opacity: .8
}

.fpd-container .fpd-btn.fpd-loading,
.fpd-modal-inner .fpd-btn.fpd-loading {
  background-image: var(--fpd-loading-svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30%;
  opacity: .8;
  color: transparent;
  cursor: wait
}

.fpd-container .fpd-btn.fpd-secondary,
.fpd-modal-inner .fpd-btn.fpd-secondary {
  background: var(--fpd-light-grey-color);
  color: var(--fpd-dark-grey-color)
}

.fpd-container .fpd-btn.fpd-full,
.fpd-modal-inner .fpd-btn.fpd-full {
  width: 100%;
  justify-content: center
}

body .fpd-container input,
body .fpd-container textarea {
  color: var(--fpd-input-text-color);
  box-shadow: 0 0 4px rgba(110, 111, 114, .22);
  border: none;
  border-radius: var(--fpd-border-radius);
  padding: 10px;
  margin-bottom: 10px;
  appearance: none;
  -moz-appearance: textfield;
  resize: none;
  font-size: 16px;
  border: 1px solid transparent
}

body .fpd-container input[type=text],
body .fpd-container textarea[type=text] {
  width: 100%
}

body .fpd-container input:focus,
body .fpd-container textarea:focus {
  box-shadow: 0 0 4px rgba(110, 111, 114, .22);
  border: 1px solid var(--fpd-secondary-color)
}

body .fpd-container textarea {
  width: 100%;
  min-height: 100px
}

body .fpd-container select {
  box-shadow: 0 0 4px rgba(110, 111, 114, .22);
  border-radius: var(--fpd-border-radius);
  border: 1px solid transparent
}

body .fpd-container select:focus {
  box-shadow: 0 0 4px rgba(110, 111, 114, .22);
  border: 1px solid var(--fpd-secondary-color)
}

body .fpd-container .fpd-input-back-search,
body .fpd-container .fpd-input-search {
  display: flex;
  box-shadow: 0 0 4px rgba(110, 111, 114, .22);
  height: 40px;
  border-radius: 4px;
  flex: 1
}

body .fpd-container .fpd-input-back-search input,
body .fpd-container .fpd-input-search input {
  flex: 1;
  box-shadow: none !important;
  margin: 0;
  padding: 0 5px;
  line-height: 1;
  border: none !important
}

body .fpd-container .fpd-input-back-search span,
body .fpd-container .fpd-input-search span {
  width: 20px;
  align-self: center;
  text-align: center;
  font-size: 16px;
  margin-right: 5px
}

body .fpd-container .fpd-input-back-search .fpd-input-search {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  box-shadow: none !important
}

body .fpd-container .fpd-input-back-search .fpd-back {
  color: var(--fpd-module-secondary-text-color);
  border: none !important;
  background: rgba(0, 0, 0, .03) !important;
  line-height: 1;
  padding: 9px 8px !important;
  display: inline-block;
  width: 32px;
  height: 100%;
  text-align: center;
  margin: 0 !important;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0
}

body .fpd-container .fpd-input {
  display: flex;
  width: 100%;
  align-items: center;
  box-shadow: 0 0 4px rgba(110, 111, 114, .22);
  overflow: hidden;
  border-radius: var(--fpd-border-radius);
  border: 1px solid transparent;
  height: auto
}

body .fpd-container .fpd-input [class^=fpd-icon-],
body .fpd-container .fpd-input span {
  padding: 2px 6px;
  flex: 0 30px;
  margin-right: 5px;
  text-align: center;
  border-right: 1px solid var(--fpd-border-color)
}

body .fpd-container .fpd-input span {
  flex: 0 auto;
  text-align: left;
  white-space: nowrap
}

body .fpd-container .fpd-input input {
  box-shadow: none;
  margin: 0;
  padding: 5px;
  flex: 1;
  width: 100%;
  border-radius: 0;
  border: none !important
}

body .fpd-container .fpd-input fpd-range-slider {
  flex-basis: 100%
}

body .fpd-container .fpd-input .fpd-slider-number {
  flex: 0 70px;
  text-align: center;
  border: 1px solid var(--fpd-border-color) !important;
  border-radius: var(--fpd-border-radius);
  margin: 3px 3px 3px 5px
}

body .fpd-container .fpd-input .fpd-slider-number:focus {
  border-color: var(--fpd-secondary-color) !important
}

.fpd-container .fpd-module-tabs {
  display: flex;
  background: var(--fpd-module-secondary-color);
  color: var(--fpd-module-secondary-text-color)
}

.fpd-container .fpd-module-tabs>div {
  flex: 1;
  text-align: center;
  cursor: pointer;
  padding: 8px 0;
  font-size: 20px
}

.fpd-container .fpd-module-tabs>div:hover {
  background: rgba(0, 0, 0, .03)
}

.fpd-container .fpd-module-tabs>div.fpd-active {
  background: var(--fpd-primary-fg-color);
  color: var(--fpd-secondary-color)
}

.fpd-container .fpd-module-tabs>div>span {
  pointer-events: none
}

.fpd-container .fpd-module-tabs-content {
  height: 100%
}

.fpd-container .fpd-module-tabs-content>div {
  display: none;
  height: 100%
}

.fpd-container .fpd-module-tabs-content>div.fpd-active {
  display: block
}

.fpd-sidebar .fpd-module-tabs {
  top: 50px
}

.fpd-hide-tabs .fpd-module-tabs {
  display: none !important
}

.fpd-snackbar-wrapper {
  position: fixed;
  left: 12px;
  bottom: 0;
  z-index: 100000
}

.fpd-snackbar-wrapper .fpd-snackbar {
  background: var(--fpd-snackbar-bg-color);
  margin-bottom: 10px;
  color: #fff;
  line-height: 18px;
  font-size: 14px;
  min-width: 288px;
  max-width: 568px;
  overflow-y: hidden;
  border-radius: 2px;
  -webkit-transition: all .3s ease-out;
  transition: all .3s ease-out
}

.fpd-snackbar-wrapper .fpd-snackbar p {
  margin: 0;
  padding: 16px 24px
}

.fpd-snackbar-wrapper .fpd-snackbar.fpd-show-up {
  max-height: 300px
}

.fpd-modal-overlay {
  position: absolute !important;
  width: 100% !important;
  bottom: 0 !important;
  right: 0 !important;
  top: 0 !important;
  left: 0 !important;
  background: rgba(0, 0, 0, .5);
  z-index: 10000;
  overflow: auto
}

.fpd-modal-overlay>.fpd-modal-inner {
  display: flex;
  align-items: center;
  background: #fff;
  width: 450px;
  min-height: 200px;
  position: absolute;
  left: 50%;
  top: 30%;
  padding: 40px;
  z-index: 10020;
  max-width: 100%;
  transform: translateX(-50%);
  box-sizing: border-box;
  border-radius: var(--fpd-border-radius)
}

.fpd-modal-overlay>.fpd-modal-inner>.fpd-modal-close {
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 16px;
  cursor: pointer;
  opacity: .6;
  transition: opacity .2s ease-out
}

.fpd-modal-overlay>.fpd-modal-inner>.fpd-modal-close:hover {
  opacity: 1
}

.fpd-modal-overlay>.fpd-modal-inner>.fpd-modal-content {
  flex: 1 100%;
  text-align: center;
  color: rgba(0, 0, 0, .7);
  line-height: 22px;
  word-break: break-word
}

.fpd-modal-overlay.fpd-fullscreen>.fpd-modal-inner {
  width: 100%;
  height: 100%;
  top: 0;
  overflow: auto;
  border-radius: 0
}

.fpd-modal-overlay.fpd-modal-internal {
  z-index: 10000000000
}

.fpd-modal-overlay.fpd-modal-product-designer,
.fpd-overflow-hidden .fpd-modal-overlay {
  position: fixed !important
}

.fpd-modal-internal[data-type=prompt] input {
  width: 100%;
  display: block
}

.fpd-modal-internal[data-type=prompt] {
  text-align: center
}

.fpd-modal-internal[data-type=confirm] {
  text-align: center
}

.fpd-modal-internal .fpd-confirm-msg {
  margin-bottom: 10px
}

.fpd-modal-product-designer {
  display: none;
  pointer-events: none;
  overflow: hidden !important
}

.fpd-modal-product-designer.fpd-show {
  display: block;
  pointer-events: all
}

.fpd-modal-product-designer>.fpd-modal-inner {
  padding: 0
}

.fpd-modal-product-designer>.fpd-modal-inner>.fpd-wrapper {
  flex: 1 100%;
  margin: 0 0 !important;
  height: 100%;
  box-shadow: none !important
}

.fpd-modal-product-designer>.fpd-modal-inner>.fpd-wrapper fpd-main-bar {
  height: calc(100% - var(--fpd-actions-bar-height)) !important
}

.fpd-modal-product-designer>.fpd-modal-inner>.fpd-wrapper.fpd-layout-small fpd-main-wrapper {
  height: calc(100% - var(--fpd-actions-bar-height) - var(--fpd-sidebar-nav-width)) !important
}

body.fpd-modal-mode-active:not(.fpd-modal-designer-visible) fpd-element-toolbar {
  display: none !important
}

.fpd-container .fpd-modal-content fpd-module-save-load {
  padding: 0
}

.fpd-container .fpd-modal-content fpd-module-save-load .fpd-saved-designs {
  max-height: 200px
}

.fpd-list {
  width: 100%;
  overflow: auto
}

.fpd-list>.fpd-list-row {
  display: flex;
  font-size: 15px;
  overflow: hidden;
  cursor: pointer;
  transition: background .3s ease-out
}

.fpd-list>.fpd-list-row>.fpd-cell-full {
  flex: 1 100%
}

.fpd-list>.fpd-list-row>div {
  padding: 22px 0;
  flex: 1
}

.fpd-list .fpd-sortable-placeholder {
  background: rgba(0, 0, 0, .05);
  border: 2px dotted var(--fpd-border-color);
  height: 65px
}

.fpd-container fpd-range-slider {
  display: block;
  margin-top: 3px
}

.fpd-container fpd-range-slider input[type=range] {
  margin: 0;
  padding: 0;
  box-shadow: none;
  width: 100%
}

.fpd-container fpd-range-slider input[type=range]:focus {
  outline: 0
}

.fpd-container fpd-range-slider input[type=range]::-webkit-slider-runnable-track {
  height: var(--fpd-track-height);
  border: 1px solid var(--fpd-border-color);
  border-radius: 4px;
  background: var(--fpd-light-bg-color)
}

.fpd-container fpd-range-slider input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 1em;
  background: #fff;
  border: 2px solid var(--fpd-secondary-color);
  margin-top: calc((var(--fpd-track-height) * .5 - 1px) - (20px * .5));
  cursor: pointer
}

.fpd-container fpd-range-slider input[type=range]::-webkit-slider-thumb:hover {
  scale: 1.2
}

.fpd-container fpd-range-slider.fpd-progress input[type=range] {
  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--value) - var(--min)) / var(--range));
  --sx: calc(0.5 * 20px + var(--ratio) * (100% - 20px))
}

.fpd-container fpd-range-slider.fpd-progress input[type=range]::-webkit-slider-runnable-track {
  background: linear-gradient(var(--fpd-secondary-color), var(--fpd-secondary-color)) 0/var(--sx) 100% no-repeat, var(--fpd-light-bg-color)
}

.fpd-container fpd-range-slider input[type=range]::-moz-range-track {
  height: var(--fpd-track-height);
  border: 1px solid var(--fpd-border-color);
  border-radius: 4px;
  background: var(--fpd-light-bg-color)
}

.fpd-container fpd-range-slider input[type=range]::-moz-range-thumb {
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 1em;
  background: #fff;
  border: 2px solid var(--fpd-secondary-color);
  margin-top: calc((var(--fpd-track-height) * .5 - 1px) - (20px * .5));
  cursor: pointer
}

.fpd-container fpd-range-slider input[type=range]::-moz-range-thumb:hover {
  scale: 1.2
}

.fpd-container fpd-range-slider.fpd-progress input[type=range]::-moz-range-track {
  background: linear-gradient(var(--fpd-secondary-color), var(--fpd-secondary-color)) 0/var(--sx) 100% no-repeat, var(--fpd-light-bg-color)
}

.fpd-container .fpd-color-panel>.fpd-scroll-area {
  height: auto;
  max-height: 100px;
  margin-bottom: 10px
}

.fpd-container .fpd-color-panel>* {
  margin-bottom: 10px
}

.fpd-container .fpd-color-panel>:last-child {
  margin-bottom: 0
}

.fpd-container .picker_wrapper {
  width: 100%;
  box-shadow: none;
  background: 0 0;
  padding: 0
}

.fpd-container .picker_wrapper.popup {
  width: 200px;
  max-width: 200px;
  padding: 10px;
  display: flex;
  min-height: 200px;
  background: #f6f6f6;
  margin: 0;
  transform: translate(-50%, 10px);
  border-radius: var(--fpd-border-radius);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12)
}

.fpd-container .picker_wrapper>* {
  margin: 0 0 10px
}

.fpd-container .picker_wrapper .picker_sample,
.fpd-container .picker_wrapper .picker_sl,
.fpd-container .picker_wrapper .picker_slider {
  box-shadow: none
}

.fpd-container .picker_wrapper .picker_selector {
  border: 2px solid rgba(0, 0, 0, .4);
  background: rgba(255, 255, 255, .5);
  border-radius: 50%;
  box-shadow: none;
  width: 15px;
  height: 15px;
  padding: 0
}

.fpd-container .picker_wrapper .picker_sl {
  margin-top: 0;
  height: 100%;
  border-radius: var(--fpd-border-radius)
}

.fpd-container .picker_wrapper .picker_sl:before {
  height: 100px;
  padding: 0;
  border: 1px solid var(--fpd-border-color);
  border-radius: var(--fpd-border-radius)
}

.fpd-container .picker_wrapper .picker_sl .picker_selector {
  transform-origin: center
}

.fpd-container .picker_wrapper .picker_hue {
  order: 1;
  height: 15px;
  padding: 0;
  border: 1px solid var(--fpd-border-color);
  border-radius: var(--fpd-border-radius)
}

.fpd-container .picker_wrapper .picker_hue .picker_selector {
  transform: translate(-50%, 0);
  top: -1px
}

.fpd-container .picker_wrapper .picker_editor {
  width: auto;
  flex: 0 80%;
  max-width: 100px;
  margin-bottom: 0
}

.fpd-container .picker_wrapper .picker_editor input {
  font-size: 16px;
  height: 28px;
  box-shadow: none !important;
  border: 1px solid var(--fpd-border-color);
  margin-bottom: 0
}

.fpd-container .picker_wrapper .picker_sample {
  height: 28px;
  cursor: pointer;
  text-align: center;
  flex: 0 30px;
  margin-bottom: 0
}

.fpd-container .picker_wrapper .picker_sample:before {
  border-radius: var(--fpd-border-radius);
  border: 1px solid var(--fpd-border-color)
}

.fpd-container .picker_wrapper .picker_sample span {
  position: relative;
  display: inline-block;
  margin-top: 3px;
  font-size: 16px;
  color: #fff;
  text-shadow: 0 0 #000
}

.fpd-container .picker_wrapper .picker_arrow,
.fpd-container .picker_wrapper .picker_done {
  display: none
}

.fpd-container .fpd-colorpicker-wrapper {
  position: relative;
  padding: 0 10px;
  width: 100%
}

.fpd-container .fpd-colorpicker-wrapper .fpd-scroll-area {
  max-height: 100px;
  overflow-x: hidden;
  margin-top: 10px
}

.fpd-container .fpd-color-palette,
.fpd-container .fpd-patterns-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 6px
}

.fpd-container .fpd-color-palette .fpd-item,
.fpd-container .fpd-patterns-wrapper .fpd-item {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(0, 0, 0, .1);
  border-radius: var(--fpd-border-radius);
  transition: all .2s ease;
  background-repeat: repeat;
  cursor: pointer
}

.fpd-container .fpd-color-palette .fpd-item:hover,
.fpd-container .fpd-patterns-wrapper .fpd-item:hover {
  border-color: rgba(0, 0, 0, .2)
}

.fpd-container .fpd-color-palette.fpd-sub-show>.fpd-item,
.fpd-container .fpd-patterns-wrapper.fpd-sub-show>.fpd-item {
  scale: .7
}

.fpd-container .fpd-color-palette.fpd-sub-show>.fpd-item.fpd-active,
.fpd-container .fpd-patterns-wrapper.fpd-sub-show>.fpd-item.fpd-active {
  scale: 1
}

.fpd-container .fpd-has-subpanel>.fpd-color-palette>.fpd-scroll-area {
  margin-top: 5px;
  flex: 1 1 100%
}

.fpd-main-tooltip {
  position: fixed;
  background: var(--fpd-tooltip-bg-color);
  color: #fff;
  padding: 5px;
  font-size: 14px;
  min-width: 30px;
  top: 0;
  left: 0;
  border-radius: var(--fpd-border-radius);
  pointer-events: none;
  transform: scale(0);
  opacity: 0;
  z-index: 10000000000;
  visibility: hidden;
  transition: transform .1s ease
}

.fpd-main-tooltip.fpd-show {
  visibility: visible;
  opacity: 1;
  transform: scale(1)
}

.fpd-thumbnail-preview {
  width: 350px;
  height: 250px;
  padding: 10px;
  border-width: 1px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999999999999;
  border-radius: var(--fpd-border-radius)
}

.fpd-thumbnail-preview.fpd-title-enabled {
  padding-bottom: 30px
}

.fpd-thumbnail-preview>picture {
  display: block;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center
}

.fpd-thumbnail-preview>.fpd-preview-title {
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 100%;
  font-size: 14px;
  text-align: center;
  margin-top: 30px
}

.fpd-thumbnail-preview>.fpd-price {
  background: rgba(0, 0, 0, .7);
  position: absolute;
  right: 20px;
  top: 15px;
  padding: 2px 5px 2px 7px;
  font-size: 12px;
  color: #fff;
  border-radius: var(--fpd-border-radius)
}

.fpd-thumbnail-preview>.fpd-image-quality-ratings {
  background: rgba(0, 0, 0, .7);
  position: absolute;
  left: 20px;
  top: 15px;
  border-radius: 4px;
  padding: 2px 5px;
  color: #fff;
  text-align: left
}

.fpd-thumbnail-preview>.fpd-image-quality-ratings>span {
  font-size: 18px;
  color: var(--fpd-image-quality-start-color)
}

.fpd-thumbnail-preview>.fpd-image-quality-ratings>.fpd-image-quality-rating-label {
  color: #fff;
  display: block;
  padding-top: 2px;
  font-size: 10px;
  text-transform: uppercase
}

.fpd-editor-box-wrapper {
  margin: 20px 0;
  background: rgba(0, 0, 0, .05);
  padding: 10px
}

.fpd-editor-box-wrapper .fpd-eb-title {
  font-size: 16px;
  margin-bottom: 10px
}

.fpd-editor-box-wrapper .fpd-eb-grid {
  display: flex;
  flex-flow: row wrap
}

.fpd-editor-box-wrapper .fpd-eb-grid>div {
  flex: 1 0 50%;
  padding: 0 10px 0 0
}

.fpd-editor-box-wrapper .fpd-eb-grid>div span {
  text-transform: uppercase
}

.fpd-dragged-image {
  position: absolute;
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  width: 200px;
  height: 200px;
  top: 0;
  left: 0;
  cursor: move;
  transition: transform .1s ease-in-out;
  transform-origin: center center;
  transform: scale(0);
  z-index: 100000000000;
  pointer-events: none
}

.fpd-dragged-image.fpd-animate {
  transform: scale(1)
}

.fpd-container input.fpd-switch {
  appearance: none;
  background-color: var(--fpd-light-grey-color) !important;
  border-radius: 70px;
  border-style: none;
  height: 20px;
  margin: 0;
  position: relative;
  width: 35px;
  box-shadow: none;
  cursor: pointer
}

.fpd-container input.fpd-switch:before {
  bottom: -6px;
  content: "";
  left: -6px;
  position: absolute;
  right: -6px;
  top: -6px
}

.fpd-container input.fpd-switch:after {
  background-color: #fff;
  border-radius: 50%;
  content: "";
  height: 14px;
  left: 3px;
  position: absolute;
  top: 3px;
  width: 14px;
  transition: all .1s ease-out
}

.fpd-container input.fpd-switch:hover {
  opacity: .9;
  transition-duration: 0s
}

.fpd-container input.fpd-switch:checked {
  background-color: var(--fpd-secondary-color) !important
}

.fpd-container input.fpd-switch:checked:after {
  background-color: #fff;
  left: 18px
}

.fpd-container .fpd-switch-wrapper {
  display: flex;
  justify-content: center
}

.fpd-container .fpd-switch-wrapper label {
  margin-left: 10px
}

.fpd-container .fpd-grid {
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 100px;
  gap: 0 0
}

.fpd-container .fpd-grid>.fpd-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  position: relative
}

.fpd-container .fpd-grid>.fpd-item>img,
.fpd-container .fpd-grid>.fpd-item>picture {
  opacity: 1;
  transition: opacity .3s ease-out;
  pointer-events: none
}

.fpd-container .fpd-grid>.fpd-item:hover>img,
.fpd-container .fpd-grid>.fpd-item:hover>picture {
  opacity: .8
}

.fpd-container .fpd-grid>.fpd-item>picture {
  width: 90%;
  height: 90%;
  background-position: center center;
  background-repeat: no-repeat
}

.fpd-container .fpd-grid>.fpd-item>.fpd-delete {
  position: absolute;
  font-size: 18px;
  top: 5px;
  right: 5px;
  cursor: pointer
}

.fpd-container .fpd-grid>.fpd-item>.fpd-price {
  position: absolute;
  right: 5px;
  bottom: 5px;
  background: rgba(0, 0, 0, .7);
  color: #fff;
  font-size: 10px;
  line-height: 1;
  padding: 3px 4px;
  border-radius: 2px
}

.fpd-container .fpd-grid>.fpd-item.fpd-loading picture {
  filter: blur(2px)
}

.fpd-container .fpd-grid.fpd-grid-cover>.fpd-item>picture {
  background-size: cover
}

.fpd-container .fpd-grid.fpd-grid-contain>.fpd-item>picture {
  background-size: contain
}

.fpd-container .fpd-grid.fpd-photo-grid {
  gap: 6px
}

.fpd-container .fpd-grid.fpd-photo-grid>.fpd-item>picture {
  width: 100%;
  height: 100%;
  border-radius: var(--fpd-border-radius)
}

.fpd-container .fpd-grid.fpd-padding {
  gap: 5px
}

.fpd-container .fpd-grid>.fpd-category.fpd-item {
  background: var(--fpd-module-secondary-color);
  color: var(--fpd-module-secondary-text-color);
  height: 100px !important;
  border-radius: 2px
}

.fpd-container .fpd-grid>.fpd-category.fpd-item:nth-child(-n+2) {
  margin-top: 0
}

.fpd-container .fpd-grid>.fpd-category.fpd-item:nth-child(2n+2) {
  margin-right: 0
}

.fpd-container .fpd-grid>.fpd-category.fpd-item>picture {
  height: 55%
}

.fpd-container .fpd-grid>.fpd-category.fpd-item>span {
  text-transform: uppercase;
  margin-top: 5px;
  font-size: 10px;
  text-align: center;
  width: 100%;
  white-space: nowrap
}

.fpd-container .fpd-grid>.fpd-category.fpd-item.fpd-title-centered>span {
  bottom: 50%;
  font-size: 14px;
  white-space: normal;
  transform: translateY(50%)
}

.fpd-grid>.fpd-item>picture.fpd-on-loading,
.fpd-thumbnail-preview picture.fpd-on-loading {
  width: 30px !important;
  height: 30px !important;
  background-size: auto;
  background-image: var(--fpd-loading-svg)
}

.fpd-shadow-1 {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12)
}

.fpd-shadow-2 {
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19)
}

.fpd-shadow-3 {
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, .24), 0 17px 50px 0 rgba(0, 0, 0, .19)
}

.fpd-shadow-4 {
  box-shadow: 0 16px 28px 0 rgba(0, 0, 0, .22), 0 25px 55px 0 rgba(0, 0, 0, .21)
}

.fpd-shadow-5 {
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, .2), 0 40px 77px 0 rgba(0, 0, 0, .22)
}

.fpd-shadow-6:after,
.fpd-shadow-6:before {
  z-index: -1;
  position: absolute;
  content: "";
  bottom: 15px;
  left: 10px;
  width: 50%;
  top: 80%;
  max-width: 300px;
  background: #777;
  box-shadow: 0 15px 10px #777;
  transform: rotate(-3deg)
}

.fpd-shadow-6:after {
  transform: rotate(3deg);
  right: 10px;
  left: auto
}

.fpd-shadow-7 {
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .3), 0 0 40px rgba(0, 0, 0, .1) inset
}

.fpd-shadow-7:after,
.fpd-shadow-7:before {
  content: "";
  position: absolute;
  z-index: -1;
  box-shadow: 0 0 20px rgba(0, 0, 0, .8);
  top: 50%;
  bottom: 0;
  left: 10px;
  right: 10px;
  border-radius: 100px/10px
}

.fpd-shadow-8 {
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .3), 0 0 40px rgba(0, 0, 0, .1) inset
}

.fpd-shadow-8:after,
.fpd-shadow-8:before {
  content: "";
  position: absolute;
  z-index: -1;
  box-shadow: 0 0 20px rgba(0, 0, 0, .8);
  top: 0;
  bottom: 0;
  left: 10px;
  right: 10px;
  border-radius: 100px/10px
}

.fpd-shadow-8:after {
  right: 10px;
  left: auto;
  transform: skew(8deg) rotate(3deg)
}

.fpd-shadow-9 {
  box-shadow: 0 1px 4px rgba(0, 0, 0, .3), 0 0 40px rgba(0, 0, 0, .1) inset
}

.fpd-shadow-9:after,
.fpd-shadow-9:before {
  content: "";
  position: absolute;
  z-index: -1;
  box-shadow: 0 0 20px rgba(0, 0, 0, .8);
  top: 10px;
  bottom: 10px;
  left: 0;
  right: 0;
  border-radius: 100px/10px
}

.fpd-shadow-9:after {
  right: 10px;
  left: auto;
  transform: skew(8deg) rotate(3deg)
}

.mobile-close {
  display: none;
  width: 100%;
  font-size: 18px;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  bottom: auto;
  height: 30px;
  line-height: 30px;
  background: var(--fpd-primary-fg-color);
  z-index: 1000;
  cursor: pointer;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: none;
  border: none
}

.mobile-close:before {
  content: "";
  position: absolute;
  height: 4px;
  width: 60px;
  background: var(--fpd-border-color);
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px
}

.mobile-close .fpd-icon-close {
  display: none
}

fpd-main-bar {
  display: flex;
  position: relative;
  background: var(--fpd-primary-fg-color)
}

fpd-main-bar>.fpd-close {
  display: none;
  position: absolute;
  bottom: calc(var(--fpd-topbar-nav-height));
  left: -100%;
  width: 50px;
  height: 50px;
  padding: 0 15px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  background: rgba(255, 255, 255, .96);
  z-index: 99;
  cursor: pointer;
  border-top: 1px solid var(--fpd-border-color);
  border-right: 1px solid var(--fpd-border-color);
  border-radius: 0 4px 0 0;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, .1)
}

fpd-main-bar .fpd-navigation>.fpd-nav-item {
  display: flex;
  align-items: center;
  margin: 15px 7px;
  padding: 5px;
  text-align: center;
  cursor: pointer;
  border-radius: var(--fpd-border-radius);
  background: 0 0;
  transition: all .3s ease
}

fpd-main-bar .fpd-navigation>.fpd-nav-item .fpd-nav-icon:before {
  color: var(--fpd-mainbar-nav-color)
}

fpd-main-bar .fpd-navigation>.fpd-nav-item svg {
  width: 24px;
  max-height: 30px;
  vertical-align: middle
}

fpd-main-bar .fpd-navigation>.fpd-nav-item svg * {
  fill: var(--fpd-mainbar-nav-color)
}

fpd-main-bar .fpd-navigation>.fpd-nav-item:hover {
  opacity: .8
}

fpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active {
  position: relative;
  color: var(--fpd-secondary-color)
}

fpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active .fpd-nav-icon:before {
  color: var(--fpd-secondary-color)
}

fpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active svg * {
  fill: var(--fpd-secondary-color)
}

fpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active:before {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--fpd-secondary-color);
  opacity: .1;
  border-radius: var(--fpd-border-radius)
}

.fpd-container.fpd-sidebar .fpd-navigation {
  flex: 0 0 var(--fpd-sidebar-nav-width);
  overflow: auto
}

.fpd-container.fpd-sidebar .fpd-navigation>div>span {
  padding: 10px 0;
  display: inline-block;
  font-size: 28px
}

.fpd-container.fpd-sidebar .fpd-navigation>div>.fpd-label {
  display: block;
  font-size: 12px;
  line-height: 14px;
  padding: 0;
  word-break: break-word
}

.fpd-container.fpd-sidebar>fpd-main-bar {
  height: 100%;
  flex: 0 var(--fpd-sidebar-width);
  overflow: hidden;
  border-right: 1px solid var(--fpd-border-color)
}

.fpd-container.fpd-sidebar>fpd-main-bar .fpd-navigation {
  border-right: 1px solid var(--fpd-border-color)
}

.fpd-container.fpd-sidebar>fpd-main-bar .fpd-navigation>.fpd-nav-item {
  flex-direction: column
}

.fpd-container.fpd-sidebar>fpd-main-bar>.fpd-module-content {
  flex: 1
}

.fpd-container.fpd-sidebar.fpd-layout-medium {
  --fpd-sidebar-width: 350px
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-wrapper {
  order: 2;
  flex-basis: 100%
}

.fpd-container.fpd-sidebar.fpd-layout-small:not(.fpd-no-modules-mode) fpd-main-wrapper {
  margin-bottom: var(--fpd-sidebar-nav-width)
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar {
  height: auto !important;
  width: 100%;
  flex-basis: auto;
  flex-flow: row wrap;
  z-index: 999999999999;
  position: absolute;
  left: 0;
  bottom: 0;
  overflow: visible;
  border: none
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation {
  display: flex;
  flex: 1 0 100%;
  height: var(--fpd-sidebar-nav-width);
  min-height: auto;
  order: 2;
  align-self: flex-end;
  border-right: none;
  border-top: 1px solid var(--fpd-border-color)
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation>.fpd-nav-item {
  flex: 1 0 auto;
  white-space: nowrap;
  padding: 0 20px;
  margin: 5px 5px 8px
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation>.fpd-nav-item>span:first-child {
  height: 45px;
  padding-top: 10px;
  padding-bottom: 0
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation>.fpd-nav-item .fpd-label {
  line-height: 1
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-module-content,
.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-secondary-content {
  padding-top: 30px;
  flex: 1 0 100%;
  height: calc(100% - var(--fpd-sidebar-nav-width));
  min-height: auto;
  display: none
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-close {
  display: none;
  width: 100%;
  font-size: 18px;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  bottom: auto;
  height: 30px;
  line-height: 30px;
  background: var(--fpd-primary-fg-color);
  z-index: 1000;
  cursor: pointer;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: none;
  border: none
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-close:before {
  content: "";
  position: absolute;
  height: 4px;
  width: 60px;
  background: var(--fpd-border-color);
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-close .fpd-icon-close {
  display: none
}

.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar:not(.fpd-no-modules-mode) .fpd-secondary-content {
  height: 100%
}

.fpd-container.fpd-sidebar.fpd-layout-small.fpd-module-visible fpd-main-bar,
.fpd-container.fpd-sidebar.fpd-layout-small.fpd-secondary-visible fpd-main-bar {
  height: 100% !important
}

.fpd-container.fpd-sidebar.fpd-layout-small.fpd-module-visible .fpd-module-content {
  display: block !important
}

.fpd-container.fpd-sidebar.fpd-secondary-visible .fpd-secondary-content {
  display: block !important
}

.fpd-off-canvas fpd-main-bar,
.fpd-topbar fpd-main-bar {
  flex-basis: 100%;
  order: 2;
  height: auto !important
}

.fpd-off-canvas fpd-main-bar .fpd-navigation,
.fpd-topbar fpd-main-bar .fpd-navigation {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  flex-basis: 100%;
  height: var(--fpd-topbar-nav-height);
  padding: 5px;
  overflow-x: auto;
  border-bottom: 1px solid var(--fpd-border-color)
}

.fpd-off-canvas fpd-main-bar .fpd-navigation>div,
.fpd-topbar fpd-main-bar .fpd-navigation>div {
  height: 100%;
  padding: 0 20px;
  margin: 0;
  white-space: nowrap;
  flex-grow: 1;
  flex-basis: auto
}

.fpd-off-canvas fpd-main-bar .fpd-navigation>div>span,
.fpd-topbar fpd-main-bar .fpd-navigation>div>span {
  line-height: 65px;
  font-size: 26px
}

.fpd-off-canvas fpd-main-bar .fpd-navigation>div>.fpd-label,
.fpd-topbar fpd-main-bar .fpd-navigation>div>.fpd-label {
  font-size: 15px;
  padding-left: 10px;
  vertical-align: top;
  text-transform: uppercase;
  white-space: nowrap
}

.fpd-off-canvas fpd-main-bar>.fpd-module-content,
.fpd-topbar fpd-main-bar>.fpd-module-content {
  display: none
}

.fpd-topbar fpd-main-bar>.fpd-close {
  display: none !important
}

.fpd-off-canvas {
  overflow: hidden
}

.fpd-off-canvas fpd-main-bar {
  order: 3
}

.fpd-off-canvas fpd-main-bar>.fpd-close {
  display: block
}

.fpd-off-canvas fpd-main-bar .fpd-navigation {
  border-top: 1px solid var(--fpd-border-color)
}

.fpd-off-canvas fpd-main-bar .fpd-module-content,
.fpd-off-canvas fpd-main-bar .fpd-secondary-content {
  height: var(--fpd-content-height);
  width: var(--fpd-off-canvas-width);
  left: calc(-2 * var(--fpd-off-canvas-width));
  bottom: var(--fpd-topbar-nav-height);
  border-right: 1px solid var(--fpd-border-color);
  position: absolute;
  display: block;
  z-index: 100;
  background: rgba(255, 255, 255, .96);
  box-shadow: 2px 0 8px 0 rgba(0, 0, 0, .1)
}

.fpd-off-canvas fpd-main-bar.fpd-show .fpd-module-content {
  left: 0
}

.fpd-off-canvas fpd-main-bar.fpd-show>.fpd-close {
  left: var(--fpd-off-canvas-width);
  margin-left: -1px
}

.fpd-off-canvas fpd-main-bar:not(.fpd-is-dragging) .fpd-close,
.fpd-off-canvas fpd-main-bar:not(.fpd-is-dragging) .fpd-module-content {
  transition: left .3s cubic-bezier(.215, .61, .355, 1)
}

.fpd-off-canvas.fpd-secondary-visible fpd-main-bar .fpd-secondary-content {
  left: 0
}

.fpd-off-canvas.fpd-secondary-visible fpd-main-bar>.fpd-close {
  left: var(--fpd-off-canvas-width);
  margin-left: -1px
}

.fpd-off-canvas.fpd-layout-small fpd-main-bar .fpd-close {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  padding: 0
}

.fpd-off-canvas.fpd-layout-small fpd-main-bar .fpd-module-content {
  border: none
}

.fpd-module-content>* {
  height: 100%;
  display: none
}

.fpd-module-content>*>div {
  height: 100%;
  display: flex;
  flex-flow: column
}

.fpd-module-content>.fpd-active {
  display: block
}

.fpd-draggable-dialog {
  display: none;
  width: 350px;
  height: 450px;
  background: var(--fpd-primary-fg-color);
  position: fixed !important;
  left: calc(50% - 175px);
  top: calc(45% - 200px);
  min-width: 200px;
  min-height: 100px;
  z-index: 1000000;
  border-radius: 2px;
  max-width: 100%;
  overflow: hidden;
  border-radius: 6px
}

.fpd-draggable-dialog.fpd-show {
  display: flex;
  flex-flow: column nowrap
}

.fpd-draggable-dialog>.fpd-dialog-head {
  background: var(--fpd-primary-color);
  color: var(--fpd-primary-fg-color);
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 15px;
  padding: 0 0 0 12px;
  cursor: move;
  overflow: hidden;
  white-space: nowrap
}

.fpd-draggable-dialog>.fpd-dialog-head>.fpd-dialog-drag-handle {
  flex: 1;
  overflow: hidden
}

.fpd-draggable-dialog>.fpd-dialog-head>.fpd-dialog-drag-handle .fpd-dialog-title {
  margin-left: 6px;
  text-transform: uppercase
}

.fpd-draggable-dialog>.fpd-dialog-head>.fpd-close-dialog {
  font-size: 14px;
  padding: 0 12px;
  text-align: right;
  cursor: pointer;
  opacity: .8;
  transition: opacity .2s ease-out
}

.fpd-draggable-dialog>.fpd-dialog-head>.fpd-close-dialog:hover {
  opacity: 1
}

.fpd-draggable-dialog>.fpd-module-content {
  flex: 1;
  height: 100%;
  overflow: hidden
}

.fpd-draggable-dialog.fpd-secondary-visible>.fpd-module-content {
  display: none
}

.fpd-draggable-dialog.fpd-secondary-visible>.fpd-secondary-content {
  display: block;
  overflow: hidden
}

.fpd-wrapper.fpd-module-visible.fpd-layout-small fpd-main-bar .fpd-close,
.fpd-wrapper.fpd-module-visible.fpd-off-canvas fpd-main-bar .fpd-close,
.fpd-wrapper.fpd-secondary-visible.fpd-layout-small fpd-main-bar .fpd-close,
.fpd-wrapper.fpd-secondary-visible.fpd-off-canvas fpd-main-bar .fpd-close {
  display: block
}

.fpd-wrapper.fpd-secondary-visible fpd-main-bar .fpd-module-content {
  display: none !important
}

.fpd-wrapper.fpd-products-module-hidden .fpd-navigation .fpd-nav-item[data-module=products] {
  display: none !important
}

.fpd-wrapper.fpd-no-modules-mode fpd-main-bar .fpd-navigation,
.fpd-wrapper.fpd-one-module-mode:not(.fpd-layout-small) fpd-main-bar .fpd-navigation {
  display: none !important
}

.fpd-secondary-content {
  display: none;
  flex: 1
}

.fpd-secondary-content>* {
  display: none
}

.fpd-secondary-content>.fpd-active {
  display: block
}

.fpd-secondary-content .fpd-upload-zone-panel {
  display: flex;
  flex-flow: column;
  height: 100%
}

.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content {
  flex-basis: 100%;
  overflow: hidden
}

.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content>* {
  height: 100%;
  display: none
}

.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content>.fpd-active {
  display: block
}

.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content>*>div {
  height: 100%;
  display: flex;
  flex-flow: column
}

.fpd-secondary-content .fpd-upload-zone-panel>.fpd-bottom-nav>div {
  padding: 11px;
  font-size: 22px
}

.fpd-no-modules-mode.fpd-off-canvas .fpd-secondary-content {
  bottom: 0
}

.fpd-container.fpd-main-bar-container fpd-main-bar {
  min-height: 500px !important;
  min-width: 300px;
  width: 400px;
  border: 1px solid var(--fpd-border-color);
  margin: 20px 0
}

.fpd-main-bar-container-enabled fpd-main-wrapper {
  flex-basis: 100% !important
}

.fpd-modal-mode-active .fpd-wrapper.fpd-layout-small fpd-main-bar {
  padding-bottom: env(safe-area-inset-bottom)
}

.fpd-container fpd-actions-bar {
  background: var(--fpd-actions-bar-bg-color);
  height: var(--fpd-actions-bar-height);
  flex: 1 100%;
  display: flex;
  flex-flow: row nowrap;
  color: var(--fpd-primary-fg-color);
  align-items: center;
  padding: 0 5px;
  justify-content: space-between
}

.fpd-container fpd-actions-bar>div {
  flex: 1;
  font-size: 16px;
  white-space: nowrap;
  max-width: 33%;
  height: 100%
}

.fpd-container fpd-actions-bar>div>.fpd-btn span {
  margin-left: 5px
}

.fpd-container fpd-actions-bar>[data-pos=center] fpd-actions-menu>div {
  left: 50%;
  transform: translateX(-50%)
}

.fpd-container fpd-actions-bar>[data-pos=center] .fpd-btn span {
  display: none
}

.fpd-container fpd-actions-bar>[data-pos=center] .fpd-switch {
  display: none
}

.fpd-container fpd-actions-bar>[data-pos=right] fpd-actions-menu>div {
  right: 0;
  left: auto
}

.fpd-container fpd-actions-bar>[data-pos=right] fpd-actions-menu .fpd-dropdown-menu {
  text-align: left;
  right: 0;
  left: auto
}

.fpd-container fpd-actions-bar>[data-pos=modal] {
  display: none
}

.fpd-container fpd-actions-bar fpd-actions-menu {
  display: flex;
  justify-content: center;
  max-width: 100%;
  height: 100%;
  position: relative
}

.fpd-container fpd-actions-bar fpd-actions-menu .fpd-collapsed-menu,
.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex
}

.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu {
  max-width: none;
  white-space: nowrap;
  align-items: center;
  justify-content: center
}

.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu .fpd-btn span {
  font-size: 14px;
  margin-left: 10px
}

.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu .fpd-btn .fpd-switch {
  display: none
}

.fpd-container fpd-actions-bar fpd-actions-menu .fpd-collapsed-menu {
  align-items: center
}

.fpd-container fpd-actions-bar .fpd-btn,
.fpd-container fpd-actions-bar .fpd-dropdown-btn {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding: 7px 12px;
  margin: 0 0 0 5px;
  border-radius: var(--fpd-border-radius);
  line-height: 1;
  text-transform: capitalize;
  background: 0 0
}

.fpd-container fpd-actions-bar .fpd-btn:hover,
.fpd-container fpd-actions-bar .fpd-dropdown-btn:hover {
  opacity: 1;
  background: rgba(255, 255, 255, .05)
}

.fpd-container fpd-actions-bar .fpd-btn>*,
.fpd-container fpd-actions-bar .fpd-dropdown-btn>* {
  pointer-events: none;
  line-height: 1;
  vertical-align: middle
}

.fpd-container fpd-actions-bar .fpd-btn.fpd-btn-fill,
.fpd-container fpd-actions-bar .fpd-dropdown-btn.fpd-btn-fill {
  background: rgba(255, 255, 255, .1)
}

.fpd-container fpd-actions-bar .fpd-btn.fpd-btn-fill>span,
.fpd-container fpd-actions-bar .fpd-dropdown-btn.fpd-btn-fill>span {
  display: inline-flex;
}

.fpd-container fpd-actions-bar .fpd-btn {
  font-size: 18px
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: max-content;
  z-index: 10000;
  background: #fff;
  border-radius: var(--fpd-border-radius);
  transform: translateY(5px);
  padding: 5px 0
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn {
  display: flex;
  color: var(--fpd-text-color);
  min-width: 150px;
  margin: 5px 10px;
  font-size: 16px;
  padding: 0;
  border-radius: var(--fpd-border-radius)
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn:hover {
  background: rgba(0, 0, 0, .05)
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>* {
  pointer-events: auto;
  margin: 10px
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>i {
  flex: 0;
  margin-right: 0
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>span {
  flex: 1
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>.fpd-switch {
  margin-left: 40px
}

.fpd-container fpd-actions-bar .fpd-dropdown-menu.fpd-show {
  display: block
}

.fpd-off-canvas fpd-actions-bar,
.fpd-topbar fpd-actions-bar {
  order: 1;
  display: flex
}

.fpd-off-canvas fpd-actions-bar {
  order: 1 !important
}

.fpd-container .fpd-modal-download>span {
  font-size: 60px;
  cursor: pointer
}

.fpd-container .fpd-zoom-wrapper {
  display: flex;
  width: 150px;
  background: #fff;
  border-radius: var(--fpd-border-radius);
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translate(-50%, 50%);
  padding: 10px;
  z-index: 10
}

.fpd-container .fpd-zoom-wrapper>.fpd-stage-pan {
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer
}

.fpd-container .fpd-zoom-wrapper>.fpd-stage-pan.fpd-active {
  color: var(--fpd-secondary-color)
}

.fpd-container .fpd-zoom-wrapper>.fpd-close {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
  top: 4px;
  transform: translateY(-100%);
  background: #fff;
  padding: 2px 10px;
  z-index: 1;
  border-radius: var(--fpd-border-radius) var(--fpd-border-radius) 0 0;
  border: 1px solid var(--fpd-border-color);
  border-bottom: none;
  cursor: pointer;
  font-size: 10px
}

.fpd-container .fpd-zoom-wrapper>.fpd-close:hover>* {
  font-weight: 700
}

.fpd-modal-product-designer fpd-actions-bar {
  justify-content: stretch
}

.fpd-modal-product-designer fpd-actions-bar [data-pos=right] {
  margin-left: auto
}

.fpd-modal-product-designer fpd-actions-bar [data-pos=modal] {
  flex: 0;
  text-align: right;
  display: flex !important;
  padding: 5px;
  align-items: center
}

.fpd-modal-product-designer fpd-actions-bar .fpd-total-price {
  line-height: 20px;
  font-size: 15px;
  display: inline-block
}

.fpd-modal-product-designer .fpd-wrapper.fpd-layout-small [data-pos=right] .fpd-dropdown-menu {
  transform: translate(50%, 5px)
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar {
  gap: 2px
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar>div {
  max-width: none
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar .fpd-dropdown-btn>span {
  display: none
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=left],
.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=right] {
  max-width: 45px
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=modal]>.fpd-btn.fpd-done .fpd-label {
  display: none
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=modal]>.fpd-btn.fpd-done i {
  font-size: 14px
}

.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=modal]>.fpd-btn.fpd-close:last-child {
  padding-left: 6px;
  padding-right: 0;
  font-size: 16px
}

.fpd-wrapper.fpd-off-canvas>fpd-main-wrapper,
.fpd-wrapper.fpd-topbar>fpd-main-wrapper {
  flex-basis: 100%
}

.fpd-wrapper.fpd-off-canvas>fpd-main-wrapper {
  order: 2 !important
}

.fpd-wrapper>fpd-main-wrapper {
  display: flex;
  overflow: hidden;
  flex: 1 0;
  min-height: 400px;
  background: var(--fpd-canvas-bg);
  transition: opacity .3s ease-out;
  order: 3;
  position: relative
}

.fpd-wrapper>fpd-main-wrapper .fpd-product-stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  direction: ltr;
  max-height: 100%;
  margin: auto;
  width: 100%
}

.fpd-wrapper>fpd-main-wrapper .fpd-product-stage>.fpd-view-stage {
  background: rgba(255, 255, 255, .7);
  height: 100%
}

.fpd-wrapper>fpd-main-wrapper .fpd-product-stage>.fpd-view-stage textarea {
  left: -10000px !important;
  top: 50% !important
}

.fpd-wrapper>fpd-main-wrapper .fpd-product-stage>.fpd-zoom-image {
  position: absolute;
  top: 0;
  left: 0;
  max-width: 100%
}

.fpd-wrapper>fpd-main-wrapper.fpd-drag canvas {
  cursor: grab !important
}

.fpd-wrapper>fpd-main-wrapper>.fpd-warnings {
  position: absolute;
  width: 90%;
  left: 5%;
  top: 20px;
  font-size: 14px
}

.fpd-wrapper>fpd-main-wrapper>.fpd-warnings>.fpd-size-warning {
  display: flex;
  flex-direction: row;
  padding: 12px;
  background: var(--fpd-yellow-color);
  color: var(--fpd-yellow-contrast-color);
  border-radius: var(--fpd-border-radius);
  border: 1px solid var(--fpd-yellow-contrast-color);
  box-shadow: 0 0 6px rgba(0, 0, 0, .1);
  justify-content: space-between;
  gap: 10px
}

.fpd-wrapper>fpd-main-wrapper>.fpd-warnings>.fpd-size-warning .fpd-btn {
  background-color: #3f3f3f;
  margin: 0;
  white-space: nowrap;
  max-height: 35px
}

.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 100
}

.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor .fpd-close {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 16px;
  z-index: 1000;
  cursor: pointer;
  opacity: .6
}

.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor .fpd-close:hover {
  opacity: 1
}

.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor .fpd-done {
  position: absolute;
  background: var(--fpd-secondary-color);
  color: var(--fpd-secondary-fg-color);
  border-radius: var(--fpd-border-radius);
  padding: 6px 12px;
  right: 10px;
  bottom: 10px;
  font-size: 16px;
  z-index: 1000;
  cursor: pointer
}

.fpd-wrapper.fpd-layout-small .fpd-size-warning {
  flex-direction: column !important
}

.fpd-wrapper.fpd-layout-small .fpd-size-warning .fpd-btn {
  justify-content: center
}

.fpd-container fpd-views-nav {
  position: absolute;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 4px 8px;
  bottom: calc(10px + env(safe-area-inset-bottom));
  right: 10px;
  background: #fff;
  box-shadow: 0 0 10px rgba(110, 111, 114, .22);
  border-radius: var(--fpd-border-radius);
  min-height: 35px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 160px
}

.fpd-container fpd-views-nav>.fpd-view-locker {
  font-size: 20px;
  cursor: pointer;
  margin-left: 5px
}

.fpd-container fpd-views-nav>.fpd-view-locker .fpd-icon-locked {
  color: var(--fpd-secondary-color)
}

.fpd-container fpd-views-nav>.fpd-view-next,
.fpd-container fpd-views-nav>.fpd-view-prev {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  font-size: 18px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  transform-origin: center center
}

.fpd-container fpd-views-nav>.fpd-view-next:hover,
.fpd-container fpd-views-nav>.fpd-view-prev:hover {
  color: var(--fpd-secondary-color)
}

.fpd-container fpd-views-nav>.fpd-view-prev {
  rotate: -180deg
}

.fpd-container fpd-views-nav>.fpd-show-views-grid {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  line-height: 1
}

.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-icon-pages {
  font-size: 18px;
  margin-right: 4px
}

.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-current-view {
  font-size: 16px;
  margin-right: 2px;
  padding-top: 2px
}

.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-total-views {
  display: inline-block;
  padding: 4px 0;
  text-align: center;
  color: var(--fpd-dark-grey-color);
  font-size: 12px
}

.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-total-views:before {
  content: "/"
}

.fpd-container fpd-views-nav>.fpd-view-edit-size {
  display: flex;
  flex-direction: row;
  flex: 1 1 100%;
  width: 50px;
  border-bottom: 1px solid var(--fpd-border-color)
}

.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input {
  box-shadow: none;
  border-radius: 0;
  border: none;
  height: 100%
}

.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input:first-child {
  border-top-left-radius: var(--fpd-border-radius)
}

.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input>span {
  background: var(--fpd-border-color);
  padding: 6px 6px
}

.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input>input {
  padding: 0;
  height: auto
}

.fpd-views-inside-left fpd-views-nav {
  left: 10px;
  right: auto
}

.fpd-container fpd-views-grid {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  background: var(--fpd-light-bg-color);
  z-index: 1000;
  flex-flow: column wrap
}

.fpd-container fpd-views-grid.fpd-show {
  display: flex
}

.fpd-container fpd-views-grid>.fpd-head {
  position: relative;
  min-height: 40px
}

.fpd-container fpd-views-grid>.fpd-head>.fpd-btn {
  display: none
}

.fpd-container fpd-views-grid .fpd-grid {
  gap: 35px 20px;
  display: flex;
  flex-flow: row wrap;
  padding: 10px
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item {
  background: #fff;
  flex: 1 0 45%;
  max-width: 150px;
  height: 150px;
  border-radius: var(--fpd-border-radius);
  overflow: hidden;
  padding: 5px;
  cursor: default
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>picture {
  background-size: contain;
  margin: 20px 0 5px;
  pointer-events: all;
  cursor: pointer
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>span {
  white-space: nowrap;
  display: block;
  overflow: hidden;
  font-size: 12px
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-sort {
  position: absolute;
  left: 5px;
  top: 5px;
  font-size: 18px;
  cursor: move
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-sort>* {
  pointer-events: none
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0 6px 2px;
  font-size: 18px;
  line-height: 1;
  cursor: pointer
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options:hover {
  opacity: 1
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu {
  position: absolute;
  display: none;
  flex-flow: column nowrap;
  text-align: right;
  top: 100%;
  right: 0;
  min-width: max-content;
  z-index: 1000;
  background: #fff;
  color: var(--fpd-text-color);
  border-radius: var(--fpd-border-radius);
  transform: translateY(5px);
  padding: 6px
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu>span {
  padding: 4px;
  font-size: 13px;
  min-width: 90px;
  border-radius: 4px
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu>span:hover {
  background: var(--fpd-light-bg-color)
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu.fpd-show {
  display: flex
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay {
  background: rgba(255, 255, 255, .98);
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  padding: 20px;
  gap: 10px
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay>input {
  width: 100%;
  background: #fff !important;
  margin: 0;
  text-align: center;
  padding: 7px
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay>.fpd-btn {
  display: inline-flex;
  width: min-content;
  margin: 0;
  padding: 3px 8px;
  font-size: 12px;
  line-height: 1
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay.fpd-show {
  display: flex
}

.fpd-container fpd-views-grid .fpd-grid>.fpd-item:first-child .fpd-dropdown-menu [data-option=delete] {
  display: none
}

.fpd-container fpd-views-grid .fpd-blank-page-modal,
.fpd-container fpd-views-grid .fpd-layouts-modal {
  position: absolute;
  left: 10px;
  top: 10px;
  right: 10px;
  bottom: 10px;
  background: #fff;
  margin: 10px;
  display: flex;
  flex-flow: column wrap;
  border-radius: var(--fpd-border-radius)
}

.fpd-container fpd-views-grid .fpd-blank-page-modal>.fpd-head,
.fpd-container fpd-views-grid .fpd-layouts-modal>.fpd-head {
  position: relative;
  min-height: 40px;
  display: flex
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-scroll-area,
.fpd-container fpd-views-grid .fpd-layouts-modal .fpd-scroll-area {
  margin-right: 5px
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid,
.fpd-container fpd-views-grid .fpd-layouts-modal .fpd-grid {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid>.fpd-item,
.fpd-container fpd-views-grid .fpd-layouts-modal .fpd-grid>.fpd-item {
  flex: 0 0 200px;
  height: 150px;
  cursor: pointer
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head {
  padding: 10px
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head .fpd-input {
  width: max-content;
  margin-right: 20px;
  max-width: 150px
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head .fpd-input>input {
  width: 100px
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head .fpd-btn {
  margin: 0
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid {
  justify-content: flex-start;
  align-items: center
}

.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid .fpd-item {
  flex: 1 0 45%;
  text-align: center
}

.fpd-container fpd-views-grid.fpd-modal-visible>.fpd-head,
.fpd-container fpd-views-grid.fpd-modal-visible>.fpd-scroll-area {
  filter: blur(5px)
}

.fpd-container fpd-views-grid .fpd-head {
  border-bottom: 1px solid var(--fpd-border-color);
  padding: 10px
}

.fpd-container fpd-views-grid .fpd-head .fpd-btn {
  margin: 0 10px 5px 0
}

.fpd-container fpd-views-grid .fpd-close {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  cursor: pointer
}

.fpd-container fpd-views-grid .fpd-scroll-area {
  flex: 1;
  position: relative
}

.fpd-sidebar fpd-views-grid {
  left: var(--fpd-sidebar-nav-width);
  top: var(--fpd-actions-bar-height);
  width: calc(100% - var(--fpd-sidebar-nav-width));
  height: calc(100% - var(--fpd-actions-bar-height))
}

.fpd-wrapper.fpd-layout-small .fpd-blank-page-modal .fpd-head {
  flex-flow: row wrap;
  gap: 10px;
  padding-top: 40px
}

.fpd-wrapper.fpd-layout-small .fpd-blank-page-modal .fpd-head .fpd-input {
  flex: 1 0 0;
  margin: 0
}

.fpd-wrapper.fpd-layout-small .fpd-blank-page-modal .fpd-head .fpd-btn {
  text-align: center;
  width: 100%;
  flex: 0 0 100%
}

.fpd-sidebar.fpd-layout-small fpd-views-grid {
  width: 100%;
  height: calc(100% - var(--fpd-sidebar-nav-width) - var(--fpd-actions-bar-height));
  left: 0
}

.fpd-sidebar.fpd-layout-small fpd-views-grid .fpd-grid {
  justify-content: space-between
}

.fpd-sidebar.fpd-layout-small fpd-views-grid .fpd-layouts-modal .fpd-grid {
  gap: 20px
}

.fpd-sidebar.fpd-layout-small fpd-views-grid .fpd-layouts-modal .fpd-grid .fpd-item {
  flex: 0 calc(50% - 10px)
}

.fpd-off-canvas fpd-views-grid,
.fpd-topbar fpd-views-grid {
  width: 100%;
  height: 100%
}

.fpd-wrapper.fpd-dynamic-views-enabled fpd-views-grid>.fpd-head>.fpd-btn {
  display: inline-block
}

fpd-element-toolbar {
  display: none;
  overflow: hidden;
  z-index: 2;
  color: var(--fpd-text-color)
}

fpd-element-toolbar.fpd-show {
  display: flex !important
}

fpd-element-toolbar .fpd-close,
fpd-element-toolbar .fpd-close-sub-panel {
  display: none;
  position: absolute;
  right: 0;
  top: 5px;
  height: 30px;
  min-width: 35px;
  padding: 0 7px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  background: #fff;
  font-size: 14px;
  transform: translateY(-100%);
  box-shadow: 0 -1px 2px rgba(110, 111, 114, .2);
  border-top-left-radius: var(--fpd-border-radius);
  border-top-right-radius: var(--fpd-border-radius);
  gap: 3px;
  align-items: center
}

fpd-element-toolbar .fpd-close-sub-panel>.fpd-label {
  font-size: 12px
}

fpd-element-toolbar>.fpd-tools-nav {
  display: flex;
  flex-direction: column
}

fpd-element-toolbar>.fpd-tools-nav>div {
  display: flex
}

fpd-element-toolbar>.fpd-tools-nav>div>div {
  flex: 1;
  padding: 0 15px;
  white-space: nowrap;
  text-align: center;
  cursor: pointer
}

fpd-element-toolbar>.fpd-tools-nav>div>div>span[class^=fpd-icon-] {
  display: block;
  font-size: 20px !important;
  line-height: 28px
}

fpd-element-toolbar>.fpd-tools-nav>div>div>.fpd-label {
  margin-top: 5px;
  font-size: 11px;
  display: inline-block;
  line-height: 1;
  vertical-align: bottom
}

fpd-element-toolbar>.fpd-tools-nav>div>div>.fpd-current-fill {
  display: block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, .1)
}

fpd-element-toolbar>.fpd-tools-nav>div>div.fpd-active {
  color: var(--fpd-secondary-color)
}

fpd-element-toolbar .fpd-sub-panel {
  flex: 1;
  overscroll-behavior: none
}

fpd-element-toolbar .fpd-sub-panel>div {
  display: none;
  height: 100%;
  width: 100%
}

fpd-element-toolbar .fpd-sub-panel>div>* {
  margin-bottom: 10px
}

fpd-element-toolbar .fpd-sub-panel>div>:last-child {
  margin: 0
}

fpd-element-toolbar .fpd-sub-panel>div.fpd-active {
  display: flex;
  flex-flow: column nowrap
}

fpd-element-toolbar .fpd-sub-panel>div.fpd-padding {
  padding: 15px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-input {
  flex-flow: row wrap;
  box-shadow: none;
  overflow: visible
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-input input,
fpd-element-toolbar .fpd-sub-panel>div .fpd-input>span {
  flex: 1;
  border: none
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-input>span {
  padding: 0
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-input fpd-range-slider {
  order: 3
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs {
  display: flex;
  align-items: center
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs>span {
  flex: 1;
  text-align: center;
  padding: 8px 0 6px 0;
  cursor: pointer;
  opacity: .7
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs>span.fpd-active {
  color: var(--fpd-secondary-color);
  position: relative;
  opacity: 1
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs>span.fpd-active:after {
  background-color: var(--fpd-secondary-color);
  position: absolute;
  content: "";
  width: 60%;
  height: 2px;
  left: 20%;
  bottom: 0
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs-content>div {
  display: none;
  padding: 10px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs-content>div.fpd-active {
  display: block
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs-content>div>* {
  margin-bottom: 20px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group,
fpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 4px;
  flex-flow: row wrap
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>*,
fpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group>* {
  flex: 1;
  border: 1px solid var(--fpd-border-color);
  border-radius: var(--fpd-border-radius);
  font-size: 13px;
  padding: 5px 0;
  cursor: pointer;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>:hover,
fpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group>:hover {
  background: var(--fpd-light-bg-color)
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group [class^=fpd-icon-],
fpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group [class^=fpd-icon-] {
  font-size: 18px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group {
  border: 1px solid var(--fpd-border-color)
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>* {
  border: none;
  border-radius: 0
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>.fpd-active {
  color: var(--fpd-secondary-color)
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-toggle.fpd-enabled {
  color: var(--fpd-secondary-color)
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-tool-position-align>div {
  flex: 1 0 32%
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-tool-uniscaling-locker {
  font-size: 18px;
  text-align: right
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-curved-options {
  display: flex;
  gap: 30px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-curved-options>span {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  cursor: pointer;
  background: var(--fpd-light-bg-color);
  border-radius: var(--fpd-border-radius);
  padding: 5px
}

fpd-element-toolbar .fpd-sub-panel>div .fpd-curved-options>span.fpd-active svg * {
  fill: var(--fpd-secondary-color)
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-color>.fpd-scroll-area {
  overflow: visible
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-color .fpd-colorpicker-wrapper {
  padding: 0
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family {
  flex-flow: column nowrap;
  height: 100%
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list {
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  gap: 20px
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list>.fpd-item {
  cursor: pointer;
  font-size: 16px;
  transition: all .2s ease-in-out
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list>.fpd-item.fpd-active {
  color: var(--fpd-secondary-color)
}

fpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list>.fpd-item:hover {
  padding-left: 5px
}

fpd-element-toolbar .fpd-sub-panel .fpd-tool-filters {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 35px 10px;
  padding-bottom: 40px;
  overflow: auto;
  height: auto
}

fpd-element-toolbar .fpd-sub-panel .fpd-tool-filters>.fpd-item {
  flex: 0 0 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative
}

fpd-element-toolbar .fpd-sub-panel .fpd-tool-filters>.fpd-item:after {
  content: attr(aria-label);
  position: absolute;
  top: 100%;
  left: 0;
  line-height: 14px;
  font-size: 12px;
  overflow: hidden;
  transform: translateY(3px);
  max-width: inherit
}

fpd-element-toolbar .fpd-sub-panel .fpd-tool-crop-masks {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
  gap: 40px 20px !important
}

fpd-element-toolbar .fpd-sub-panel .fpd-tool-crop-masks .fpd-item {
  flex: 0 0 25%;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain
}

fpd-element-toolbar.fpd-smart {
  display: none;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: var(--fpd-et-max-width);
  min-width: 300px;
  border-radius: var(--fpd-border-radius);
  transform: translateX(-50%);
  z-index: 10000000000;
  box-shadow: 0 0 10px rgba(110, 111, 114, .22);
  overflow: visible
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>div {
  margin: 10px 0
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>div>div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools {
  justify-content: space-between;
  padding-left: 5px
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools>div {
  padding: 0 10px
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size {
  flex: 0 70px
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size input {
  margin: 0;
  width: 100%;
  pointer-events: none;
  text-align: center
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family {
  flex: 1 180px
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family fpd-dropdown {
  width: 100%;
  pointer-events: none
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family,
fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size {
  align-self: flex-end
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family>[class^=fpd-icon-],
fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size>[class^=fpd-icon-] {
  display: none
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family .fpd-label,
fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size .fpd-label {
  display: none
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family>fpd-dropdown,
fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size>fpd-dropdown {
  min-height: 42px
}

fpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-secondary-tools {
  padding-bottom: 10px
}

fpd-element-toolbar.fpd-smart[data-element-type=image] .fpd-tools-nav {
  flex-direction: row
}

fpd-element-toolbar.fpd-smart[data-element-type=image] .fpd-tools-nav>div {
  margin: 20px 0;
  overflow: hidden;
  flex: 1 0 auto;
  max-width: none
}

fpd-element-toolbar.fpd-smart[data-element-type=image] .fpd-tools-nav>.fpd-secondary-tools {
  padding-bottom: 0
}

fpd-element-toolbar.fpd-smart>.fpd-sub-panel {
  display: none;
  width: 100%
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible {
  width: var(--fpd-et-max-width)
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible .fpd-close {
  display: none !important
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-tools-nav {
  display: none !important
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-sub-panel {
  display: flex
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-sub-panel .fpd-panel-tabs-content.fpd-scroll-area {
  overflow: auto;
  max-height: 200px
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list {
  max-height: 100px
}

fpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-close-sub-panel {
  display: flex
}

fpd-element-toolbar.fpd-smart.fpd-show>.fpd-close {
  display: block
}

fpd-element-toolbar.fpd-smart .fpd-tool-crop-masks,
fpd-element-toolbar.fpd-smart .fpd-tool-filters {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 30px;
  overflow-x: auto;
  overflow-y: hidden
}

fpd-element-toolbar.fpd-smart .fpd-tool-crop-masks {
  gap: 0 20px !important;
  justify-content: flex-start
}

fpd-element-toolbar.fpd-smart .fpd-tool-crop-masks .fpd-item {
  height: 50px
}

fpd-element-toolbar.fpd-smart.fpd-layout-small {
  position: fixed;
  left: 0 !important;
  bottom: 0 !important;
  top: auto !important;
  width: 100%;
  transform: none;
  border-radius: 0;
  box-shadow: 0 -1px 8px rgba(110, 111, 114, .2);
  padding-bottom: env(safe-area-inset-bottom);
  max-width: none
}

fpd-element-toolbar.fpd-smart.fpd-layout-small .fpd-close,
fpd-element-toolbar.fpd-smart.fpd-layout-small .fpd-close-sub-panel {
  border-top-right-radius: 0
}

fpd-element-toolbar.fpd-sidebar .fpd-tool-filters {
  row-gap: 35px !important
}

fpd-element-toolbar.fpd-sidebar .fpd-tools-nav {
  flex-direction: column
}

fpd-element-toolbar.fpd-sidebar .fpd-tools-nav>div {
  flex-direction: column;
  gap: 25px 0;
  height: auto;
  overflow: visible
}

fpd-element-toolbar.fpd-sidebar .fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family fpd-dropdown,
fpd-element-toolbar.fpd-sidebar .fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size input {
  display: none !important
}

fpd-main-bar>fpd-element-toolbar {
  background: var(--fpd-primary-fg-color);
  position: absolute;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100%;
  flex-flow: row nowrap
}

fpd-main-bar>fpd-element-toolbar>.fpd-tools-nav {
  flex: 0 80px;
  flex-flow: column;
  align-items: center;
  border-right: 1px solid var(--fpd-border-color)
}

fpd-main-bar>fpd-element-toolbar>.fpd-tools-nav>div {
  flex: 0;
  margin: 10px 0
}

fpd-main-bar>fpd-element-toolbar>.fpd-tools-nav>div .fpd-label {
  white-space: normal
}

fpd-element-toolbar[data-fabric-type=engraved-text] .fpd-panel-color>.fpd-panel-tabs,
fpd-element-toolbar[data-fabric-type=engraved-text] .fpd-patterns-wrapper,
fpd-element-toolbar[data-fabric-type=engraved-text] .fpd-tool-curved-text,
fpd-element-toolbar[data-fabric-type=engraved-text] .fpd-tool-fill-opacity,
fpd-element-toolbar[data-fabric-type=engraved-text] .fpd-tool-text-format,
fpd-element-toolbar[data-fabric-type=neon-text] .fpd-panel-color>.fpd-panel-tabs,
fpd-element-toolbar[data-fabric-type=neon-text] .fpd-patterns-wrapper,
fpd-element-toolbar[data-fabric-type=neon-text] .fpd-tool-curved-text,
fpd-element-toolbar[data-fabric-type=neon-text] .fpd-tool-fill-opacity,
fpd-element-toolbar[data-fabric-type=neon-text] .fpd-tool-text-format {
  display: none !important
}

.fpd-toolbar-visible .fpd-toolbar-sidebar fpd-main-bar {
  overflow: visible
}

.fpd-toolbar-visible .fpd-toolbar-sidebar fpd-main-bar>.fpd-close {
  display: block;
  right: 0;
  left: auto;
  top: 20px;
  transform: translateX(100%);
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  width: 30px;
  padding: 0 5px
}

body[data-fpd-industry-type=engraving]:not(.fpd-editor-mode) .fpd-tool-advanced-editing,
body[data-fpd-industry-type=engraving]:not(.fpd-editor-mode) .fpd-tool-fill-opacity,
body[data-fpd-industry-type=engraving]:not(.fpd-editor-mode) .fpd-tool-remove-bg {
  display: none !important
}

.fpd-container fpd-module-products {
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-products .fpd-product-categories {
  display: none
}

.fpd-container fpd-module-products.fpd-categories-enabled .fpd-product-categories {
  display: flex
}

.fpd-container fpd-module-text .fpd-add-text {
  padding: 10px
}

.fpd-container fpd-module-text .fpd-add-text input {
  padding: 3px 5px;
  width: 80px;
  display: block
}

.fpd-container fpd-module-text .fpd-add-text .fpd-btn {
  margin-top: 10px;
  margin-bottom: 20px
}

.fpd-container fpd-module-text .fpd-text-templates .fpd-grid {
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-text .fpd-text-templates .fpd-grid .fpd-item {
  background: var(--fpd-module-secondary-color);
  text-align: center;
  position: relative;
  border-radius: var(--fpd-border-radius)
}

.fpd-container fpd-module-text .fpd-text-templates .fpd-grid .fpd-item>div {
  font-size: 16px;
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.fpd-container fpd-module-text .fpd-text-templates .fpd-grid .fpd-item:hover {
  opacity: .8
}

.fpd-container fpd-module-designs {
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-designs .fpd-head {
  display: none
}

.fpd-container fpd-module-designs.fpd-head-visible .fpd-head,
.fpd-container fpd-module-designs.fpd-single-cat .fpd-head {
  display: block;
  margin-bottom: 10px
}

.fpd-container fpd-module-designs.fpd-single-cat .fpd-back {
  display: none !important
}

.fpd-container fpd-module-designs .fpd-single-cat .fpd-input-search {
  width: 100%
}

.fpd-container fpd-module-designs .fpd-grid .fpd-item {
  border-radius: var(--fpd-border-radius)
}

.fpd-container fpd-module-text-to-image .fpd-head .fpd-info {
  margin: 0 0 10px;
  line-height: 20px;
  font-size: 14px
}

.fpd-container fpd-module-text-to-image .fpd-head .fpd-btn {
  margin: 0 0 20px
}

.fpd-container fpd-module-images .fpd-module-tabs-content {
  overflow: hidden;
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-images .fpd-module-tabs-content>div>* {
  height: 100%;
  display: flex;
  flex-flow: column
}

.fpd-container fpd-module-images .fpd-module-tabs-content>div>* .fpd-scroll-area {
  padding-right: 5px
}

.fpd-container fpd-module-uploads .fpd-upload-image {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  border: 2px dashed var(--fpd-border-color);
  background: var(--fpd-module-secondary-color);
  color: var(--fpd-module-secondary-text-color);
  border-radius: var(--fpd-border-radius);
  padding: 10px 10px 0;
  cursor: pointer;
  margin-bottom: 10px
}

.fpd-container fpd-module-uploads .fpd-upload-image>span {
  display: block;
  font-size: 10px;
  text-transform: uppercase;
  margin: 0 0 15px !important
}

.fpd-container fpd-module-uploads .fpd-upload-image>.fpd-price {
  font-size: 12px;
  line-height: 1
}

.fpd-container fpd-module-uploads .fpd-upload-image.fpd-hover {
  opacity: .5
}

.fpd-container fpd-module-uploads .fpd-grid .fpd-loading-bar {
  background: rgba(255, 255, 255, .7);
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 6px;
  transform: translate(-50%, -50%);
  z-index: 10
}

.fpd-container fpd-module-uploads .fpd-grid .fpd-loading-bar>.fpd-loading-progress {
  background: #fff;
  height: 100%;
  width: 0
}

.fpd-container fpd-module-uploads .fpd-image-quality-ratings {
  position: absolute;
  left: 5px;
  top: 5px;
  line-height: 1
}

.fpd-container fpd-module-uploads .fpd-image-quality-ratings>span {
  color: var(--fpd-image-quality-start-color);
  text-shadow: 0 0 1px rgba(0, 0, 0, .7);
  font-size: 18px
}

.fpd-container fpd-module-facebook-images .fpd-head {
  margin-bottom: 10px
}

.fpd-container fpd-module-facebook-images .fpd-head .fpd-facebook-albums {
  display: none
}

.fpd-container fpd-module-facebook-images.fpd-facebook-logged-in .fpd-facebook-login {
  display: none
}

.fpd-container fpd-module-facebook-images.fpd-facebook-logged-in .fpd-facebook-albums {
  display: block
}

.fpd-container fpd-module-pixabay-images {
  position: relative
}

.fpd-container fpd-module-pixabay-images .fpd-head {
  margin-bottom: 10px
}

.fpd-container fpd-module-pixabay-images .fpd-loader-wrapper {
  height: 100%
}

.fpd-container fpd-module-pixabay-images .fpd-pixabay-logo {
  background-repeat: no-repeat !important;
  border: none !important;
  background-color: transparent !important;
  width: 72px;
  height: 14px;
  display: block;
  margin-bottom: 10px;
  opacity: .6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important
}

.fpd-container fpd-module-manage-layers .fpd-list {
  padding: var(--fpd-module-content-padding);
  position: relative;
  min-height: 100%
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row {
  flex-wrap: wrap;
  margin: 10px 5px 10px 0;
  align-items: center;
  border: 1px solid transparent;
  border-radius: var(--fpd-border-radius);
  box-shadow: 0 0 10px rgba(110, 111, 114, .2)
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div {
  overflow: hidden;
  white-space: nowrap
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-0 {
  flex: 0 45px;
  text-align: center
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-0>.fpd-current-color {
  cursor: pointer;
  width: 25px;
  height: 25px;
  display: block;
  border-radius: var(--fpd-border-radius);
  margin: auto;
  border: 1px solid rgba(0, 0, 0, .1)
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 {
  padding-left: 0;
  padding-right: 0
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 textarea {
  border: 1px solid var(--fpd-border-color);
  min-height: auto;
  max-height: 30px;
  width: 100%;
  padding: 3px 5px !important;
  box-shadow: none;
  margin: 0
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 .fpd-img-meta {
  font-size: 11px;
  font-weight: 700
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 .fpd-img-meta span {
  font-weight: 400;
  margin-right: 5px
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2 {
  flex: 0 110px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span {
  padding-left: 8px;
  font-size: 18px;
  opacity: .7;
  transition: opacity .3s ease-out;
  flex: 1;
  flex-grow: 0
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span.fpd-icon-reorder {
  cursor: move
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span:first-child {
  padding: 0
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span:hover {
  opacity: 1
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span>* {
  vertical-align: top
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span>.fpd-icon-eye {
  font-size: 13.5px
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full {
  padding: 0 0 10px;
  display: none
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area.fpd-has-subpanel {
  max-height: none
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-color-palette,
.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-patterns-wrapper {
  padding: 0 10px
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-color-palette>.fpd-colorpicker-wrapper,
.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-patterns-wrapper>.fpd-colorpicker-wrapper {
  padding: 0
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row:hover {
  border-color: var(--fpd-border-color)
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-show-colors {
  background: var(--fpd-list-bg-color-active)
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-show-colors .fpd-cell-full {
  display: block
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-locked>div:nth-child(-n+2) {
  opacity: .2;
  pointer-events: none
}

.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-hide-dpi .fpd-dpi {
  display: none
}

.fpd-container fpd-module-qr-code .fpd-qr-code-colors {
  text-align: center
}

.fpd-container fpd-module-qr-code .fpd-qr-code-colors>.fpd-qr-code-color-dark,
.fpd-container fpd-module-qr-code .fpd-qr-code-colors>.fpd-qr-code-color-light {
  display: inline-block;
  padding: 12px;
  position: relative;
  border-radius: var(--fpd-border-radius);
  border: 2px solid rgba(0, 0, 0, .2);
  overflow: visible
}

.fpd-container fpd-module-save-load {
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-text-layers .fpd-list {
  position: relative;
  min-height: 100%;
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row {
  flex-wrap: wrap;
  margin: 0 0 10px;
  border-radius: var(--fpd-border-radius);
  box-shadow: 0 0 10px rgba(110, 111, 114, .2)
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>div {
  margin: 10px 8px;
  padding: 0;
  position: relative
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-title {
  color: var(--fpd-dark-grey-color);
  padding-left: 2px;
  margin-bottom: 0;
  font-size: 14px
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-cell-1 fpd-dropdown {
  height: 35px
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-cell-2 {
  flex: 0 0 60px
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-cell-2>input {
  text-align: center;
  height: 35px
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row .fpd-color-panel {
  margin-top: 10px
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row .fpd-color-panel .fpd-colorpicker-wrapper {
  padding: 0
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row .fpd-clear-text {
  position: absolute;
  right: 1px;
  top: 1px;
  font-size: 11px;
  line-height: 1;
  padding: 3px 4px;
  text-transform: uppercase;
  background: var(--fpd-module-secondary-color);
  border-bottom-left-radius: 2px;
  cursor: pointer;
  border-top-right-radius: var(--fpd-border-radius)
}

.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row input,
.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row textarea {
  margin: 0 !important;
  padding: 8px;
  width: 100%
}

.fpd-container fpd-module-layouts .fpd-grid {
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-layouts .fpd-grid>.fpd-item {
  border-radius: var(--fpd-border-radius);
  background-color: var(--fpd-module-secondary-color)
}

.fpd-container fpd-module-names-numbers {
  padding: var(--fpd-module-content-padding)
}

.fpd-container fpd-module-names-numbers .fpd-head .fpd-btn {
  margin: 0 0 20px
}

.fpd-container fpd-module-names-numbers .fpd-list {
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding-right: 10px
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-number-col {
  width: 50px
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-number-col input {
  text-align: center
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-name-col {
  flex: 1
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-select-col {
  width: 50px;
  position: relative
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-select-col select {
  position: relative;
  appearance: none;
  height: 100%;
  width: 100%;
  text-align: center;
  background: var(--fpd-light-bg-color);
  cursor: pointer;
  padding-right: 10px
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-select-col:after {
  content: "\\e90e";
  font-family: FontFPD !important;
  font-size: 16px;
  position: absolute;
  top: 50%;
  right: 2px;
  pointer-events: none;
  transform: translateY(-50%)
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-remove-col {
  flex: 1 100%;
  text-align: right;
  font-size: 10px;
  line-height: 1;
  color: var(--fpd-red-color);
  order: 3
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-remove-col>span {
  opacity: .7;
  text-transform: uppercase;
  cursor: pointer
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-remove-col>span:hover {
  opacity: 1
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-input-col:nth-child(2)>* {
  border-top-left-radius: var(--fpd-border-radius);
  border-bottom-left-radius: var(--fpd-border-radius);
  border-left: 1px solid var(--fpd-border-color)
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-input-col:last-child>* {
  border-top-right-radius: var(--fpd-border-radius);
  border-bottom-right-radius: var(--fpd-border-radius)
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row input,
.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row select {
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  border: 1px solid var(--fpd-border-color);
  width: 100%;
  border-left: none
}

.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row:first-child>.fpd-remove-col {
  visibility: hidden
}

.fpd-bulk-variations {
  margin: 20px 0
}

.fpd-bulk-variations>.fpd-head {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px
}

.fpd-bulk-variations>.fpd-head>.fpd-headline {
  font-size: 18px
}

.fpd-bulk-variations .fpd-variations-list {
  display: flex;
  flex-flow: column wrap;
  gap: 20px
}

.fpd-bulk-variations .fpd-variations-list .fpd-row {
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;
  height: 40px;
  align-items: center
}

.fpd-bulk-variations .fpd-variations-list .fpd-row>select {
  flex: 1;
  font-size: 16px;
  padding: 0 5px;
  height: 100%
}

.fpd-bulk-variations .fpd-variations-list .fpd-row>select.fpd-error {
  border-color: var(--fpd-red-color)
}

.fpd-bulk-variations .fpd-variations-list .fpd-row>input {
  width: 50px;
  height: 100%;
  margin: 0;
  text-align: center
}

.fpd-bulk-variations .fpd-variations-list .fpd-row>span {
  display: inline-block;
  width: 30px;
  cursor: pointer;
  font-size: 14px;
  text-align: center
}

.fpd-bulk-variations .fpd-variations-list .fpd-row:first-child span {
  display: none
}

.fpd-color-selection {
  margin: 20px 0;
  display: flex;
  flex-flow: column wrap;
  gap: 20px
}

.fpd-color-selection .fpd-cs-item .fpd-title {
  font-size: 16px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--fpd-border-color)
}

.fpd-color-selection .fpd-cs-item .fpd-color-palette,
.fpd-color-selection .fpd-cs-item .fpd-patterns-wrapper {
  margin: 10px 0
}

.fpd-color-selection .fpd-cs-item .fpd-color-palette .fpd-item,
.fpd-color-selection .fpd-cs-item .fpd-patterns-wrapper .fpd-item {
  width: 45px;
  height: 45px;
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2)
}

.fpd-color-selection .fpd-cs-item .fpd-color-panel>.fpd-scroll-area>.fpd-color-palette .fpd-item:after {
  position: absolute;
  color: rgba(0, 0, 0, .6);
  background: rgba(255, 255, 255, .95);
  bottom: -2px;
  line-height: 1;
  width: calc(100% + 4px);
  left: -2px;
  text-transform: uppercase;
  font-size: 10px;
  content: attr(aria-label);
  padding: 4px 0;
  text-align: center
}

.fpd-container.fpd-gt-step {
  width: 320px;
  padding: 15px;
  position: fixed;
  top: 0;
  left: 0;
  color: #fff;
  z-index: 100;
  margin-top: 15px;
  margin-left: -24px;
  z-index: 100000000000;
  background: var(--fpd-tooltip-bg-color)
}

.fpd-container.fpd-gt-step>.fpd-gt-pointer {
  font-size: 50px;
  position: absolute;
  top: -16px;
  left: 0;
  color: var(--fpd-tooltip-bg-color);
  transform: scaleY(-1)
}

.fpd-container.fpd-gt-step .fpd-gt-close {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  cursor: pointer;
  z-index: 10
}

.fpd-container.fpd-gt-step .fpd-gt-text {
  padding-right: 15px
}

.fpd-container.fpd-gt-step .fpd-gt-actions {
  margin-top: 20px
}

.fpd-container.fpd-gt-step .fpd-gt-actions>.fpd-btn {
  margin: 0;
  float: right;
  margin-left: 5px;
  font-size: 12px;
  padding: 3px 10px
}

.fpd-container.fpd-gt-step .fpd-gt-actions>.fpd-gt-counter {
  line-height: 34px;
  font-size: 12px;
  opacity: .5
}

.fpd-3d-preview-wrapper {
  background: #fff;
  color: rgba(0, 0, 0, .5);
  box-shadow: rgba(0, 0, 0, .15) 0 5px 15px 0;
  position: relative
}

.fpd-3d-preview-wrapper:after {
  content: "3D";
  position: absolute;
  left: 5px;
  top: 5px
}

.fpd-3d-preview-wrapper .fpd-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%)
}

.fpd-3d-preview-wrapper>canvas {
  outline: 0;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.fpd-3d-preview-wrapper .fpd-touch-info {
  z-index: 100;
  position: absolute;
  left: 5px;
  bottom: 5px;
  width: 64px;
  height: 64px;
  background-size: 40%;
  background-position: left bottom;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
}

fpd-main-wrapper .fpd-3d-preview-wrapper {
  display: block;
  box-shadow: rgba(0, 0, 0, .15) 0 5px 15px 0;
  background: #fff;
  color: rgba(0, 0, 0, .5);
  z-index: 100;
  position: absolute;
  bottom: 0;
  left: 0
}

fpd-main-wrapper .fpd-3d-preview-wrapper.fpd-fullscreen>.fpd-fullscreen-toggle {
  padding: 4px
}

fpd-main-wrapper .fpd-3d-preview-wrapper.fpd-fullscreen>.fpd-fullscreen-toggle>span:first-child {
  display: none
}

fpd-main-wrapper .fpd-3d-preview-wrapper.fpd-fullscreen>.fpd-fullscreen-toggle>span:last-child {
  display: inline
}

fpd-main-wrapper .fpd-3d-preview-wrapper>.fpd-fullscreen-toggle {
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  font-size: 18px;
  z-index: 10
}

fpd-main-wrapper .fpd-3d-preview-wrapper>.fpd-fullscreen-toggle>span:last-child {
  display: none
}

.fpd-view-thumbnails-wrapper {
  display: flex;
  gap: 15px;
  margin: 20px 0;
  flex-wrap: wrap
}

.fpd-view-thumbnails-wrapper>.fpd-item {
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  border-radius: 8px;
  cursor: pointer;
  background-color: rgba(255, 255, 252, .9)
}

fpd-main-wrapper>.fpd-view-thumbnails-wrapper {
  position: absolute;
  left: 10px;
  bottom: calc(10px + env(safe-area-inset-bottom));
  margin: 0;
  z-index: 21
}

fpd-main-wrapper>.fpd-view-thumbnails-wrapper .fpd-item {
  height: 70px;
  flex-basis: 60px
}

.fpd-wrapper.fpd-views-inside-left fpd-main-wrapper>.fpd-view-thumbnails-wrapper {
  right: 10px;
  left: auto;
  justify-content: flex-end
}`, "",{"version":3,"sources":["webpack://./src/assets/css/FancyProductDesigner.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,oCAAoC;EACpC,0BAA0B;EAC1B,sDAAsD;EACtD,uDAAuD;EACvD,0BAA0B;EAC1B,mDAAmD;EACnD,2DAA2D;EAC3D,2BAA2B;EAC3B,2CAA2C;EAC3C,+CAA+C;EAC/C,0CAA0C;EAC1C,0CAA0C;EAC1C,uBAAuB;EACvB,0CAA0C;EAC1C,+CAA+C;EAC/C,iCAAiC;EACjC,wBAAwB;EACxB,iDAAiD;EACjD,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,oDAAoD;EACpD,8BAA8B;EAC9B,0DAAkiI;EACliI,0CAA0C;EAC1C,yBAAyB;EACzB,kCAAkC;EAClC,uDAAuD;EACvD,wDAAwD;EACxD;AACF;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ;AACF;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,2CAA2C;EAC3C;AACF;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB;AACF;;AAEA;EACE,kDAAkD;EAClD,2BAA2B;EAC3B,mBAAmB;EACnB;AACF;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B;AACF;;AAEA;EACE,wBAAwB;EACxB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oCAAoC;EACpC;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,YAAY;EACZ,+EAA+E;EAC/E,0BAA0B;EAC1B,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B;AACF;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;;EAEE,wCAAwC;EACxC,wCAAwC;EACxC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,uCAAuC;EACvC;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB;AACF;;AAEA;;EAEE,uCAAuC;EACvC;AACF;;AAEA;;EAEE,WAAW;EACX;AACF;;AAEA;;EAEE,kCAAkC;EAClC,4CAA4C;EAC5C,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,4CAA4C;EAC5C;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC;AACF;;AAEA;EACE,4CAA4C;EAC5C;AACF;;AAEA;;EAEE,aAAa;EACb,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;;EAEE,OAAO;EACP,2BAA2B;EAC3B,SAAS;EACT,cAAc;EACd,cAAc;EACd;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B;AACF;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;EACvB,yCAAyC;EACzC,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,uCAAuC;EACvC,6BAA6B;EAC7B;AACF;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C;AACF;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;EACf,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,MAAM;EACN,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,oEAAoE;EACpE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;EACzD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB;AACF;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,oEAAoE;EACpE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yCAAyC;EACzC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,yCAAyC;EACzC;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,WAAW;EACX;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf;AACF;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,uCAAuC;EACvC,wBAAwB;EACxB,yBAAyB;EACzB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,MAAM;EACN,OAAO;EACP,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX;AACF;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,wDAAwD;EACxD,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB;AACF;;AAEA;;EAEE,UAAU;EACV,gCAAgC;EAChC;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kCAAkC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,UAAU;EACV;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,wBAAwB;EACxB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB;AACF;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B;AACF;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,MAAM;EACN,SAAS;EACT,UAAU;EACV,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,SAAS;EACT,YAAY;EACZ,OAAO;EACP,QAAQ;EACR;AACF;;AAEA;EACE,WAAW;EACX,UAAU;EACV;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,6CAA6C;EAC7C,+CAA+C;EAC/C,wBAAwB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,WAAW;EACX;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV;AACF;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,iBAAiB;EACjB;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,iDAAiD;EACjD,gBAAgB;EAChB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,gBAAgB;EAChB,QAAQ;EACR;AACF;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;;EAEE,iBAAiB;EACjB;AACF;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,iCAAiC;EACjC,kCAAkC;EAClC,4CAA4C;EAC5C,oCAAoC;EACpC,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iCAAiC;EACjC;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iCAAiC;EACjC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE,OAAO;EACP;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,QAAQ;EACR;AACF;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ;AACF;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,cAAc;EACd,0BAA0B;EAC1B;AACF;;AAEA;;EAEE,UAAU;EACV;AACF;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,0BAA0B;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB;AACF;;AAEA;EACE,OAAO;EACP;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,oEAAoE;EACpE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,QAAQ;EACR;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,kDAAkD;EAClD,qCAAqC;EACrC,8BAA8B;EAC9B;AACF;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,aAAa;EACb,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;EACpC,uCAAuC;EACvC,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;EAChD,WAAW;EACX,gBAAgB;EAChB,6CAA6C;EAC7C,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qCAAqC;EACrC,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,uCAAuC;EACvC,0BAA0B;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2BAA2B;EAC3B;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,gDAAgD;EAChD;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf;AACF;;AAEA;EACE,OAAO;EACP;AACF;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,gDAAgD;EAChD;AACF;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,iFAAiF;EACjF;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,8CAA8C;EAC9C,gDAAgD;EAChD,iDAAiD;EACjD,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,OAAO;EACP;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB;AACF;;AAEA;;EAEE,OAAO;EACP;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf;AACF;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB;AACF;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,SAAS;EACT;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;;EAEE,OAAO;EACP,yCAAyC;EACzC,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,uCAAuC;EACvC,2BAA2B;EAC3B,oBAAoB;EACpB,6CAA6C;EAC7C;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,2CAA2C;EAC3C;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB;AACF;;AAEA;EACE,OAAO;EACP;AACF;;AAEA;EACE;AACF;;AAEA;;;;;;;;;;EAUE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;EAC7C,6CAA6C;EAC7C,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR;AACF;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;EACvB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX;AACF;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uCAAuC;EACvC,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,OAAO;EACP;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,mCAAmC;EACnC;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV;AACF;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,8BAA8B;EAC9B,eAAe;EACf;AACF;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;EACvC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,SAAS;EACT;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gDAAgD;EAChD,mDAAmD;EACnD;AACF;;AAEA;EACE,iDAAiD;EACjD;AACF;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,yCAAyC;EACzC,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ;AACF;;AAEA;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,kCAAkC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,2CAA2C;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR;AACF;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gDAAgD;EAChD,SAAS;EACT;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX,UAAU;EACV;AACF","sourcesContent":[":root {\n  --fpd-primary-color: #485563;\n  --fpd-primary-fg-color: #fff;\n  --fpd-secondary-color: #029EEB;\n  --fpd-secondary-fg-color: #fff;\n  --fpd-light-bg-color: #F6F6F6;\n  --fpd-light-grey-color: #EBEBEB;\n  --fpd-dark-grey-color: #989898;\n  --fpd-red-color: #bd081c;\n  --fpd-yellow-color: #fffaf3;\n  --fpd-yellow-contrast-color: #654c21;\n  --fpd-green-color: #2ecc71;\n  --fpd-scrollbar-track-color: var(--fpd-light-bg-color);\n  --fpd-scrollbar-thumb-color: var(--fpd-dark-grey-color);\n  --fpd-scrollbar-width: 6px;\n  --fpd-btn-primary-color: var(--fpd-secondary-color);\n  --fpd-btn-primary-text-color: var(--fpd-secondary-fg-color);\n  --fpd-dropdown-height: 40px;\n  --fpd-snackbar-bg-color: rgba(0, 0, 0, 0.9);\n  --fpd-list-bg-color-active: rgba(0, 0, 0, 0.04);\n  --fpd-input-text-color: rgba(0, 0, 0, 0.7);\n  --fpd-tooltip-bg-color: rgba(0, 0, 0, 0.9);\n  --fpd-track-height: 8px;\n  --fpd-text-color: var(--fpd-primary-color);\n  --fpd-border-color: var(--fpd-light-grey-color);\n  --fpd-container-min-height: 500px;\n  --fpd-border-radius: 6px;\n  --fpd-mainbar-nav-color: var(--fpd-primary-color);\n  --fpd-sidebar-width: 400px;\n  --fpd-sidebar-nav-width: 80px;\n  --fpd-topbar-nav-height: 70px;\n  --fpd-off-canvas-width: 350px;\n  --fpd-actions-bar-bg-color: var(--fpd-primary-color);\n  --fpd-actions-bar-height: 50px;\n  --fpd-loading-svg: url(data:image/svg+xml;base64,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);\n  --fpd-canvas-bg: var(--fpd-light-bg-color);\n  --fpd-et-max-width: 375px;\n  --fpd-module-content-padding: 10px;\n  --fpd-module-secondary-color: var(--fpd-light-bg-color);\n  --fpd-module-secondary-text-color: var(--fpd-text-color);\n  --fpd-image-quality-start-color: #FFE790\n}\n\n.fpd-container *,\n.fpd-container:after,\n.fpd-container:before {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  max-width: 100%;\n  list-style-type: none;\n  text-shadow: none;\n  outline: 0;\n  line-height: 20px;\n  border: none;\n  box-sizing: border-box\n}\n\n.fpd-container input {\n  -webkit-appearance: none;\n  appearance: none;\n  height: auto;\n  background: 0 0 !important;\n  outline: 0 !important\n}\n\n.fpd-container textarea {\n  background: 0 0;\n  outline: 0 !important\n}\n\n.fpd-container input::-webkit-inner-spin-button,\n.fpd-container input::-webkit-outer-spin-button {\n  appearance: none\n}\n\n.fpd-wrapper {\n  display: flex;\n  flex-flow: row wrap;\n  max-width: 100%;\n  position: relative;\n  color: var(--fpd-text-color)\n}\n\n.fpd-container.fpd-not-responsive,\n.fpd-container.fpd-not-responsive * {\n  max-width: none !important\n}\n\n.fpd-container.fpd-not-responsive * .fpd-product-stage,\n.fpd-container.fpd-not-responsive .fpd-product-stage {\n  overflow: auto\n}\n\n.fpd-container .fpd-scroll-area {\n  height: 100%;\n  overflow: auto;\n  overscroll-behavior: none;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: var(--fpd-scrollbar-width);\n  scrollbar-color: var(--fpd-scrollbar-thumb-color) var(--fpd-scrollbar-track-color)\n}\n\n.fpd-container .fpd-scroll-area::-webkit-scrollbar {\n  width: var(--fpd-scrollbar-width);\n  height: var(--fpd-scrollbar-width);\n  padding-right: 5px;\n  margin-right: 5px\n}\n\n.fpd-container .fpd-scroll-area::-webkit-scrollbar-track {\n  background-color: var(--fpd-scrollbar-track-color);\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  margin: 20px\n}\n\n.fpd-container .fpd-scroll-area::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: var(--fpd-scrollbar-thumb-color)\n}\n\n.fpd-scrollbar-hidden {\n  overscroll-behavior: none;\n  -ms-overflow-style: none;\n  scrollbar-width: none\n}\n\n.fpd-scrollbar-hidden::-webkit-scrollbar {\n  display: none\n}\n\ntextarea[data-fabric-hiddentextarea] {\n  font-size: 16px !important;\n  transform: translateY(-20px);\n  caret-color: transparent\n}\n\n.fpd-disabled {\n  opacity: .2 !important;\n  cursor: default !important;\n  pointer-events: none !important\n}\n\nbody .fpd-hidden {\n  display: none !important;\n  pointer-events: none !important\n}\n\n.fpd-overflow-hidden {\n  overflow: hidden !important\n}\n\n.fpd-hidden-canvas {\n  position: absolute !important;\n  left: -9999999px\n}\n\n[class^=fpd-icon-]:before {\n  color: inherit !important\n}\n\nbody .fpd-visible-hidden {\n  visibility: hidden !important;\n  pointer-events: none !important\n}\n\nbody fpd-dropdown {\n  position: relative;\n  display: flex;\n  height: var(--fpd-dropdown-height)\n}\n\nbody fpd-dropdown>.fpd-dropdown-current {\n  height: 100%;\n  width: 100% !important;\n  padding: 7px 20px 7px 7px !important;\n  margin: 0 !important\n}\n\nbody fpd-dropdown>.fpd-dropdown-arrow {\n  position: absolute;\n  font-size: 20px;\n  right: 2px;\n  top: calc(50% - 10px);\n  opacity: .6;\n  text-align: center;\n  width: 20px;\n  height: 20px;\n  transform-origin: center center;\n  transition: all .2s ease-out;\n  cursor: pointer\n}\n\nbody fpd-dropdown .fpd-dropdown-list {\n  display: none;\n  position: fixed;\n  padding-right: 5px;\n  left: 0;\n  top: 0;\n  background: #fff;\n  z-index: 100;\n  box-shadow: 0 2px 0 1px rgba(64, 87, 109, .07), 0 2px 12px rgba(53, 71, 90, .2);\n  transform: translateY(2px);\n  border-radius: 4px;\n  max-height: 200px\n}\n\nbody fpd-dropdown .fpd-dropdown-list>.fpd-scroll-area {\n  max-height: inherit;\n  padding: 0 !important\n}\n\nbody fpd-dropdown .fpd-dropdown-list .fpd-item {\n  display: block;\n  text-align: left;\n  margin: 5px;\n  padding: 10px;\n  line-height: 14px;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 4px\n}\n\nbody fpd-dropdown .fpd-dropdown-list .fpd-item:hover {\n  background: rgba(0, 0, 0, .05)\n}\n\nbody fpd-dropdown input:focus~.fpd-dropdown-list,\nbody fpd-dropdown.fpd-active .fpd-dropdown-list {\n  display: block;\n  border: 1px solid var(--fpd-border-color)\n}\n\nbody fpd-dropdown input:focus~.fpd-dropdown-arrow,\nbody fpd-dropdown.fpd-active>.fpd-dropdown-arrow {\n  transform: rotate(90deg)\n}\n\nbody fpd-dropdown.fpd-on-loading .fpd-dropdown-arrow {\n  display: none !important\n}\n\nbody fpd-dropdown.fpd-on-loading>input.fpd-dropdown-current {\n  background-size: 20px;\n  background-repeat: no-repeat;\n  background-position: 98% center;\n  background-image: var(--fpd-loading-svg)\n}\n\n.fpd-container .fpd-loader-wrapper {\n  background: rgba(255, 255, 255, .9);\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100\n}\n\n.fpd-loader-wrapper>.fpd-loader {\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%)\n}\n\n.fpd-loader>.fpd-loader-text {\n  position: absolute;\n  width: 100%;\n  display: block;\n  font-size: 14px;\n  padding: 20px 0;\n  color: rgba(0, 0, 0, .5);\n  text-transform: uppercase;\n  font-weight: lighter;\n  letter-spacing: 1.5px;\n  -webkit-filter: blur(0)\n}\n\n.fpd-loader>.fpd-loader-circle {\n  margin: 0 auto;\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(0, 0, 0, .2);\n  border-left: 3px solid #000;\n  transform: translateZ(0);\n  animation: fpd-loader-animation 1.1s infinite linear\n}\n\n.fpd-loader>.fpd-loader-circle,\n.fpd-loader>.fpd-loader-circle:after {\n  border-radius: 50%\n}\n\n@-webkit-keyframes fpd-loader-animation {\n  0% {\n    transform: rotate(0)\n  }\n\n  100% {\n    transform: rotate(360deg)\n  }\n}\n\n@keyframes fpd-loader-animation {\n  0% {\n    transform: rotate(0)\n  }\n\n  100% {\n    transform: rotate(360deg)\n  }\n}\n\n.fpd-container .fpd-btn,\n.fpd-modal-inner .fpd-btn {\n  background: var(--fpd-btn-primary-color);\n  color: var(--fpd-btn-primary-text-color);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 15px;\n  font-size: 14px;\n  margin: 10px 0;\n  text-transform: uppercase;\n  border-radius: var(--fpd-border-radius);\n  transition: all .2s ease-out\n}\n\n.fpd-container .fpd-btn:hover,\n.fpd-modal-inner .fpd-btn:hover {\n  opacity: .8\n}\n\n.fpd-container .fpd-btn.fpd-loading,\n.fpd-modal-inner .fpd-btn.fpd-loading {\n  background-image: var(--fpd-loading-svg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 30%;\n  opacity: .8;\n  color: transparent;\n  cursor: wait\n}\n\n.fpd-container .fpd-btn.fpd-secondary,\n.fpd-modal-inner .fpd-btn.fpd-secondary {\n  background: var(--fpd-light-grey-color);\n  color: var(--fpd-dark-grey-color)\n}\n\n.fpd-container .fpd-btn.fpd-full,\n.fpd-modal-inner .fpd-btn.fpd-full {\n  width: 100%;\n  justify-content: center\n}\n\nbody .fpd-container input,\nbody .fpd-container textarea {\n  color: var(--fpd-input-text-color);\n  box-shadow: 0 0 4px rgba(110, 111, 114, .22);\n  border: none;\n  border-radius: var(--fpd-border-radius);\n  padding: 10px;\n  margin-bottom: 10px;\n  appearance: none;\n  -moz-appearance: textfield;\n  resize: none;\n  font-size: 16px;\n  border: 1px solid transparent\n}\n\nbody .fpd-container input[type=text],\nbody .fpd-container textarea[type=text] {\n  width: 100%\n}\n\nbody .fpd-container input:focus,\nbody .fpd-container textarea:focus {\n  box-shadow: 0 0 4px rgba(110, 111, 114, .22);\n  border: 1px solid var(--fpd-secondary-color)\n}\n\nbody .fpd-container textarea {\n  width: 100%;\n  min-height: 100px\n}\n\nbody .fpd-container select {\n  box-shadow: 0 0 4px rgba(110, 111, 114, .22);\n  border-radius: var(--fpd-border-radius);\n  border: 1px solid transparent\n}\n\nbody .fpd-container select:focus {\n  box-shadow: 0 0 4px rgba(110, 111, 114, .22);\n  border: 1px solid var(--fpd-secondary-color)\n}\n\nbody .fpd-container .fpd-input-back-search,\nbody .fpd-container .fpd-input-search {\n  display: flex;\n  box-shadow: 0 0 4px rgba(110, 111, 114, .22);\n  height: 40px;\n  border-radius: 4px;\n  flex: 1\n}\n\nbody .fpd-container .fpd-input-back-search input,\nbody .fpd-container .fpd-input-search input {\n  flex: 1;\n  box-shadow: none !important;\n  margin: 0;\n  padding: 0 5px;\n  line-height: 1;\n  border: none !important\n}\n\nbody .fpd-container .fpd-input-back-search span,\nbody .fpd-container .fpd-input-search span {\n  width: 20px;\n  align-self: center;\n  text-align: center;\n  font-size: 16px;\n  margin-right: 5px\n}\n\nbody .fpd-container .fpd-input-back-search .fpd-input-search {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  box-shadow: none !important\n}\n\nbody .fpd-container .fpd-input-back-search .fpd-back {\n  color: var(--fpd-module-secondary-text-color);\n  border: none !important;\n  background: rgba(0, 0, 0, .03) !important;\n  line-height: 1;\n  padding: 9px 8px !important;\n  display: inline-block;\n  width: 32px;\n  height: 100%;\n  text-align: center;\n  margin: 0 !important;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0\n}\n\nbody .fpd-container .fpd-input {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  box-shadow: 0 0 4px rgba(110, 111, 114, .22);\n  overflow: hidden;\n  border-radius: var(--fpd-border-radius);\n  border: 1px solid transparent;\n  height: auto\n}\n\nbody .fpd-container .fpd-input [class^=fpd-icon-],\nbody .fpd-container .fpd-input span {\n  padding: 2px 6px;\n  flex: 0 30px;\n  margin-right: 5px;\n  text-align: center;\n  border-right: 1px solid var(--fpd-border-color)\n}\n\nbody .fpd-container .fpd-input span {\n  flex: 0 auto;\n  text-align: left;\n  white-space: nowrap\n}\n\nbody .fpd-container .fpd-input input {\n  box-shadow: none;\n  margin: 0;\n  padding: 5px;\n  flex: 1;\n  width: 100%;\n  border-radius: 0;\n  border: none !important\n}\n\nbody .fpd-container .fpd-input fpd-range-slider {\n  flex-basis: 100%\n}\n\nbody .fpd-container .fpd-input .fpd-slider-number {\n  flex: 0 70px;\n  text-align: center;\n  border: 1px solid var(--fpd-border-color) !important;\n  border-radius: var(--fpd-border-radius);\n  margin: 3px 3px 3px 5px\n}\n\nbody .fpd-container .fpd-input .fpd-slider-number:focus {\n  border-color: var(--fpd-secondary-color) !important\n}\n\n.fpd-container .fpd-module-tabs {\n  display: flex;\n  background: var(--fpd-module-secondary-color);\n  color: var(--fpd-module-secondary-text-color)\n}\n\n.fpd-container .fpd-module-tabs>div {\n  flex: 1;\n  text-align: center;\n  cursor: pointer;\n  padding: 8px 0;\n  font-size: 20px\n}\n\n.fpd-container .fpd-module-tabs>div:hover {\n  background: rgba(0, 0, 0, .03)\n}\n\n.fpd-container .fpd-module-tabs>div.fpd-active {\n  background: var(--fpd-primary-fg-color);\n  color: var(--fpd-secondary-color)\n}\n\n.fpd-container .fpd-module-tabs>div>span {\n  pointer-events: none\n}\n\n.fpd-container .fpd-module-tabs-content {\n  height: 100%\n}\n\n.fpd-container .fpd-module-tabs-content>div {\n  display: none;\n  height: 100%\n}\n\n.fpd-container .fpd-module-tabs-content>div.fpd-active {\n  display: block\n}\n\n.fpd-sidebar .fpd-module-tabs {\n  top: 50px\n}\n\n.fpd-hide-tabs .fpd-module-tabs {\n  display: none !important\n}\n\n.fpd-snackbar-wrapper {\n  position: fixed;\n  left: 12px;\n  bottom: 0;\n  z-index: 100000\n}\n\n.fpd-snackbar-wrapper .fpd-snackbar {\n  background: var(--fpd-snackbar-bg-color);\n  margin-bottom: 10px;\n  color: #fff;\n  line-height: 18px;\n  font-size: 14px;\n  min-width: 288px;\n  max-width: 568px;\n  overflow-y: hidden;\n  border-radius: 2px;\n  -webkit-transition: all .3s ease-out;\n  transition: all .3s ease-out\n}\n\n.fpd-snackbar-wrapper .fpd-snackbar p {\n  margin: 0;\n  padding: 16px 24px\n}\n\n.fpd-snackbar-wrapper .fpd-snackbar.fpd-show-up {\n  max-height: 300px\n}\n\n.fpd-modal-overlay {\n  position: absolute !important;\n  width: 100% !important;\n  bottom: 0 !important;\n  right: 0 !important;\n  top: 0 !important;\n  left: 0 !important;\n  background: rgba(0, 0, 0, .5);\n  z-index: 10000;\n  overflow: auto\n}\n\n.fpd-modal-overlay>.fpd-modal-inner {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  width: 450px;\n  min-height: 200px;\n  position: absolute;\n  left: 50%;\n  top: 30%;\n  padding: 40px;\n  z-index: 10020;\n  max-width: 100%;\n  transform: translateX(-50%);\n  box-sizing: border-box;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-modal-overlay>.fpd-modal-inner>.fpd-modal-close {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  font-size: 16px;\n  cursor: pointer;\n  opacity: .6;\n  transition: opacity .2s ease-out\n}\n\n.fpd-modal-overlay>.fpd-modal-inner>.fpd-modal-close:hover {\n  opacity: 1\n}\n\n.fpd-modal-overlay>.fpd-modal-inner>.fpd-modal-content {\n  flex: 1 100%;\n  text-align: center;\n  color: rgba(0, 0, 0, .7);\n  line-height: 22px;\n  word-break: break-word\n}\n\n.fpd-modal-overlay.fpd-fullscreen>.fpd-modal-inner {\n  width: 100%;\n  height: 100%;\n  top: 0;\n  overflow: auto;\n  border-radius: 0\n}\n\n.fpd-modal-overlay.fpd-modal-internal {\n  z-index: 10000000000\n}\n\n.fpd-modal-overlay.fpd-modal-product-designer,\n.fpd-overflow-hidden .fpd-modal-overlay {\n  position: fixed !important\n}\n\n.fpd-modal-internal[data-type=prompt] input {\n  width: 100%;\n  display: block\n}\n\n.fpd-modal-internal[data-type=prompt] {\n  text-align: center\n}\n\n.fpd-modal-internal[data-type=confirm] {\n  text-align: center\n}\n\n.fpd-modal-internal .fpd-confirm-msg {\n  margin-bottom: 10px\n}\n\n.fpd-modal-product-designer {\n  display: none;\n  pointer-events: none;\n  overflow: hidden !important\n}\n\n.fpd-modal-product-designer.fpd-show {\n  display: block;\n  pointer-events: all\n}\n\n.fpd-modal-product-designer>.fpd-modal-inner {\n  padding: 0\n}\n\n.fpd-modal-product-designer>.fpd-modal-inner>.fpd-wrapper {\n  flex: 1 100%;\n  margin: 0 0 !important;\n  height: 100%;\n  box-shadow: none !important\n}\n\n.fpd-modal-product-designer>.fpd-modal-inner>.fpd-wrapper fpd-main-bar {\n  height: calc(100% - var(--fpd-actions-bar-height)) !important\n}\n\n.fpd-modal-product-designer>.fpd-modal-inner>.fpd-wrapper.fpd-layout-small fpd-main-wrapper {\n  height: calc(100% - var(--fpd-actions-bar-height) - var(--fpd-sidebar-nav-width)) !important\n}\n\nbody.fpd-modal-mode-active:not(.fpd-modal-designer-visible) fpd-element-toolbar {\n  display: none !important\n}\n\n.fpd-container .fpd-modal-content fpd-module-save-load {\n  padding: 0\n}\n\n.fpd-container .fpd-modal-content fpd-module-save-load .fpd-saved-designs {\n  max-height: 200px\n}\n\n.fpd-list {\n  width: 100%;\n  overflow: auto\n}\n\n.fpd-list>.fpd-list-row {\n  display: flex;\n  font-size: 15px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: background .3s ease-out\n}\n\n.fpd-list>.fpd-list-row>.fpd-cell-full {\n  flex: 1 100%\n}\n\n.fpd-list>.fpd-list-row>div {\n  padding: 22px 0;\n  flex: 1\n}\n\n.fpd-list .fpd-sortable-placeholder {\n  background: rgba(0, 0, 0, .05);\n  border: 2px dotted var(--fpd-border-color);\n  height: 65px\n}\n\n.fpd-container fpd-range-slider {\n  display: block;\n  margin-top: 3px\n}\n\n.fpd-container fpd-range-slider input[type=range] {\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  width: 100%\n}\n\n.fpd-container fpd-range-slider input[type=range]:focus {\n  outline: 0\n}\n\n.fpd-container fpd-range-slider input[type=range]::-webkit-slider-runnable-track {\n  height: var(--fpd-track-height);\n  border: 1px solid var(--fpd-border-color);\n  border-radius: 4px;\n  background: var(--fpd-light-bg-color)\n}\n\n.fpd-container fpd-range-slider input[type=range]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 1em;\n  background: #fff;\n  border: 2px solid var(--fpd-secondary-color);\n  margin-top: calc((var(--fpd-track-height) * .5 - 1px) - (20px * .5));\n  cursor: pointer\n}\n\n.fpd-container fpd-range-slider input[type=range]::-webkit-slider-thumb:hover {\n  scale: 1.2\n}\n\n.fpd-container fpd-range-slider.fpd-progress input[type=range] {\n  --range: calc(var(--max) - var(--min));\n  --ratio: calc((var(--value) - var(--min)) / var(--range));\n  --sx: calc(0.5 * 20px + var(--ratio) * (100% - 20px))\n}\n\n.fpd-container fpd-range-slider.fpd-progress input[type=range]::-webkit-slider-runnable-track {\n  background: linear-gradient(var(--fpd-secondary-color), var(--fpd-secondary-color)) 0/var(--sx) 100% no-repeat, var(--fpd-light-bg-color)\n}\n\n.fpd-container fpd-range-slider input[type=range]::-moz-range-track {\n  height: var(--fpd-track-height);\n  border: 1px solid var(--fpd-border-color);\n  border-radius: 4px;\n  background: var(--fpd-light-bg-color)\n}\n\n.fpd-container fpd-range-slider input[type=range]::-moz-range-thumb {\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 1em;\n  background: #fff;\n  border: 2px solid var(--fpd-secondary-color);\n  margin-top: calc((var(--fpd-track-height) * .5 - 1px) - (20px * .5));\n  cursor: pointer\n}\n\n.fpd-container fpd-range-slider input[type=range]::-moz-range-thumb:hover {\n  scale: 1.2\n}\n\n.fpd-container fpd-range-slider.fpd-progress input[type=range]::-moz-range-track {\n  background: linear-gradient(var(--fpd-secondary-color), var(--fpd-secondary-color)) 0/var(--sx) 100% no-repeat, var(--fpd-light-bg-color)\n}\n\n.fpd-container .fpd-color-panel>.fpd-scroll-area {\n  height: auto;\n  max-height: 100px;\n  margin-bottom: 10px\n}\n\n.fpd-container .fpd-color-panel>* {\n  margin-bottom: 10px\n}\n\n.fpd-container .fpd-color-panel>:last-child {\n  margin-bottom: 0\n}\n\n.fpd-container .picker_wrapper {\n  width: 100%;\n  box-shadow: none;\n  background: 0 0;\n  padding: 0\n}\n\n.fpd-container .picker_wrapper.popup {\n  width: 200px;\n  max-width: 200px;\n  padding: 10px;\n  display: flex;\n  min-height: 200px;\n  background: #f6f6f6;\n  margin: 0;\n  transform: translate(-50%, 10px);\n  border-radius: var(--fpd-border-radius);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12)\n}\n\n.fpd-container .picker_wrapper>* {\n  margin: 0 0 10px\n}\n\n.fpd-container .picker_wrapper .picker_sample,\n.fpd-container .picker_wrapper .picker_sl,\n.fpd-container .picker_wrapper .picker_slider {\n  box-shadow: none\n}\n\n.fpd-container .picker_wrapper .picker_selector {\n  border: 2px solid rgba(0, 0, 0, .4);\n  background: rgba(255, 255, 255, .5);\n  border-radius: 50%;\n  box-shadow: none;\n  width: 15px;\n  height: 15px;\n  padding: 0\n}\n\n.fpd-container .picker_wrapper .picker_sl {\n  margin-top: 0;\n  height: 100%;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container .picker_wrapper .picker_sl:before {\n  height: 100px;\n  padding: 0;\n  border: 1px solid var(--fpd-border-color);\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container .picker_wrapper .picker_sl .picker_selector {\n  transform-origin: center\n}\n\n.fpd-container .picker_wrapper .picker_hue {\n  order: 1;\n  height: 15px;\n  padding: 0;\n  border: 1px solid var(--fpd-border-color);\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container .picker_wrapper .picker_hue .picker_selector {\n  transform: translate(-50%, 0);\n  top: -1px\n}\n\n.fpd-container .picker_wrapper .picker_editor {\n  width: auto;\n  flex: 0 80%;\n  max-width: 100px;\n  margin-bottom: 0\n}\n\n.fpd-container .picker_wrapper .picker_editor input {\n  font-size: 16px;\n  height: 28px;\n  box-shadow: none !important;\n  border: 1px solid var(--fpd-border-color);\n  margin-bottom: 0\n}\n\n.fpd-container .picker_wrapper .picker_sample {\n  height: 28px;\n  cursor: pointer;\n  text-align: center;\n  flex: 0 30px;\n  margin-bottom: 0\n}\n\n.fpd-container .picker_wrapper .picker_sample:before {\n  border-radius: var(--fpd-border-radius);\n  border: 1px solid var(--fpd-border-color)\n}\n\n.fpd-container .picker_wrapper .picker_sample span {\n  position: relative;\n  display: inline-block;\n  margin-top: 3px;\n  font-size: 16px;\n  color: #fff;\n  text-shadow: 0 0 #000\n}\n\n.fpd-container .picker_wrapper .picker_arrow,\n.fpd-container .picker_wrapper .picker_done {\n  display: none\n}\n\n.fpd-container .fpd-colorpicker-wrapper {\n  position: relative;\n  padding: 0 10px;\n  width: 100%\n}\n\n.fpd-container .fpd-colorpicker-wrapper .fpd-scroll-area {\n  max-height: 100px;\n  overflow-x: hidden;\n  margin-top: 10px\n}\n\n.fpd-container .fpd-color-palette,\n.fpd-container .fpd-patterns-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px\n}\n\n.fpd-container .fpd-color-palette .fpd-item,\n.fpd-container .fpd-patterns-wrapper .fpd-item {\n  width: 24px;\n  height: 24px;\n  border: 2px solid rgba(0, 0, 0, .1);\n  border-radius: var(--fpd-border-radius);\n  transition: all .2s ease;\n  background-repeat: repeat;\n  cursor: pointer\n}\n\n.fpd-container .fpd-color-palette .fpd-item:hover,\n.fpd-container .fpd-patterns-wrapper .fpd-item:hover {\n  border-color: rgba(0, 0, 0, .2)\n}\n\n.fpd-container .fpd-color-palette.fpd-sub-show>.fpd-item,\n.fpd-container .fpd-patterns-wrapper.fpd-sub-show>.fpd-item {\n  scale: .7\n}\n\n.fpd-container .fpd-color-palette.fpd-sub-show>.fpd-item.fpd-active,\n.fpd-container .fpd-patterns-wrapper.fpd-sub-show>.fpd-item.fpd-active {\n  scale: 1\n}\n\n.fpd-container .fpd-has-subpanel>.fpd-color-palette>.fpd-scroll-area {\n  margin-top: 5px;\n  flex: 1 1 100%\n}\n\n.fpd-main-tooltip {\n  position: fixed;\n  background: var(--fpd-tooltip-bg-color);\n  color: #fff;\n  padding: 5px;\n  font-size: 14px;\n  min-width: 30px;\n  top: 0;\n  left: 0;\n  border-radius: var(--fpd-border-radius);\n  pointer-events: none;\n  transform: scale(0);\n  opacity: 0;\n  z-index: 10000000000;\n  visibility: hidden;\n  transition: transform .1s ease\n}\n\n.fpd-main-tooltip.fpd-show {\n  visibility: visible;\n  opacity: 1;\n  transform: scale(1)\n}\n\n.fpd-thumbnail-preview {\n  width: 350px;\n  height: 250px;\n  padding: 10px;\n  border-width: 1px;\n  background: #fff;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 9999999999999;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-thumbnail-preview.fpd-title-enabled {\n  padding-bottom: 30px\n}\n\n.fpd-thumbnail-preview>picture {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: top center\n}\n\n.fpd-thumbnail-preview>.fpd-preview-title {\n  position: absolute;\n  left: 0;\n  bottom: 5px;\n  width: 100%;\n  font-size: 14px;\n  text-align: center;\n  margin-top: 30px\n}\n\n.fpd-thumbnail-preview>.fpd-price {\n  background: rgba(0, 0, 0, .7);\n  position: absolute;\n  right: 20px;\n  top: 15px;\n  padding: 2px 5px 2px 7px;\n  font-size: 12px;\n  color: #fff;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-thumbnail-preview>.fpd-image-quality-ratings {\n  background: rgba(0, 0, 0, .7);\n  position: absolute;\n  left: 20px;\n  top: 15px;\n  border-radius: 4px;\n  padding: 2px 5px;\n  color: #fff;\n  text-align: left\n}\n\n.fpd-thumbnail-preview>.fpd-image-quality-ratings>span {\n  font-size: 18px;\n  color: var(--fpd-image-quality-start-color)\n}\n\n.fpd-thumbnail-preview>.fpd-image-quality-ratings>.fpd-image-quality-rating-label {\n  color: #fff;\n  display: block;\n  padding-top: 2px;\n  font-size: 10px;\n  text-transform: uppercase\n}\n\n.fpd-editor-box-wrapper {\n  margin: 20px 0;\n  background: rgba(0, 0, 0, .05);\n  padding: 10px\n}\n\n.fpd-editor-box-wrapper .fpd-eb-title {\n  font-size: 16px;\n  margin-bottom: 10px\n}\n\n.fpd-editor-box-wrapper .fpd-eb-grid {\n  display: flex;\n  flex-flow: row wrap\n}\n\n.fpd-editor-box-wrapper .fpd-eb-grid>div {\n  flex: 1 0 50%;\n  padding: 0 10px 0 0\n}\n\n.fpd-editor-box-wrapper .fpd-eb-grid>div span {\n  text-transform: uppercase\n}\n\n.fpd-dragged-image {\n  position: absolute;\n  background-size: 90%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: #fff;\n  width: 200px;\n  height: 200px;\n  top: 0;\n  left: 0;\n  cursor: move;\n  transition: transform .1s ease-in-out;\n  transform-origin: center center;\n  transform: scale(0);\n  z-index: 100000000000;\n  pointer-events: none\n}\n\n.fpd-dragged-image.fpd-animate {\n  transform: scale(1)\n}\n\n.fpd-container input.fpd-switch {\n  appearance: none;\n  background-color: var(--fpd-light-grey-color) !important;\n  border-radius: 70px;\n  border-style: none;\n  height: 20px;\n  margin: 0;\n  position: relative;\n  width: 35px;\n  box-shadow: none;\n  cursor: pointer\n}\n\n.fpd-container input.fpd-switch:before {\n  bottom: -6px;\n  content: \"\";\n  left: -6px;\n  position: absolute;\n  right: -6px;\n  top: -6px\n}\n\n.fpd-container input.fpd-switch:after {\n  background-color: #fff;\n  border-radius: 50%;\n  content: \"\";\n  height: 14px;\n  left: 3px;\n  position: absolute;\n  top: 3px;\n  width: 14px;\n  transition: all .1s ease-out\n}\n\n.fpd-container input.fpd-switch:hover {\n  opacity: .9;\n  transition-duration: 0s\n}\n\n.fpd-container input.fpd-switch:checked {\n  background-color: var(--fpd-secondary-color) !important\n}\n\n.fpd-container input.fpd-switch:checked:after {\n  background-color: #fff;\n  left: 18px\n}\n\n.fpd-container .fpd-switch-wrapper {\n  display: flex;\n  justify-content: center\n}\n\n.fpd-container .fpd-switch-wrapper label {\n  margin-left: 10px\n}\n\n.fpd-container .fpd-grid {\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: 100px;\n  gap: 0 0\n}\n\n.fpd-container .fpd-grid>.fpd-item {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-flow: column;\n  position: relative\n}\n\n.fpd-container .fpd-grid>.fpd-item>img,\n.fpd-container .fpd-grid>.fpd-item>picture {\n  opacity: 1;\n  transition: opacity .3s ease-out;\n  pointer-events: none\n}\n\n.fpd-container .fpd-grid>.fpd-item:hover>img,\n.fpd-container .fpd-grid>.fpd-item:hover>picture {\n  opacity: .8\n}\n\n.fpd-container .fpd-grid>.fpd-item>picture {\n  width: 90%;\n  height: 90%;\n  background-position: center center;\n  background-repeat: no-repeat\n}\n\n.fpd-container .fpd-grid>.fpd-item>.fpd-delete {\n  position: absolute;\n  font-size: 18px;\n  top: 5px;\n  right: 5px;\n  cursor: pointer\n}\n\n.fpd-container .fpd-grid>.fpd-item>.fpd-price {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  background: rgba(0, 0, 0, .7);\n  color: #fff;\n  font-size: 10px;\n  line-height: 1;\n  padding: 3px 4px;\n  border-radius: 2px\n}\n\n.fpd-container .fpd-grid>.fpd-item.fpd-loading picture {\n  filter: blur(2px)\n}\n\n.fpd-container .fpd-grid.fpd-grid-cover>.fpd-item>picture {\n  background-size: cover\n}\n\n.fpd-container .fpd-grid.fpd-grid-contain>.fpd-item>picture {\n  background-size: contain\n}\n\n.fpd-container .fpd-grid.fpd-photo-grid {\n  gap: 6px\n}\n\n.fpd-container .fpd-grid.fpd-photo-grid>.fpd-item>picture {\n  width: 100%;\n  height: 100%;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container .fpd-grid.fpd-padding {\n  gap: 5px\n}\n\n.fpd-container .fpd-grid>.fpd-category.fpd-item {\n  background: var(--fpd-module-secondary-color);\n  color: var(--fpd-module-secondary-text-color);\n  height: 100px !important;\n  border-radius: 2px\n}\n\n.fpd-container .fpd-grid>.fpd-category.fpd-item:nth-child(-n+2) {\n  margin-top: 0\n}\n\n.fpd-container .fpd-grid>.fpd-category.fpd-item:nth-child(2n+2) {\n  margin-right: 0\n}\n\n.fpd-container .fpd-grid>.fpd-category.fpd-item>picture {\n  height: 55%\n}\n\n.fpd-container .fpd-grid>.fpd-category.fpd-item>span {\n  text-transform: uppercase;\n  margin-top: 5px;\n  font-size: 10px;\n  text-align: center;\n  width: 100%;\n  white-space: nowrap\n}\n\n.fpd-container .fpd-grid>.fpd-category.fpd-item.fpd-title-centered>span {\n  bottom: 50%;\n  font-size: 14px;\n  white-space: normal;\n  transform: translateY(50%)\n}\n\n.fpd-grid>.fpd-item>picture.fpd-on-loading,\n.fpd-thumbnail-preview picture.fpd-on-loading {\n  width: 30px !important;\n  height: 30px !important;\n  background-size: auto;\n  background-image: var(--fpd-loading-svg)\n}\n\n.fpd-shadow-1 {\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .16), 0 2px 10px 0 rgba(0, 0, 0, .12)\n}\n\n.fpd-shadow-2 {\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19)\n}\n\n.fpd-shadow-3 {\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, .24), 0 17px 50px 0 rgba(0, 0, 0, .19)\n}\n\n.fpd-shadow-4 {\n  box-shadow: 0 16px 28px 0 rgba(0, 0, 0, .22), 0 25px 55px 0 rgba(0, 0, 0, .21)\n}\n\n.fpd-shadow-5 {\n  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, .2), 0 40px 77px 0 rgba(0, 0, 0, .22)\n}\n\n.fpd-shadow-6:after,\n.fpd-shadow-6:before {\n  z-index: -1;\n  position: absolute;\n  content: \"\";\n  bottom: 15px;\n  left: 10px;\n  width: 50%;\n  top: 80%;\n  max-width: 300px;\n  background: #777;\n  box-shadow: 0 15px 10px #777;\n  transform: rotate(-3deg)\n}\n\n.fpd-shadow-6:after {\n  transform: rotate(3deg);\n  right: 10px;\n  left: auto\n}\n\n.fpd-shadow-7 {\n  position: relative;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .3), 0 0 40px rgba(0, 0, 0, .1) inset\n}\n\n.fpd-shadow-7:after,\n.fpd-shadow-7:before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  box-shadow: 0 0 20px rgba(0, 0, 0, .8);\n  top: 50%;\n  bottom: 0;\n  left: 10px;\n  right: 10px;\n  border-radius: 100px/10px\n}\n\n.fpd-shadow-8 {\n  position: relative;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .3), 0 0 40px rgba(0, 0, 0, .1) inset\n}\n\n.fpd-shadow-8:after,\n.fpd-shadow-8:before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  box-shadow: 0 0 20px rgba(0, 0, 0, .8);\n  top: 0;\n  bottom: 0;\n  left: 10px;\n  right: 10px;\n  border-radius: 100px/10px\n}\n\n.fpd-shadow-8:after {\n  right: 10px;\n  left: auto;\n  transform: skew(8deg) rotate(3deg)\n}\n\n.fpd-shadow-9 {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .3), 0 0 40px rgba(0, 0, 0, .1) inset\n}\n\n.fpd-shadow-9:after,\n.fpd-shadow-9:before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  box-shadow: 0 0 20px rgba(0, 0, 0, .8);\n  top: 10px;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n  border-radius: 100px/10px\n}\n\n.fpd-shadow-9:after {\n  right: 10px;\n  left: auto;\n  transform: skew(8deg) rotate(3deg)\n}\n\n.mobile-close {\n  display: none;\n  width: 100%;\n  font-size: 18px;\n  text-align: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: auto;\n  bottom: auto;\n  height: 30px;\n  line-height: 30px;\n  background: var(--fpd-primary-fg-color);\n  z-index: 1000;\n  cursor: pointer;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  box-shadow: none;\n  border: none\n}\n\n.mobile-close:before {\n  content: \"\";\n  position: absolute;\n  height: 4px;\n  width: 60px;\n  background: var(--fpd-border-color);\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 2px\n}\n\n.mobile-close .fpd-icon-close {\n  display: none\n}\n\nfpd-main-bar {\n  display: flex;\n  position: relative;\n  background: var(--fpd-primary-fg-color)\n}\n\nfpd-main-bar>.fpd-close {\n  display: none;\n  position: absolute;\n  bottom: calc(var(--fpd-topbar-nav-height));\n  left: -100%;\n  width: 50px;\n  height: 50px;\n  padding: 0 15px;\n  line-height: 50px;\n  text-align: center;\n  font-size: 16px;\n  background: rgba(255, 255, 255, .96);\n  z-index: 99;\n  cursor: pointer;\n  border-top: 1px solid var(--fpd-border-color);\n  border-right: 1px solid var(--fpd-border-color);\n  border-radius: 0 4px 0 0;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, .1)\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item {\n  display: flex;\n  align-items: center;\n  margin: 15px 7px;\n  padding: 5px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: var(--fpd-border-radius);\n  background: 0 0;\n  transition: all .3s ease\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item .fpd-nav-icon:before {\n  color: var(--fpd-mainbar-nav-color)\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item svg {\n  width: 24px;\n  max-height: 30px;\n  vertical-align: middle\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item svg * {\n  fill: var(--fpd-mainbar-nav-color)\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item:hover {\n  opacity: .8\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active {\n  position: relative;\n  color: var(--fpd-secondary-color)\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active .fpd-nav-icon:before {\n  color: var(--fpd-secondary-color)\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active svg * {\n  fill: var(--fpd-secondary-color)\n}\n\nfpd-main-bar .fpd-navigation>.fpd-nav-item.fpd-active:before {\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--fpd-secondary-color);\n  opacity: .1;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container.fpd-sidebar .fpd-navigation {\n  flex: 0 0 var(--fpd-sidebar-nav-width);\n  overflow: auto\n}\n\n.fpd-container.fpd-sidebar .fpd-navigation>div>span {\n  padding: 10px 0;\n  display: inline-block;\n  font-size: 28px\n}\n\n.fpd-container.fpd-sidebar .fpd-navigation>div>.fpd-label {\n  display: block;\n  font-size: 12px;\n  line-height: 14px;\n  padding: 0;\n  word-break: break-word\n}\n\n.fpd-container.fpd-sidebar>fpd-main-bar {\n  height: 100%;\n  flex: 0 var(--fpd-sidebar-width);\n  overflow: hidden;\n  border-right: 1px solid var(--fpd-border-color)\n}\n\n.fpd-container.fpd-sidebar>fpd-main-bar .fpd-navigation {\n  border-right: 1px solid var(--fpd-border-color)\n}\n\n.fpd-container.fpd-sidebar>fpd-main-bar .fpd-navigation>.fpd-nav-item {\n  flex-direction: column\n}\n\n.fpd-container.fpd-sidebar>fpd-main-bar>.fpd-module-content {\n  flex: 1\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-medium {\n  --fpd-sidebar-width: 350px\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-wrapper {\n  order: 2;\n  flex-basis: 100%\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small:not(.fpd-no-modules-mode) fpd-main-wrapper {\n  margin-bottom: var(--fpd-sidebar-nav-width)\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar {\n  height: auto !important;\n  width: 100%;\n  flex-basis: auto;\n  flex-flow: row wrap;\n  z-index: 999999999999;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  overflow: visible;\n  border: none\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation {\n  display: flex;\n  flex: 1 0 100%;\n  height: var(--fpd-sidebar-nav-width);\n  min-height: auto;\n  order: 2;\n  align-self: flex-end;\n  border-right: none;\n  border-top: 1px solid var(--fpd-border-color)\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation>.fpd-nav-item {\n  flex: 1 0 auto;\n  white-space: nowrap;\n  padding: 0 20px;\n  margin: 5px 5px 8px\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation>.fpd-nav-item>span:first-child {\n  height: 45px;\n  padding-top: 10px;\n  padding-bottom: 0\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-navigation>.fpd-nav-item .fpd-label {\n  line-height: 1\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-module-content,\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-secondary-content {\n  padding-top: 30px;\n  flex: 1 0 100%;\n  height: calc(100% - var(--fpd-sidebar-nav-width));\n  min-height: auto;\n  display: none\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-close {\n  display: none;\n  width: 100%;\n  font-size: 18px;\n  text-align: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: auto;\n  bottom: auto;\n  height: 30px;\n  line-height: 30px;\n  background: var(--fpd-primary-fg-color);\n  z-index: 1000;\n  cursor: pointer;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  box-shadow: none;\n  border: none\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-close:before {\n  content: \"\";\n  position: absolute;\n  height: 4px;\n  width: 60px;\n  background: var(--fpd-border-color);\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 2px\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar>.fpd-close .fpd-icon-close {\n  display: none\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small fpd-main-bar:not(.fpd-no-modules-mode) .fpd-secondary-content {\n  height: 100%\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small.fpd-module-visible fpd-main-bar,\n.fpd-container.fpd-sidebar.fpd-layout-small.fpd-secondary-visible fpd-main-bar {\n  height: 100% !important\n}\n\n.fpd-container.fpd-sidebar.fpd-layout-small.fpd-module-visible .fpd-module-content {\n  display: block !important\n}\n\n.fpd-container.fpd-sidebar.fpd-secondary-visible .fpd-secondary-content {\n  display: block !important\n}\n\n.fpd-off-canvas fpd-main-bar,\n.fpd-topbar fpd-main-bar {\n  flex-basis: 100%;\n  order: 2;\n  height: auto !important\n}\n\n.fpd-off-canvas fpd-main-bar .fpd-navigation,\n.fpd-topbar fpd-main-bar .fpd-navigation {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  flex-basis: 100%;\n  height: var(--fpd-topbar-nav-height);\n  padding: 5px;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--fpd-border-color)\n}\n\n.fpd-off-canvas fpd-main-bar .fpd-navigation>div,\n.fpd-topbar fpd-main-bar .fpd-navigation>div {\n  height: 100%;\n  padding: 0 20px;\n  margin: 0;\n  white-space: nowrap;\n  flex-grow: 1;\n  flex-basis: auto\n}\n\n.fpd-off-canvas fpd-main-bar .fpd-navigation>div>span,\n.fpd-topbar fpd-main-bar .fpd-navigation>div>span {\n  line-height: 65px;\n  font-size: 26px\n}\n\n.fpd-off-canvas fpd-main-bar .fpd-navigation>div>.fpd-label,\n.fpd-topbar fpd-main-bar .fpd-navigation>div>.fpd-label {\n  font-size: 15px;\n  padding-left: 10px;\n  vertical-align: top;\n  text-transform: uppercase;\n  white-space: nowrap\n}\n\n.fpd-off-canvas fpd-main-bar>.fpd-module-content,\n.fpd-topbar fpd-main-bar>.fpd-module-content {\n  display: none\n}\n\n.fpd-topbar fpd-main-bar>.fpd-close {\n  display: none !important\n}\n\n.fpd-off-canvas {\n  overflow: hidden\n}\n\n.fpd-off-canvas fpd-main-bar {\n  order: 3\n}\n\n.fpd-off-canvas fpd-main-bar>.fpd-close {\n  display: block\n}\n\n.fpd-off-canvas fpd-main-bar .fpd-navigation {\n  border-top: 1px solid var(--fpd-border-color)\n}\n\n.fpd-off-canvas fpd-main-bar .fpd-module-content,\n.fpd-off-canvas fpd-main-bar .fpd-secondary-content {\n  height: var(--fpd-content-height);\n  width: var(--fpd-off-canvas-width);\n  left: calc(-2 * var(--fpd-off-canvas-width));\n  bottom: var(--fpd-topbar-nav-height);\n  border-right: 1px solid var(--fpd-border-color);\n  position: absolute;\n  display: block;\n  z-index: 100;\n  background: rgba(255, 255, 255, .96);\n  box-shadow: 2px 0 8px 0 rgba(0, 0, 0, .1)\n}\n\n.fpd-off-canvas fpd-main-bar.fpd-show .fpd-module-content {\n  left: 0\n}\n\n.fpd-off-canvas fpd-main-bar.fpd-show>.fpd-close {\n  left: var(--fpd-off-canvas-width);\n  margin-left: -1px\n}\n\n.fpd-off-canvas fpd-main-bar:not(.fpd-is-dragging) .fpd-close,\n.fpd-off-canvas fpd-main-bar:not(.fpd-is-dragging) .fpd-module-content {\n  transition: left .3s cubic-bezier(.215, .61, .355, 1)\n}\n\n.fpd-off-canvas.fpd-secondary-visible fpd-main-bar .fpd-secondary-content {\n  left: 0\n}\n\n.fpd-off-canvas.fpd-secondary-visible fpd-main-bar>.fpd-close {\n  left: var(--fpd-off-canvas-width);\n  margin-left: -1px\n}\n\n.fpd-off-canvas.fpd-layout-small fpd-main-bar .fpd-close {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  font-size: 12px;\n  padding: 0\n}\n\n.fpd-off-canvas.fpd-layout-small fpd-main-bar .fpd-module-content {\n  border: none\n}\n\n.fpd-module-content>* {\n  height: 100%;\n  display: none\n}\n\n.fpd-module-content>*>div {\n  height: 100%;\n  display: flex;\n  flex-flow: column\n}\n\n.fpd-module-content>.fpd-active {\n  display: block\n}\n\n.fpd-draggable-dialog {\n  display: none;\n  width: 350px;\n  height: 450px;\n  background: var(--fpd-primary-fg-color);\n  position: fixed !important;\n  left: calc(50% - 175px);\n  top: calc(45% - 200px);\n  min-width: 200px;\n  min-height: 100px;\n  z-index: 1000000;\n  border-radius: 2px;\n  max-width: 100%;\n  overflow: hidden;\n  border-radius: 6px\n}\n\n.fpd-draggable-dialog.fpd-show {\n  display: flex;\n  flex-flow: column nowrap\n}\n\n.fpd-draggable-dialog>.fpd-dialog-head {\n  background: var(--fpd-primary-color);\n  color: var(--fpd-primary-fg-color);\n  display: flex;\n  align-items: center;\n  height: 40px;\n  font-size: 15px;\n  padding: 0 0 0 12px;\n  cursor: move;\n  overflow: hidden;\n  white-space: nowrap\n}\n\n.fpd-draggable-dialog>.fpd-dialog-head>.fpd-dialog-drag-handle {\n  flex: 1;\n  overflow: hidden\n}\n\n.fpd-draggable-dialog>.fpd-dialog-head>.fpd-dialog-drag-handle .fpd-dialog-title {\n  margin-left: 6px;\n  text-transform: uppercase\n}\n\n.fpd-draggable-dialog>.fpd-dialog-head>.fpd-close-dialog {\n  font-size: 14px;\n  padding: 0 12px;\n  text-align: right;\n  cursor: pointer;\n  opacity: .8;\n  transition: opacity .2s ease-out\n}\n\n.fpd-draggable-dialog>.fpd-dialog-head>.fpd-close-dialog:hover {\n  opacity: 1\n}\n\n.fpd-draggable-dialog>.fpd-module-content {\n  flex: 1;\n  height: 100%;\n  overflow: hidden\n}\n\n.fpd-draggable-dialog.fpd-secondary-visible>.fpd-module-content {\n  display: none\n}\n\n.fpd-draggable-dialog.fpd-secondary-visible>.fpd-secondary-content {\n  display: block;\n  overflow: hidden\n}\n\n.fpd-wrapper.fpd-module-visible.fpd-layout-small fpd-main-bar .fpd-close,\n.fpd-wrapper.fpd-module-visible.fpd-off-canvas fpd-main-bar .fpd-close,\n.fpd-wrapper.fpd-secondary-visible.fpd-layout-small fpd-main-bar .fpd-close,\n.fpd-wrapper.fpd-secondary-visible.fpd-off-canvas fpd-main-bar .fpd-close {\n  display: block\n}\n\n.fpd-wrapper.fpd-secondary-visible fpd-main-bar .fpd-module-content {\n  display: none !important\n}\n\n.fpd-wrapper.fpd-products-module-hidden .fpd-navigation .fpd-nav-item[data-module=products] {\n  display: none !important\n}\n\n.fpd-wrapper.fpd-no-modules-mode fpd-main-bar .fpd-navigation,\n.fpd-wrapper.fpd-one-module-mode:not(.fpd-layout-small) fpd-main-bar .fpd-navigation {\n  display: none !important\n}\n\n.fpd-secondary-content {\n  display: none;\n  flex: 1\n}\n\n.fpd-secondary-content>* {\n  display: none\n}\n\n.fpd-secondary-content>.fpd-active {\n  display: block\n}\n\n.fpd-secondary-content .fpd-upload-zone-panel {\n  display: flex;\n  flex-flow: column;\n  height: 100%\n}\n\n.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content {\n  flex-basis: 100%;\n  overflow: hidden\n}\n\n.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content>* {\n  height: 100%;\n  display: none\n}\n\n.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content>.fpd-active {\n  display: block\n}\n\n.fpd-secondary-content .fpd-upload-zone-panel>.fpd-upload-zone-content>*>div {\n  height: 100%;\n  display: flex;\n  flex-flow: column\n}\n\n.fpd-secondary-content .fpd-upload-zone-panel>.fpd-bottom-nav>div {\n  padding: 11px;\n  font-size: 22px\n}\n\n.fpd-no-modules-mode.fpd-off-canvas .fpd-secondary-content {\n  bottom: 0\n}\n\n.fpd-container.fpd-main-bar-container fpd-main-bar {\n  min-height: 500px !important;\n  min-width: 300px;\n  width: 400px;\n  border: 1px solid var(--fpd-border-color);\n  margin: 20px 0\n}\n\n.fpd-main-bar-container-enabled fpd-main-wrapper {\n  flex-basis: 100% !important\n}\n\n.fpd-modal-mode-active .fpd-wrapper.fpd-layout-small fpd-main-bar {\n  padding-bottom: env(safe-area-inset-bottom)\n}\n\n.fpd-container fpd-actions-bar {\n  background: var(--fpd-actions-bar-bg-color);\n  height: var(--fpd-actions-bar-height);\n  flex: 1 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  color: var(--fpd-primary-fg-color);\n  align-items: center;\n  padding: 0 5px;\n  justify-content: space-between\n}\n\n.fpd-container fpd-actions-bar>div {\n  flex: 1;\n  font-size: 16px;\n  white-space: nowrap;\n  max-width: 33%;\n  height: 100%\n}\n\n.fpd-container fpd-actions-bar>div>.fpd-btn span {\n  margin-left: 5px\n}\n\n.fpd-container fpd-actions-bar>[data-pos=center] fpd-actions-menu>div {\n  left: 50%;\n  transform: translateX(-50%)\n}\n\n.fpd-container fpd-actions-bar>[data-pos=center] .fpd-btn span {\n  display: none\n}\n\n.fpd-container fpd-actions-bar>[data-pos=center] .fpd-switch {\n  display: none\n}\n\n.fpd-container fpd-actions-bar>[data-pos=right] fpd-actions-menu>div {\n  right: 0;\n  left: auto\n}\n\n.fpd-container fpd-actions-bar>[data-pos=right] fpd-actions-menu .fpd-dropdown-menu {\n  text-align: left;\n  right: 0;\n  left: auto\n}\n\n.fpd-container fpd-actions-bar>[data-pos=modal] {\n  display: none\n}\n\n.fpd-container fpd-actions-bar fpd-actions-menu {\n  display: flex;\n  justify-content: center;\n  max-width: 100%;\n  height: 100%;\n  position: relative\n}\n\n.fpd-container fpd-actions-bar fpd-actions-menu .fpd-collapsed-menu,\n.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  display: flex\n}\n\n.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu {\n  max-width: none;\n  white-space: nowrap;\n  align-items: center;\n  justify-content: center\n}\n\n.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu .fpd-btn span {\n  font-size: 14px;\n  margin-left: 10px\n}\n\n.fpd-container fpd-actions-bar fpd-actions-menu .fpd-uncollapsed-menu .fpd-btn .fpd-switch {\n  display: none\n}\n\n.fpd-container fpd-actions-bar fpd-actions-menu .fpd-collapsed-menu {\n  align-items: center\n}\n\n.fpd-container fpd-actions-bar .fpd-btn,\n.fpd-container fpd-actions-bar .fpd-dropdown-btn {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n  padding: 7px 12px;\n  margin: 0 0 0 5px;\n  border-radius: var(--fpd-border-radius);\n  line-height: 1;\n  text-transform: capitalize;\n  background: 0 0\n}\n\n.fpd-container fpd-actions-bar .fpd-btn:hover,\n.fpd-container fpd-actions-bar .fpd-dropdown-btn:hover {\n  opacity: 1;\n  background: rgba(255, 255, 255, .05)\n}\n\n.fpd-container fpd-actions-bar .fpd-btn>*,\n.fpd-container fpd-actions-bar .fpd-dropdown-btn>* {\n  pointer-events: none;\n  line-height: 1;\n  vertical-align: middle\n}\n\n.fpd-container fpd-actions-bar .fpd-btn.fpd-btn-fill,\n.fpd-container fpd-actions-bar .fpd-dropdown-btn.fpd-btn-fill {\n  background: rgba(255, 255, 255, .1)\n}\n\n.fpd-container fpd-actions-bar .fpd-btn.fpd-btn-fill>span,\n.fpd-container fpd-actions-bar .fpd-dropdown-btn.fpd-btn-fill>span {\n  display: inline-flex;\n}\n\n.fpd-container fpd-actions-bar .fpd-btn {\n  font-size: 18px\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: max-content;\n  z-index: 10000;\n  background: #fff;\n  border-radius: var(--fpd-border-radius);\n  transform: translateY(5px);\n  padding: 5px 0\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn {\n  display: flex;\n  color: var(--fpd-text-color);\n  min-width: 150px;\n  margin: 5px 10px;\n  font-size: 16px;\n  padding: 0;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn:hover {\n  background: rgba(0, 0, 0, .05)\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>* {\n  pointer-events: auto;\n  margin: 10px\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>i {\n  flex: 0;\n  margin-right: 0\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>span {\n  flex: 1\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu>.fpd-btn>.fpd-switch {\n  margin-left: 40px\n}\n\n.fpd-container fpd-actions-bar .fpd-dropdown-menu.fpd-show {\n  display: block\n}\n\n.fpd-off-canvas fpd-actions-bar,\n.fpd-topbar fpd-actions-bar {\n  order: 1;\n  display: flex\n}\n\n.fpd-off-canvas fpd-actions-bar {\n  order: 1 !important\n}\n\n.fpd-container .fpd-modal-download>span {\n  font-size: 60px;\n  cursor: pointer\n}\n\n.fpd-container .fpd-zoom-wrapper {\n  display: flex;\n  width: 150px;\n  background: #fff;\n  border-radius: var(--fpd-border-radius);\n  position: absolute;\n  left: 50%;\n  top: 10px;\n  transform: translate(-50%, 50%);\n  padding: 10px;\n  z-index: 10\n}\n\n.fpd-container .fpd-zoom-wrapper>.fpd-stage-pan {\n  margin-left: 10px;\n  font-size: 14px;\n  cursor: pointer\n}\n\n.fpd-container .fpd-zoom-wrapper>.fpd-stage-pan.fpd-active {\n  color: var(--fpd-secondary-color)\n}\n\n.fpd-container .fpd-zoom-wrapper>.fpd-close {\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: 0;\n  top: 4px;\n  transform: translateY(-100%);\n  background: #fff;\n  padding: 2px 10px;\n  z-index: 1;\n  border-radius: var(--fpd-border-radius) var(--fpd-border-radius) 0 0;\n  border: 1px solid var(--fpd-border-color);\n  border-bottom: none;\n  cursor: pointer;\n  font-size: 10px\n}\n\n.fpd-container .fpd-zoom-wrapper>.fpd-close:hover>* {\n  font-weight: 700\n}\n\n.fpd-modal-product-designer fpd-actions-bar {\n  justify-content: stretch\n}\n\n.fpd-modal-product-designer fpd-actions-bar [data-pos=right] {\n  margin-left: auto\n}\n\n.fpd-modal-product-designer fpd-actions-bar [data-pos=modal] {\n  flex: 0;\n  text-align: right;\n  display: flex !important;\n  padding: 5px;\n  align-items: center\n}\n\n.fpd-modal-product-designer fpd-actions-bar .fpd-total-price {\n  line-height: 20px;\n  font-size: 15px;\n  display: inline-block\n}\n\n.fpd-modal-product-designer .fpd-wrapper.fpd-layout-small [data-pos=right] .fpd-dropdown-menu {\n  transform: translate(50%, 5px)\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar {\n  gap: 2px\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar>div {\n  max-width: none\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar .fpd-dropdown-btn>span {\n  display: none\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=left],\n.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=right] {\n  max-width: 45px\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=modal]>.fpd-btn.fpd-done .fpd-label {\n  display: none\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=modal]>.fpd-btn.fpd-done i {\n  font-size: 14px\n}\n\n.fpd-wrapper.fpd-layout-small fpd-actions-bar [data-pos=modal]>.fpd-btn.fpd-close:last-child {\n  padding-left: 6px;\n  padding-right: 0;\n  font-size: 16px\n}\n\n.fpd-wrapper.fpd-off-canvas>fpd-main-wrapper,\n.fpd-wrapper.fpd-topbar>fpd-main-wrapper {\n  flex-basis: 100%\n}\n\n.fpd-wrapper.fpd-off-canvas>fpd-main-wrapper {\n  order: 2 !important\n}\n\n.fpd-wrapper>fpd-main-wrapper {\n  display: flex;\n  overflow: hidden;\n  flex: 1 0;\n  min-height: 400px;\n  background: var(--fpd-canvas-bg);\n  transition: opacity .3s ease-out;\n  order: 3;\n  position: relative\n}\n\n.fpd-wrapper>fpd-main-wrapper .fpd-product-stage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  direction: ltr;\n  max-height: 100%;\n  margin: auto;\n  width: 100%\n}\n\n.fpd-wrapper>fpd-main-wrapper .fpd-product-stage>.fpd-view-stage {\n  background: rgba(255, 255, 255, .7);\n  height: 100%\n}\n\n.fpd-wrapper>fpd-main-wrapper .fpd-product-stage>.fpd-view-stage textarea {\n  left: -10000px !important;\n  top: 50% !important\n}\n\n.fpd-wrapper>fpd-main-wrapper .fpd-product-stage>.fpd-zoom-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  max-width: 100%\n}\n\n.fpd-wrapper>fpd-main-wrapper.fpd-drag canvas {\n  cursor: grab !important\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-warnings {\n  position: absolute;\n  width: 90%;\n  left: 5%;\n  top: 20px;\n  font-size: 14px\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-warnings>.fpd-size-warning {\n  display: flex;\n  flex-direction: row;\n  padding: 12px;\n  background: var(--fpd-yellow-color);\n  color: var(--fpd-yellow-contrast-color);\n  border-radius: var(--fpd-border-radius);\n  border: 1px solid var(--fpd-yellow-contrast-color);\n  box-shadow: 0 0 6px rgba(0, 0, 0, .1);\n  justify-content: space-between;\n  gap: 10px\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-warnings>.fpd-size-warning .fpd-btn {\n  background-color: #3f3f3f;\n  margin: 0;\n  white-space: nowrap;\n  max-height: 35px\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background: #fff;\n  z-index: 100\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor .fpd-close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 16px;\n  z-index: 1000;\n  cursor: pointer;\n  opacity: .6\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor .fpd-close:hover {\n  opacity: 1\n}\n\n.fpd-wrapper>fpd-main-wrapper>.fpd-advanced-image-editor .fpd-done {\n  position: absolute;\n  background: var(--fpd-secondary-color);\n  color: var(--fpd-secondary-fg-color);\n  border-radius: var(--fpd-border-radius);\n  padding: 6px 12px;\n  right: 10px;\n  bottom: 10px;\n  font-size: 16px;\n  z-index: 1000;\n  cursor: pointer\n}\n\n.fpd-wrapper.fpd-layout-small .fpd-size-warning {\n  flex-direction: column !important\n}\n\n.fpd-wrapper.fpd-layout-small .fpd-size-warning .fpd-btn {\n  justify-content: center\n}\n\n.fpd-container fpd-views-nav {\n  position: absolute;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  gap: 4px 8px;\n  bottom: calc(10px + env(safe-area-inset-bottom));\n  right: 10px;\n  background: #fff;\n  box-shadow: 0 0 10px rgba(110, 111, 114, .22);\n  border-radius: var(--fpd-border-radius);\n  min-height: 35px;\n  flex-wrap: wrap;\n  justify-content: center;\n  max-width: 160px\n}\n\n.fpd-container fpd-views-nav>.fpd-view-locker {\n  font-size: 20px;\n  cursor: pointer;\n  margin-left: 5px\n}\n\n.fpd-container fpd-views-nav>.fpd-view-locker .fpd-icon-locked {\n  color: var(--fpd-secondary-color)\n}\n\n.fpd-container fpd-views-nav>.fpd-view-next,\n.fpd-container fpd-views-nav>.fpd-view-prev {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  font-size: 18px;\n  border-radius: 50%;\n  text-align: center;\n  cursor: pointer;\n  transform-origin: center center\n}\n\n.fpd-container fpd-views-nav>.fpd-view-next:hover,\n.fpd-container fpd-views-nav>.fpd-view-prev:hover {\n  color: var(--fpd-secondary-color)\n}\n\n.fpd-container fpd-views-nav>.fpd-view-prev {\n  rotate: -180deg\n}\n\n.fpd-container fpd-views-nav>.fpd-show-views-grid {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  line-height: 1\n}\n\n.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-icon-pages {\n  font-size: 18px;\n  margin-right: 4px\n}\n\n.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-current-view {\n  font-size: 16px;\n  margin-right: 2px;\n  padding-top: 2px\n}\n\n.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-total-views {\n  display: inline-block;\n  padding: 4px 0;\n  text-align: center;\n  color: var(--fpd-dark-grey-color);\n  font-size: 12px\n}\n\n.fpd-container fpd-views-nav>.fpd-show-views-grid>.fpd-total-views:before {\n  content: \"/\"\n}\n\n.fpd-container fpd-views-nav>.fpd-view-edit-size {\n  display: flex;\n  flex-direction: row;\n  flex: 1 1 100%;\n  width: 50px;\n  border-bottom: 1px solid var(--fpd-border-color)\n}\n\n.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input {\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  height: 100%\n}\n\n.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input:first-child {\n  border-top-left-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input>span {\n  background: var(--fpd-border-color);\n  padding: 6px 6px\n}\n\n.fpd-container fpd-views-nav>.fpd-view-edit-size .fpd-input>input {\n  padding: 0;\n  height: auto\n}\n\n.fpd-views-inside-left fpd-views-nav {\n  left: 10px;\n  right: auto\n}\n\n.fpd-container fpd-views-grid {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: var(--fpd-light-bg-color);\n  z-index: 1000;\n  flex-flow: column wrap\n}\n\n.fpd-container fpd-views-grid.fpd-show {\n  display: flex\n}\n\n.fpd-container fpd-views-grid>.fpd-head {\n  position: relative;\n  min-height: 40px\n}\n\n.fpd-container fpd-views-grid>.fpd-head>.fpd-btn {\n  display: none\n}\n\n.fpd-container fpd-views-grid .fpd-grid {\n  gap: 35px 20px;\n  display: flex;\n  flex-flow: row wrap;\n  padding: 10px\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item {\n  background: #fff;\n  flex: 1 0 45%;\n  max-width: 150px;\n  height: 150px;\n  border-radius: var(--fpd-border-radius);\n  overflow: hidden;\n  padding: 5px;\n  cursor: default\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>picture {\n  background-size: contain;\n  margin: 20px 0 5px;\n  pointer-events: all;\n  cursor: pointer\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>span {\n  white-space: nowrap;\n  display: block;\n  overflow: hidden;\n  font-size: 12px\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-sort {\n  position: absolute;\n  left: 5px;\n  top: 5px;\n  font-size: 18px;\n  cursor: move\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-sort>* {\n  pointer-events: none\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  padding: 0 6px 2px;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options:hover {\n  opacity: 1\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu {\n  position: absolute;\n  display: none;\n  flex-flow: column nowrap;\n  text-align: right;\n  top: 100%;\n  right: 0;\n  min-width: max-content;\n  z-index: 1000;\n  background: #fff;\n  color: var(--fpd-text-color);\n  border-radius: var(--fpd-border-radius);\n  transform: translateY(5px);\n  padding: 6px\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu>span {\n  padding: 4px;\n  font-size: 13px;\n  min-width: 90px;\n  border-radius: 4px\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu>span:hover {\n  background: var(--fpd-light-bg-color)\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-options>.fpd-dropdown-menu.fpd-show {\n  display: flex\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay {\n  background: rgba(255, 255, 255, .98);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: none;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  gap: 10px\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay>input {\n  width: 100%;\n  background: #fff !important;\n  margin: 0;\n  text-align: center;\n  padding: 7px\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay>.fpd-btn {\n  display: inline-flex;\n  width: min-content;\n  margin: 0;\n  padding: 3px 8px;\n  font-size: 12px;\n  line-height: 1\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item>.fpd-edit-size-overlay.fpd-show {\n  display: flex\n}\n\n.fpd-container fpd-views-grid .fpd-grid>.fpd-item:first-child .fpd-dropdown-menu [data-option=delete] {\n  display: none\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal,\n.fpd-container fpd-views-grid .fpd-layouts-modal {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  right: 10px;\n  bottom: 10px;\n  background: #fff;\n  margin: 10px;\n  display: flex;\n  flex-flow: column wrap;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal>.fpd-head,\n.fpd-container fpd-views-grid .fpd-layouts-modal>.fpd-head {\n  position: relative;\n  min-height: 40px;\n  display: flex\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-scroll-area,\n.fpd-container fpd-views-grid .fpd-layouts-modal .fpd-scroll-area {\n  margin-right: 5px\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid,\n.fpd-container fpd-views-grid .fpd-layouts-modal .fpd-grid {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid>.fpd-item,\n.fpd-container fpd-views-grid .fpd-layouts-modal .fpd-grid>.fpd-item {\n  flex: 0 0 200px;\n  height: 150px;\n  cursor: pointer\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head {\n  padding: 10px\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head .fpd-input {\n  width: max-content;\n  margin-right: 20px;\n  max-width: 150px\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head .fpd-input>input {\n  width: 100px\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-head .fpd-btn {\n  margin: 0\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid {\n  justify-content: flex-start;\n  align-items: center\n}\n\n.fpd-container fpd-views-grid .fpd-blank-page-modal .fpd-grid .fpd-item {\n  flex: 1 0 45%;\n  text-align: center\n}\n\n.fpd-container fpd-views-grid.fpd-modal-visible>.fpd-head,\n.fpd-container fpd-views-grid.fpd-modal-visible>.fpd-scroll-area {\n  filter: blur(5px)\n}\n\n.fpd-container fpd-views-grid .fpd-head {\n  border-bottom: 1px solid var(--fpd-border-color);\n  padding: 10px\n}\n\n.fpd-container fpd-views-grid .fpd-head .fpd-btn {\n  margin: 0 10px 5px 0\n}\n\n.fpd-container fpd-views-grid .fpd-close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 14px;\n  cursor: pointer\n}\n\n.fpd-container fpd-views-grid .fpd-scroll-area {\n  flex: 1;\n  position: relative\n}\n\n.fpd-sidebar fpd-views-grid {\n  left: var(--fpd-sidebar-nav-width);\n  top: var(--fpd-actions-bar-height);\n  width: calc(100% - var(--fpd-sidebar-nav-width));\n  height: calc(100% - var(--fpd-actions-bar-height))\n}\n\n.fpd-wrapper.fpd-layout-small .fpd-blank-page-modal .fpd-head {\n  flex-flow: row wrap;\n  gap: 10px;\n  padding-top: 40px\n}\n\n.fpd-wrapper.fpd-layout-small .fpd-blank-page-modal .fpd-head .fpd-input {\n  flex: 1 0 0;\n  margin: 0\n}\n\n.fpd-wrapper.fpd-layout-small .fpd-blank-page-modal .fpd-head .fpd-btn {\n  text-align: center;\n  width: 100%;\n  flex: 0 0 100%\n}\n\n.fpd-sidebar.fpd-layout-small fpd-views-grid {\n  width: 100%;\n  height: calc(100% - var(--fpd-sidebar-nav-width) - var(--fpd-actions-bar-height));\n  left: 0\n}\n\n.fpd-sidebar.fpd-layout-small fpd-views-grid .fpd-grid {\n  justify-content: space-between\n}\n\n.fpd-sidebar.fpd-layout-small fpd-views-grid .fpd-layouts-modal .fpd-grid {\n  gap: 20px\n}\n\n.fpd-sidebar.fpd-layout-small fpd-views-grid .fpd-layouts-modal .fpd-grid .fpd-item {\n  flex: 0 calc(50% - 10px)\n}\n\n.fpd-off-canvas fpd-views-grid,\n.fpd-topbar fpd-views-grid {\n  width: 100%;\n  height: 100%\n}\n\n.fpd-wrapper.fpd-dynamic-views-enabled fpd-views-grid>.fpd-head>.fpd-btn {\n  display: inline-block\n}\n\nfpd-element-toolbar {\n  display: none;\n  overflow: hidden;\n  z-index: 2;\n  color: var(--fpd-text-color)\n}\n\nfpd-element-toolbar.fpd-show {\n  display: flex !important\n}\n\nfpd-element-toolbar .fpd-close,\nfpd-element-toolbar .fpd-close-sub-panel {\n  display: none;\n  position: absolute;\n  right: 0;\n  top: 5px;\n  height: 30px;\n  min-width: 35px;\n  padding: 0 7px;\n  line-height: 30px;\n  text-align: center;\n  cursor: pointer;\n  background: #fff;\n  font-size: 14px;\n  transform: translateY(-100%);\n  box-shadow: 0 -1px 2px rgba(110, 111, 114, .2);\n  border-top-left-radius: var(--fpd-border-radius);\n  border-top-right-radius: var(--fpd-border-radius);\n  gap: 3px;\n  align-items: center\n}\n\nfpd-element-toolbar .fpd-close-sub-panel>.fpd-label {\n  font-size: 12px\n}\n\nfpd-element-toolbar>.fpd-tools-nav {\n  display: flex;\n  flex-direction: column\n}\n\nfpd-element-toolbar>.fpd-tools-nav>div {\n  display: flex\n}\n\nfpd-element-toolbar>.fpd-tools-nav>div>div {\n  flex: 1;\n  padding: 0 15px;\n  white-space: nowrap;\n  text-align: center;\n  cursor: pointer\n}\n\nfpd-element-toolbar>.fpd-tools-nav>div>div>span[class^=fpd-icon-] {\n  display: block;\n  font-size: 20px !important;\n  line-height: 28px\n}\n\nfpd-element-toolbar>.fpd-tools-nav>div>div>.fpd-label {\n  margin-top: 5px;\n  font-size: 11px;\n  display: inline-block;\n  line-height: 1;\n  vertical-align: bottom\n}\n\nfpd-element-toolbar>.fpd-tools-nav>div>div>.fpd-current-fill {\n  display: block;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, .1)\n}\n\nfpd-element-toolbar>.fpd-tools-nav>div>div.fpd-active {\n  color: var(--fpd-secondary-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel {\n  flex: 1;\n  overscroll-behavior: none\n}\n\nfpd-element-toolbar .fpd-sub-panel>div {\n  display: none;\n  height: 100%;\n  width: 100%\n}\n\nfpd-element-toolbar .fpd-sub-panel>div>* {\n  margin-bottom: 10px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div>:last-child {\n  margin: 0\n}\n\nfpd-element-toolbar .fpd-sub-panel>div.fpd-active {\n  display: flex;\n  flex-flow: column nowrap\n}\n\nfpd-element-toolbar .fpd-sub-panel>div.fpd-padding {\n  padding: 15px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-input {\n  flex-flow: row wrap;\n  box-shadow: none;\n  overflow: visible\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-input input,\nfpd-element-toolbar .fpd-sub-panel>div .fpd-input>span {\n  flex: 1;\n  border: none\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-input>span {\n  padding: 0\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-input fpd-range-slider {\n  order: 3\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs {\n  display: flex;\n  align-items: center\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs>span {\n  flex: 1;\n  text-align: center;\n  padding: 8px 0 6px 0;\n  cursor: pointer;\n  opacity: .7\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs>span.fpd-active {\n  color: var(--fpd-secondary-color);\n  position: relative;\n  opacity: 1\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs>span.fpd-active:after {\n  background-color: var(--fpd-secondary-color);\n  position: absolute;\n  content: \"\";\n  width: 60%;\n  height: 2px;\n  left: 20%;\n  bottom: 0\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs-content>div {\n  display: none;\n  padding: 10px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs-content>div.fpd-active {\n  display: block\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-panel-tabs-content>div>* {\n  margin-bottom: 20px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group,\nfpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 4px;\n  flex-flow: row wrap\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>*,\nfpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group>* {\n  flex: 1;\n  border: 1px solid var(--fpd-border-color);\n  border-radius: var(--fpd-border-radius);\n  font-size: 13px;\n  padding: 5px 0;\n  cursor: pointer;\n  line-height: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>:hover,\nfpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group>:hover {\n  background: var(--fpd-light-bg-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group [class^=fpd-icon-],\nfpd-element-toolbar .fpd-sub-panel>div .fpd-tools-group [class^=fpd-icon-] {\n  font-size: 18px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group {\n  border: 1px solid var(--fpd-border-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>* {\n  border: none;\n  border-radius: 0\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-btn-group>.fpd-active {\n  color: var(--fpd-secondary-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-toggle.fpd-enabled {\n  color: var(--fpd-secondary-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-tool-position-align>div {\n  flex: 1 0 32%\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-tool-uniscaling-locker {\n  font-size: 18px;\n  text-align: right\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-curved-options {\n  display: flex;\n  gap: 30px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-curved-options>span {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  aspect-ratio: 1/1;\n  cursor: pointer;\n  background: var(--fpd-light-bg-color);\n  border-radius: var(--fpd-border-radius);\n  padding: 5px\n}\n\nfpd-element-toolbar .fpd-sub-panel>div .fpd-curved-options>span.fpd-active svg * {\n  fill: var(--fpd-secondary-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-color>.fpd-scroll-area {\n  overflow: visible\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-color .fpd-colorpicker-wrapper {\n  padding: 0\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family {\n  flex-flow: column nowrap;\n  height: 100%\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list {\n  display: flex;\n  flex-flow: column nowrap;\n  height: 100%;\n  gap: 20px\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list>.fpd-item {\n  cursor: pointer;\n  font-size: 16px;\n  transition: all .2s ease-in-out\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list>.fpd-item.fpd-active {\n  color: var(--fpd-secondary-color)\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list>.fpd-item:hover {\n  padding-left: 5px\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-tool-filters {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start;\n  gap: 35px 10px;\n  padding-bottom: 40px;\n  overflow: auto;\n  height: auto\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-tool-filters>.fpd-item {\n  flex: 0 0 60px;\n  height: 60px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-tool-filters>.fpd-item:after {\n  content: attr(aria-label);\n  position: absolute;\n  top: 100%;\n  left: 0;\n  line-height: 14px;\n  font-size: 12px;\n  overflow: hidden;\n  transform: translateY(3px);\n  max-width: inherit\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-tool-crop-masks {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-evenly;\n  gap: 40px 20px !important\n}\n\nfpd-element-toolbar .fpd-sub-panel .fpd-tool-crop-masks .fpd-item {\n  flex: 0 0 25%;\n  height: 70px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain\n}\n\nfpd-element-toolbar.fpd-smart {\n  display: none;\n  background: #fff;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  max-width: var(--fpd-et-max-width);\n  min-width: 300px;\n  border-radius: var(--fpd-border-radius);\n  transform: translateX(-50%);\n  z-index: 10000000000;\n  box-shadow: 0 0 10px rgba(110, 111, 114, .22);\n  overflow: visible\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>div {\n  margin: 10px 0\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>div>div {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 0\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools {\n  justify-content: space-between;\n  padding-left: 5px\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools>div {\n  padding: 0 10px\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size {\n  flex: 0 70px\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size input {\n  margin: 0;\n  width: 100%;\n  pointer-events: none;\n  text-align: center\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family {\n  flex: 1 180px\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family fpd-dropdown {\n  width: 100%;\n  pointer-events: none\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family,\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size {\n  align-self: flex-end\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family>[class^=fpd-icon-],\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size>[class^=fpd-icon-] {\n  display: none\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family .fpd-label,\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size .fpd-label {\n  display: none\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family>fpd-dropdown,\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size>fpd-dropdown {\n  min-height: 42px\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-tools-nav>.fpd-secondary-tools {\n  padding-bottom: 10px\n}\n\nfpd-element-toolbar.fpd-smart[data-element-type=image] .fpd-tools-nav {\n  flex-direction: row\n}\n\nfpd-element-toolbar.fpd-smart[data-element-type=image] .fpd-tools-nav>div {\n  margin: 20px 0;\n  overflow: hidden;\n  flex: 1 0 auto;\n  max-width: none\n}\n\nfpd-element-toolbar.fpd-smart[data-element-type=image] .fpd-tools-nav>.fpd-secondary-tools {\n  padding-bottom: 0\n}\n\nfpd-element-toolbar.fpd-smart>.fpd-sub-panel {\n  display: none;\n  width: 100%\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible {\n  width: var(--fpd-et-max-width)\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible .fpd-close {\n  display: none !important\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-tools-nav {\n  display: none !important\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-sub-panel {\n  display: flex\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-sub-panel .fpd-panel-tabs-content.fpd-scroll-area {\n  overflow: auto;\n  max-height: 200px\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-sub-panel .fpd-panel-font-family .fpd-fonts-list {\n  max-height: 100px\n}\n\nfpd-element-toolbar.fpd-smart.fpd-panel-visible>.fpd-close-sub-panel {\n  display: flex\n}\n\nfpd-element-toolbar.fpd-smart.fpd-show>.fpd-close {\n  display: block\n}\n\nfpd-element-toolbar.fpd-smart .fpd-tool-crop-masks,\nfpd-element-toolbar.fpd-smart .fpd-tool-filters {\n  display: flex;\n  flex-wrap: nowrap;\n  padding-bottom: 30px;\n  overflow-x: auto;\n  overflow-y: hidden\n}\n\nfpd-element-toolbar.fpd-smart .fpd-tool-crop-masks {\n  gap: 0 20px !important;\n  justify-content: flex-start\n}\n\nfpd-element-toolbar.fpd-smart .fpd-tool-crop-masks .fpd-item {\n  height: 50px\n}\n\nfpd-element-toolbar.fpd-smart.fpd-layout-small {\n  position: fixed;\n  left: 0 !important;\n  bottom: 0 !important;\n  top: auto !important;\n  width: 100%;\n  transform: none;\n  border-radius: 0;\n  box-shadow: 0 -1px 8px rgba(110, 111, 114, .2);\n  padding-bottom: env(safe-area-inset-bottom);\n  max-width: none\n}\n\nfpd-element-toolbar.fpd-smart.fpd-layout-small .fpd-close,\nfpd-element-toolbar.fpd-smart.fpd-layout-small .fpd-close-sub-panel {\n  border-top-right-radius: 0\n}\n\nfpd-element-toolbar.fpd-sidebar .fpd-tool-filters {\n  row-gap: 35px !important\n}\n\nfpd-element-toolbar.fpd-sidebar .fpd-tools-nav {\n  flex-direction: column\n}\n\nfpd-element-toolbar.fpd-sidebar .fpd-tools-nav>div {\n  flex-direction: column;\n  gap: 25px 0;\n  height: auto;\n  overflow: visible\n}\n\nfpd-element-toolbar.fpd-sidebar .fpd-tools-nav>.fpd-primary-tools .fpd-tool-font-family fpd-dropdown,\nfpd-element-toolbar.fpd-sidebar .fpd-tools-nav>.fpd-primary-tools .fpd-tool-text-size input {\n  display: none !important\n}\n\nfpd-main-bar>fpd-element-toolbar {\n  background: var(--fpd-primary-fg-color);\n  position: absolute;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100%;\n  flex-flow: row nowrap\n}\n\nfpd-main-bar>fpd-element-toolbar>.fpd-tools-nav {\n  flex: 0 80px;\n  flex-flow: column;\n  align-items: center;\n  border-right: 1px solid var(--fpd-border-color)\n}\n\nfpd-main-bar>fpd-element-toolbar>.fpd-tools-nav>div {\n  flex: 0;\n  margin: 10px 0\n}\n\nfpd-main-bar>fpd-element-toolbar>.fpd-tools-nav>div .fpd-label {\n  white-space: normal\n}\n\nfpd-element-toolbar[data-fabric-type=engraved-text] .fpd-panel-color>.fpd-panel-tabs,\nfpd-element-toolbar[data-fabric-type=engraved-text] .fpd-patterns-wrapper,\nfpd-element-toolbar[data-fabric-type=engraved-text] .fpd-tool-curved-text,\nfpd-element-toolbar[data-fabric-type=engraved-text] .fpd-tool-fill-opacity,\nfpd-element-toolbar[data-fabric-type=engraved-text] .fpd-tool-text-format,\nfpd-element-toolbar[data-fabric-type=neon-text] .fpd-panel-color>.fpd-panel-tabs,\nfpd-element-toolbar[data-fabric-type=neon-text] .fpd-patterns-wrapper,\nfpd-element-toolbar[data-fabric-type=neon-text] .fpd-tool-curved-text,\nfpd-element-toolbar[data-fabric-type=neon-text] .fpd-tool-fill-opacity,\nfpd-element-toolbar[data-fabric-type=neon-text] .fpd-tool-text-format {\n  display: none !important\n}\n\n.fpd-toolbar-visible .fpd-toolbar-sidebar fpd-main-bar {\n  overflow: visible\n}\n\n.fpd-toolbar-visible .fpd-toolbar-sidebar fpd-main-bar>.fpd-close {\n  display: block;\n  right: 0;\n  left: auto;\n  top: 20px;\n  transform: translateX(100%);\n  font-size: 12px;\n  height: 30px;\n  line-height: 30px;\n  width: 30px;\n  padding: 0 5px\n}\n\nbody[data-fpd-industry-type=engraving]:not(.fpd-editor-mode) .fpd-tool-advanced-editing,\nbody[data-fpd-industry-type=engraving]:not(.fpd-editor-mode) .fpd-tool-fill-opacity,\nbody[data-fpd-industry-type=engraving]:not(.fpd-editor-mode) .fpd-tool-remove-bg {\n  display: none !important\n}\n\n.fpd-container fpd-module-products {\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-products .fpd-product-categories {\n  display: none\n}\n\n.fpd-container fpd-module-products.fpd-categories-enabled .fpd-product-categories {\n  display: flex\n}\n\n.fpd-container fpd-module-text .fpd-add-text {\n  padding: 10px\n}\n\n.fpd-container fpd-module-text .fpd-add-text input {\n  padding: 3px 5px;\n  width: 80px;\n  display: block\n}\n\n.fpd-container fpd-module-text .fpd-add-text .fpd-btn {\n  margin-top: 10px;\n  margin-bottom: 20px\n}\n\n.fpd-container fpd-module-text .fpd-text-templates .fpd-grid {\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-text .fpd-text-templates .fpd-grid .fpd-item {\n  background: var(--fpd-module-secondary-color);\n  text-align: center;\n  position: relative;\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-module-text .fpd-text-templates .fpd-grid .fpd-item>div {\n  font-size: 16px;\n  width: 80%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%)\n}\n\n.fpd-container fpd-module-text .fpd-text-templates .fpd-grid .fpd-item:hover {\n  opacity: .8\n}\n\n.fpd-container fpd-module-designs {\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-designs .fpd-head {\n  display: none\n}\n\n.fpd-container fpd-module-designs.fpd-head-visible .fpd-head,\n.fpd-container fpd-module-designs.fpd-single-cat .fpd-head {\n  display: block;\n  margin-bottom: 10px\n}\n\n.fpd-container fpd-module-designs.fpd-single-cat .fpd-back {\n  display: none !important\n}\n\n.fpd-container fpd-module-designs .fpd-single-cat .fpd-input-search {\n  width: 100%\n}\n\n.fpd-container fpd-module-designs .fpd-grid .fpd-item {\n  border-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-module-text-to-image .fpd-head .fpd-info {\n  margin: 0 0 10px;\n  line-height: 20px;\n  font-size: 14px\n}\n\n.fpd-container fpd-module-text-to-image .fpd-head .fpd-btn {\n  margin: 0 0 20px\n}\n\n.fpd-container fpd-module-images .fpd-module-tabs-content {\n  overflow: hidden;\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-images .fpd-module-tabs-content>div>* {\n  height: 100%;\n  display: flex;\n  flex-flow: column\n}\n\n.fpd-container fpd-module-images .fpd-module-tabs-content>div>* .fpd-scroll-area {\n  padding-right: 5px\n}\n\n.fpd-container fpd-module-uploads .fpd-upload-image {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  border: 2px dashed var(--fpd-border-color);\n  background: var(--fpd-module-secondary-color);\n  color: var(--fpd-module-secondary-text-color);\n  border-radius: var(--fpd-border-radius);\n  padding: 10px 10px 0;\n  cursor: pointer;\n  margin-bottom: 10px\n}\n\n.fpd-container fpd-module-uploads .fpd-upload-image>span {\n  display: block;\n  font-size: 10px;\n  text-transform: uppercase;\n  margin: 0 0 15px !important\n}\n\n.fpd-container fpd-module-uploads .fpd-upload-image>.fpd-price {\n  font-size: 12px;\n  line-height: 1\n}\n\n.fpd-container fpd-module-uploads .fpd-upload-image.fpd-hover {\n  opacity: .5\n}\n\n.fpd-container fpd-module-uploads .fpd-grid .fpd-loading-bar {\n  background: rgba(255, 255, 255, .7);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 60%;\n  height: 6px;\n  transform: translate(-50%, -50%);\n  z-index: 10\n}\n\n.fpd-container fpd-module-uploads .fpd-grid .fpd-loading-bar>.fpd-loading-progress {\n  background: #fff;\n  height: 100%;\n  width: 0\n}\n\n.fpd-container fpd-module-uploads .fpd-image-quality-ratings {\n  position: absolute;\n  left: 5px;\n  top: 5px;\n  line-height: 1\n}\n\n.fpd-container fpd-module-uploads .fpd-image-quality-ratings>span {\n  color: var(--fpd-image-quality-start-color);\n  text-shadow: 0 0 1px rgba(0, 0, 0, .7);\n  font-size: 18px\n}\n\n.fpd-container fpd-module-facebook-images .fpd-head {\n  margin-bottom: 10px\n}\n\n.fpd-container fpd-module-facebook-images .fpd-head .fpd-facebook-albums {\n  display: none\n}\n\n.fpd-container fpd-module-facebook-images.fpd-facebook-logged-in .fpd-facebook-login {\n  display: none\n}\n\n.fpd-container fpd-module-facebook-images.fpd-facebook-logged-in .fpd-facebook-albums {\n  display: block\n}\n\n.fpd-container fpd-module-pixabay-images {\n  position: relative\n}\n\n.fpd-container fpd-module-pixabay-images .fpd-head {\n  margin-bottom: 10px\n}\n\n.fpd-container fpd-module-pixabay-images .fpd-loader-wrapper {\n  height: 100%\n}\n\n.fpd-container fpd-module-pixabay-images .fpd-pixabay-logo {\n  background-repeat: no-repeat !important;\n  border: none !important;\n  background-color: transparent !important;\n  width: 72px;\n  height: 14px;\n  display: block;\n  margin-bottom: 10px;\n  opacity: .6;\n  background-image: url(data:image/png;base64,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) !important\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list {\n  padding: var(--fpd-module-content-padding);\n  position: relative;\n  min-height: 100%\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row {\n  flex-wrap: wrap;\n  margin: 10px 5px 10px 0;\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: var(--fpd-border-radius);\n  box-shadow: 0 0 10px rgba(110, 111, 114, .2)\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div {\n  overflow: hidden;\n  white-space: nowrap\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-0 {\n  flex: 0 45px;\n  text-align: center\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-0>.fpd-current-color {\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n  display: block;\n  border-radius: var(--fpd-border-radius);\n  margin: auto;\n  border: 1px solid rgba(0, 0, 0, .1)\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 {\n  padding-left: 0;\n  padding-right: 0\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 textarea {\n  border: 1px solid var(--fpd-border-color);\n  min-height: auto;\n  max-height: 30px;\n  width: 100%;\n  padding: 3px 5px !important;\n  box-shadow: none;\n  margin: 0\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 .fpd-img-meta {\n  font-size: 11px;\n  font-weight: 700\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-1 .fpd-img-meta span {\n  font-weight: 400;\n  margin-right: 5px\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2 {\n  flex: 0 110px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 10px\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span {\n  padding-left: 8px;\n  font-size: 18px;\n  opacity: .7;\n  transition: opacity .3s ease-out;\n  flex: 1;\n  flex-grow: 0\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span.fpd-icon-reorder {\n  cursor: move\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span:first-child {\n  padding: 0\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span:hover {\n  opacity: 1\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span>* {\n  vertical-align: top\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-2>span>.fpd-icon-eye {\n  font-size: 13.5px\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full {\n  padding: 0 0 10px;\n  display: none\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area.fpd-has-subpanel {\n  max-height: none\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-color-palette,\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-patterns-wrapper {\n  padding: 0 10px\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-color-palette>.fpd-colorpicker-wrapper,\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row>div.fpd-cell-full>.fpd-scroll-area>.fpd-patterns-wrapper>.fpd-colorpicker-wrapper {\n  padding: 0\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row:hover {\n  border-color: var(--fpd-border-color)\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-show-colors {\n  background: var(--fpd-list-bg-color-active)\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-show-colors .fpd-cell-full {\n  display: block\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-locked>div:nth-child(-n+2) {\n  opacity: .2;\n  pointer-events: none\n}\n\n.fpd-container fpd-module-manage-layers .fpd-list .fpd-list-row.fpd-hide-dpi .fpd-dpi {\n  display: none\n}\n\n.fpd-container fpd-module-qr-code .fpd-qr-code-colors {\n  text-align: center\n}\n\n.fpd-container fpd-module-qr-code .fpd-qr-code-colors>.fpd-qr-code-color-dark,\n.fpd-container fpd-module-qr-code .fpd-qr-code-colors>.fpd-qr-code-color-light {\n  display: inline-block;\n  padding: 12px;\n  position: relative;\n  border-radius: var(--fpd-border-radius);\n  border: 2px solid rgba(0, 0, 0, .2);\n  overflow: visible\n}\n\n.fpd-container fpd-module-save-load {\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-text-layers .fpd-list {\n  position: relative;\n  min-height: 100%;\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row {\n  flex-wrap: wrap;\n  margin: 0 0 10px;\n  border-radius: var(--fpd-border-radius);\n  box-shadow: 0 0 10px rgba(110, 111, 114, .2)\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>div {\n  margin: 10px 8px;\n  padding: 0;\n  position: relative\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-title {\n  color: var(--fpd-dark-grey-color);\n  padding-left: 2px;\n  margin-bottom: 0;\n  font-size: 14px\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-cell-1 fpd-dropdown {\n  height: 35px\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-cell-2 {\n  flex: 0 0 60px\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row>.fpd-cell-2>input {\n  text-align: center;\n  height: 35px\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row .fpd-color-panel {\n  margin-top: 10px\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row .fpd-color-panel .fpd-colorpicker-wrapper {\n  padding: 0\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row .fpd-clear-text {\n  position: absolute;\n  right: 1px;\n  top: 1px;\n  font-size: 11px;\n  line-height: 1;\n  padding: 3px 4px;\n  text-transform: uppercase;\n  background: var(--fpd-module-secondary-color);\n  border-bottom-left-radius: 2px;\n  cursor: pointer;\n  border-top-right-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row input,\n.fpd-container fpd-module-text-layers .fpd-list .fpd-list-row textarea {\n  margin: 0 !important;\n  padding: 8px;\n  width: 100%\n}\n\n.fpd-container fpd-module-layouts .fpd-grid {\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-layouts .fpd-grid>.fpd-item {\n  border-radius: var(--fpd-border-radius);\n  background-color: var(--fpd-module-secondary-color)\n}\n\n.fpd-container fpd-module-names-numbers {\n  padding: var(--fpd-module-content-padding)\n}\n\n.fpd-container fpd-module-names-numbers .fpd-head .fpd-btn {\n  margin: 0 0 20px\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list {\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 10px;\n  padding-right: 10px\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-end\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-number-col {\n  width: 50px\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-number-col input {\n  text-align: center\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-name-col {\n  flex: 1\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-select-col {\n  width: 50px;\n  position: relative\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-select-col select {\n  position: relative;\n  appearance: none;\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  background: var(--fpd-light-bg-color);\n  cursor: pointer;\n  padding-right: 10px\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-select-col:after {\n  content: \"\\e90e\";\n  font-family: FontFPD !important;\n  font-size: 16px;\n  position: absolute;\n  top: 50%;\n  right: 2px;\n  pointer-events: none;\n  transform: translateY(-50%)\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-remove-col {\n  flex: 1 100%;\n  text-align: right;\n  font-size: 10px;\n  line-height: 1;\n  color: var(--fpd-red-color);\n  order: 3\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-remove-col>span {\n  opacity: .7;\n  text-transform: uppercase;\n  cursor: pointer\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-remove-col>span:hover {\n  opacity: 1\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-input-col:nth-child(2)>* {\n  border-top-left-radius: var(--fpd-border-radius);\n  border-bottom-left-radius: var(--fpd-border-radius);\n  border-left: 1px solid var(--fpd-border-color)\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row>.fpd-input-col:last-child>* {\n  border-top-right-radius: var(--fpd-border-radius);\n  border-bottom-right-radius: var(--fpd-border-radius)\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row input,\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row select {\n  border-radius: 0;\n  box-shadow: none;\n  margin: 0;\n  border: 1px solid var(--fpd-border-color);\n  width: 100%;\n  border-left: none\n}\n\n.fpd-container fpd-module-names-numbers .fpd-list>.fpd-row:first-child>.fpd-remove-col {\n  visibility: hidden\n}\n\n.fpd-bulk-variations {\n  margin: 20px 0\n}\n\n.fpd-bulk-variations>.fpd-head {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px\n}\n\n.fpd-bulk-variations>.fpd-head>.fpd-headline {\n  font-size: 18px\n}\n\n.fpd-bulk-variations .fpd-variations-list {\n  display: flex;\n  flex-flow: column wrap;\n  gap: 20px\n}\n\n.fpd-bulk-variations .fpd-variations-list .fpd-row {\n  display: flex;\n  flex-flow: row nowrap;\n  gap: 10px;\n  height: 40px;\n  align-items: center\n}\n\n.fpd-bulk-variations .fpd-variations-list .fpd-row>select {\n  flex: 1;\n  font-size: 16px;\n  padding: 0 5px;\n  height: 100%\n}\n\n.fpd-bulk-variations .fpd-variations-list .fpd-row>select.fpd-error {\n  border-color: var(--fpd-red-color)\n}\n\n.fpd-bulk-variations .fpd-variations-list .fpd-row>input {\n  width: 50px;\n  height: 100%;\n  margin: 0;\n  text-align: center\n}\n\n.fpd-bulk-variations .fpd-variations-list .fpd-row>span {\n  display: inline-block;\n  width: 30px;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center\n}\n\n.fpd-bulk-variations .fpd-variations-list .fpd-row:first-child span {\n  display: none\n}\n\n.fpd-color-selection {\n  margin: 20px 0;\n  display: flex;\n  flex-flow: column wrap;\n  gap: 20px\n}\n\n.fpd-color-selection .fpd-cs-item .fpd-title {\n  font-size: 16px;\n  margin-bottom: 10px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid var(--fpd-border-color)\n}\n\n.fpd-color-selection .fpd-cs-item .fpd-color-palette,\n.fpd-color-selection .fpd-cs-item .fpd-patterns-wrapper {\n  margin: 10px 0\n}\n\n.fpd-color-selection .fpd-cs-item .fpd-color-palette .fpd-item,\n.fpd-color-selection .fpd-cs-item .fpd-patterns-wrapper .fpd-item {\n  width: 45px;\n  height: 45px;\n  position: relative;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .2)\n}\n\n.fpd-color-selection .fpd-cs-item .fpd-color-panel>.fpd-scroll-area>.fpd-color-palette .fpd-item:after {\n  position: absolute;\n  color: rgba(0, 0, 0, .6);\n  background: rgba(255, 255, 255, .95);\n  bottom: -2px;\n  line-height: 1;\n  width: calc(100% + 4px);\n  left: -2px;\n  text-transform: uppercase;\n  font-size: 10px;\n  content: attr(aria-label);\n  padding: 4px 0;\n  text-align: center\n}\n\n.fpd-container.fpd-gt-step {\n  width: 320px;\n  padding: 15px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  color: #fff;\n  z-index: 100;\n  margin-top: 15px;\n  margin-left: -24px;\n  z-index: 100000000000;\n  background: var(--fpd-tooltip-bg-color)\n}\n\n.fpd-container.fpd-gt-step>.fpd-gt-pointer {\n  font-size: 50px;\n  position: absolute;\n  top: -16px;\n  left: 0;\n  color: var(--fpd-tooltip-bg-color);\n  transform: scaleY(-1)\n}\n\n.fpd-container.fpd-gt-step .fpd-gt-close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 14px;\n  cursor: pointer;\n  z-index: 10\n}\n\n.fpd-container.fpd-gt-step .fpd-gt-text {\n  padding-right: 15px\n}\n\n.fpd-container.fpd-gt-step .fpd-gt-actions {\n  margin-top: 20px\n}\n\n.fpd-container.fpd-gt-step .fpd-gt-actions>.fpd-btn {\n  margin: 0;\n  float: right;\n  margin-left: 5px;\n  font-size: 12px;\n  padding: 3px 10px\n}\n\n.fpd-container.fpd-gt-step .fpd-gt-actions>.fpd-gt-counter {\n  line-height: 34px;\n  font-size: 12px;\n  opacity: .5\n}\n\n.fpd-3d-preview-wrapper {\n  background: #fff;\n  color: rgba(0, 0, 0, .5);\n  box-shadow: rgba(0, 0, 0, .15) 0 5px 15px 0;\n  position: relative\n}\n\n.fpd-3d-preview-wrapper:after {\n  content: \"3D\";\n  position: absolute;\n  left: 5px;\n  top: 5px\n}\n\n.fpd-3d-preview-wrapper .fpd-loading {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%)\n}\n\n.fpd-3d-preview-wrapper>canvas {\n  outline: 0;\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%)\n}\n\n.fpd-3d-preview-wrapper .fpd-touch-info {\n  z-index: 100;\n  position: absolute;\n  left: 5px;\n  bottom: 5px;\n  width: 64px;\n  height: 64px;\n  background-size: 40%;\n  background-position: left bottom;\n  background-repeat: no-repeat;\n  background-image: url(data:image/png;base64,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)\n}\n\nfpd-main-wrapper .fpd-3d-preview-wrapper {\n  display: block;\n  box-shadow: rgba(0, 0, 0, .15) 0 5px 15px 0;\n  background: #fff;\n  color: rgba(0, 0, 0, .5);\n  z-index: 100;\n  position: absolute;\n  bottom: 0;\n  left: 0\n}\n\nfpd-main-wrapper .fpd-3d-preview-wrapper.fpd-fullscreen>.fpd-fullscreen-toggle {\n  padding: 4px\n}\n\nfpd-main-wrapper .fpd-3d-preview-wrapper.fpd-fullscreen>.fpd-fullscreen-toggle>span:first-child {\n  display: none\n}\n\nfpd-main-wrapper .fpd-3d-preview-wrapper.fpd-fullscreen>.fpd-fullscreen-toggle>span:last-child {\n  display: inline\n}\n\nfpd-main-wrapper .fpd-3d-preview-wrapper>.fpd-fullscreen-toggle {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  cursor: pointer;\n  font-size: 18px;\n  z-index: 10\n}\n\nfpd-main-wrapper .fpd-3d-preview-wrapper>.fpd-fullscreen-toggle>span:last-child {\n  display: none\n}\n\n.fpd-view-thumbnails-wrapper {\n  display: flex;\n  gap: 15px;\n  margin: 20px 0;\n  flex-wrap: wrap\n}\n\n.fpd-view-thumbnails-wrapper>.fpd-item {\n  width: 100px;\n  height: 100px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 70%;\n  border-radius: 8px;\n  cursor: pointer;\n  background-color: rgba(255, 255, 252, .9)\n}\n\nfpd-main-wrapper>.fpd-view-thumbnails-wrapper {\n  position: absolute;\n  left: 10px;\n  bottom: calc(10px + env(safe-area-inset-bottom));\n  margin: 0;\n  z-index: 21\n}\n\nfpd-main-wrapper>.fpd-view-thumbnails-wrapper .fpd-item {\n  height: 70px;\n  flex-basis: 60px\n}\n\n.fpd-wrapper.fpd-views-inside-left fpd-main-wrapper>.fpd-view-thumbnails-wrapper {\n  right: 10px;\n  left: auto;\n  justify-content: flex-end\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
